/* Install section HTML cache (always; separate asset may not be deployed yet) */
(function (global) {
  if (global.fetchSectionHtml && global.fetchSectionHtml._sepPdpCached) return

  var TTL_MS = 30 * 60 * 1000
  var PREFIX = 'sepPdpSec:v1:'
  var MAX_429_RETRIES = 3
  var memory = new Map()
  var inflight = new Map()

  function normalizeUrl(url) {
    try {
      var u = new URL(url, location.origin)
      var params = new URLSearchParams(u.search)
      var keys = []
      params.forEach(function (_v, k) {
        keys.push(k)
      })
      keys.sort()
      var sorted = new URLSearchParams()
      keys.forEach(function (k) {
        params.getAll(k).forEach(function (v) {
          sorted.append(k, v)
        })
      })
      var qs = sorted.toString()
      return u.pathname + (qs ? '?' + qs : '')
    } catch (e) {
      return String(url)
    }
  }

  function storageKey(key) {
    return PREFIX + key
  }

  function read(key) {
    var now = Date.now()
    var mem = memory.get(key)
    if (mem) {
      if (now - mem.ts < TTL_MS && typeof mem.text === 'string' && mem.text.length) {
        return mem.text
      }
      memory.delete(key)
    }
    try {
      var raw = localStorage.getItem(storageKey(key))
      if (!raw) return null
      var parsed = JSON.parse(raw)
      if (
        !parsed ||
        typeof parsed.text !== 'string' ||
        !parsed.text.length ||
        now - parsed.ts >= TTL_MS
      ) {
        localStorage.removeItem(storageKey(key))
        return null
      }
      memory.set(key, parsed)
      return parsed.text
    } catch (e) {
      return null
    }
  }

  function pruneStorage() {
    var entries = []
    for (var i = 0; i < localStorage.length; i++) {
      var k = localStorage.key(i)
      if (!k || k.indexOf(PREFIX) !== 0) continue
      var ts = 0
      try {
        ts = JSON.parse(localStorage.getItem(k) || '{}').ts || 0
      } catch (e) {}
      entries.push({ k: k, ts: ts })
    }
    entries.sort(function (a, b) {
      return a.ts - b.ts
    })
    var removeCount = Math.max(1, Math.ceil(entries.length / 2))
    for (var j = 0; j < removeCount; j++) {
      try {
        localStorage.removeItem(entries[j].k)
      } catch (e) {}
    }
  }

  function write(key, text) {
    if (typeof text !== 'string' || !text.length) return
    var entry = { ts: Date.now(), text: text }
    memory.set(key, entry)
    try {
      localStorage.setItem(storageKey(key), JSON.stringify(entry))
    } catch (e) {
      try {
        pruneStorage()
        localStorage.setItem(storageKey(key), JSON.stringify(entry))
      } catch (e2) {}
    }
  }

  function clearKey(key) {
    memory.delete(key)
    try {
      localStorage.removeItem(storageKey(key))
    } catch (e) {}
  }

  function fetchSectionHtml(url, init, retryCount) {
    retryCount = retryCount || 0
    var key = normalizeUrl(url)
    var cached = read(key)
    if (cached != null) return Promise.resolve(cached)

    if (inflight.has(key)) return inflight.get(key)

    var promise = fetch(url, init)
      .then(function (res) {
        if (!res.ok) {
          var err = new Error('section fetch failed ' + res.status)
          err.status = res.status
          throw err
        }
        return res.text()
      })
      .then(function (text) {
        // Never cache empty/error bodies
        if (typeof text === 'string' && text.length) write(key, text)
        else clearKey(key)
        inflight.delete(key)
        return text
      })
      .catch(function (err) {
        // Never store failed responses (or the key)
        clearKey(key)
        inflight.delete(key)

        if (err && err.status === 429 && retryCount < MAX_429_RETRIES) {
          var delay = 1500 * Math.pow(2, retryCount)
          var retryPromise = new Promise(function (resolve, reject) {
            setTimeout(function () {
              // Drop this placeholder so the retry can claim inflight cleanly
              if (inflight.get(key) === retryPromise) inflight.delete(key)
              fetchSectionHtml(url, init, retryCount + 1).then(resolve, reject)
            }, delay)
          })
          // Coalesce clicks during backoff onto the same delayed retry
          inflight.set(key, retryPromise)
          return retryPromise
        }
        throw err
      })

    inflight.set(key, promise)
    return promise
  }

  fetchSectionHtml.clear = function (url) {
    if (!url) return
    var key = normalizeUrl(url)
    clearKey(key)
    inflight.delete(key)
  }

  fetchSectionHtml._sepPdpCached = true
  global.fetchSectionHtml = fetchSectionHtml
})(window);

if (typeof window.SEP_DESIGN_ZOOM_ENABLED === 'undefined') {
    window.SEP_DESIGN_ZOOM_ENABLED = false
  }
  document.body.classList.toggle('sep-zoom-enabled', window.SEP_DESIGN_ZOOM_ENABLED === true)

  function initSepDesignGalleryEnhancements() {
    const sectionRoot = document.querySelector(window.SEP_DESIGN_OPH.sectionRoot)
    if (!sectionRoot || sectionRoot.dataset.galleryEnhancementsReady === 'true') return
    sectionRoot.dataset.galleryEnhancementsReady = 'true'

    const zoomState = { panel: null, lens: null }
    const zoomFactor = 2.5
    const zoomTypes = new Set(['sunglasses', 'prescription', 'ophthalmic'])

    function hideSepDesignZoom() {
      if (zoomState.panel) zoomState.panel.style.display = 'none'
      if (zoomState.lens) zoomState.lens.style.display = 'none'
    }

    function getSepDesignZoomWrapper(event) {
      const wrapper = event.target.closest('.mainslider-wrapper > .swiper .image-wrapper')
      if (!wrapper) return null
      const slide = wrapper.closest('.swiper-slide')
      if (!slide || slide.classList.contains('hidden')) return null
      const swiperEl = wrapper.closest('.swiper')
      const productType = (swiperEl && swiperEl.getAttribute('data-product-type')) || ''
      if (!zoomTypes.has(productType)) return null
      const mainSlider = wrapper.closest('.product__sep-design__mainSlider')
      if (!mainSlider || mainSlider.classList.contains('hidden')) return null
      if (mainSlider.offsetParent === null && getComputedStyle(mainSlider).display === 'none') return null
      return wrapper
    }

    function handleSepDesignZoom(event) {
      if (window.SEP_DESIGN_ZOOM_ENABLED !== true) return hideSepDesignZoom()
      if (!window.matchMedia('(hover: hover) and (pointer: fine)').matches) return hideSepDesignZoom()
      const wrapper = getSepDesignZoomWrapper(event)
      if (!wrapper) return hideSepDesignZoom()
      const img = wrapper.querySelector('img')
      const src = img && (img.currentSrc || img.src)
      if (!src) return hideSepDesignZoom()

      if (!zoomState.panel) {
        zoomState.panel = document.createElement('div')
        zoomState.panel.className = 'sep-zoom-panel'
        document.body.appendChild(zoomState.panel)
      }
      let lens = wrapper.querySelector(':scope > .sep-zoom-lens')
      if (!lens) {
        lens = document.createElement('div')
        lens.className = 'sep-zoom-lens'
        wrapper.appendChild(lens)
      }
      zoomState.lens = lens

      const rect = wrapper.getBoundingClientRect()
      const localX = Math.min(Math.max(event.clientX - rect.left, 0), rect.width)
      const localY = Math.min(Math.max(event.clientY - rect.top, 0), rect.height)
      const fx = rect.width ? localX / rect.width : 0
      const fy = rect.height ? localY / rect.height : 0

      const panel = zoomState.panel
      const panelWidth = rect.width
      const panelHeight = Math.min(Math.max(rect.height * 1.5, 640), window.innerHeight - 32)
      panel.style.width = panelWidth + 'px'
      panel.style.height = panelHeight + 'px'
      panel.style.backgroundImage = `url("${src}")`
      panel.style.backgroundSize = `${zoomFactor * 100}%`
      panel.style.backgroundPosition = `${fx * 100}% ${fy * 100}%`
      panel.style.display = 'block'

      panel.style.left = rect.right + 16 + 'px'
      panel.style.right = 'auto'
      panel.style.top = Math.max(16, (window.innerHeight - panelHeight) / 2) + 'px'

      const lensW = Math.min(rect.width, panelWidth / zoomFactor)
      const lensH = Math.min(rect.height, panelHeight / zoomFactor)
      lens.style.width = lensW + 'px'
      lens.style.height = lensH + 'px'
      lens.style.left = Math.min(Math.max(localX - lensW / 2, 0), rect.width - lensW) + 'px'
      lens.style.top = Math.min(Math.max(localY - lensH / 2, 0), rect.height - lensH) + 'px'
      lens.style.display = 'block'
    }

    sectionRoot.addEventListener('pointermove', handleSepDesignZoom)
    sectionRoot.addEventListener('pointerleave', hideSepDesignZoom)
    window.addEventListener('scroll', hideSepDesignZoom, { passive: true })
  }

  initSepDesignGalleryEnhancements()

  function updateRxToggleUI(isRx, product) {
    const rxToggle = document.querySelector('.product__information_block.rx-toggle')
    if (!rxToggle) return
    const textEl = rxToggle.querySelector('.rx-toggle-text')
    const subEl = rxToggle.querySelector('.rx-toggle-sub')
    const iconEl = rxToggle.querySelector('.rx-toggle-action .rx-toggle-ic')
    if (isRx) {
      rxToggle.classList.add('rx')
      rxToggle.classList.remove('sunglasses')
      if (textEl) textEl.textContent = 'Click for sunglasses option'
      if (subEl) subEl.textContent = 'Switch back to non-Rx lenses'
      if (iconEl) iconEl.textContent = '🕶'
    } else {
      rxToggle.classList.add('sunglasses')
      rxToggle.classList.remove('rx')
      if (textEl) textEl.textContent = 'Click to add prescription'
      if (subEl) subEl.textContent = ''
      if (iconEl) iconEl.textContent = '👓'
    }
    syncRxToggleIncludedFeatures(product || window.pdp.currentProduct)
  }

  function syncRxToggleIncludedFeatures(product) {
    const rxToggle = document.querySelector('.product__information_block.rx-toggle')
    if (!rxToggle) return
    const lensbox = rxToggle.querySelector('.rx-toggle-lensbox')
    if (!lensbox) return

    let includedRow = lensbox.querySelector('.rx-toggle-lensrow--included')
    const tags = normalizeProductTags(product?.tags)
    const parts = []
    if (tags.includes('_style_feature:polarized')) parts.push('Polarized')
    if (tags.some((tag) => String(tag).toLowerCase() === '_lens_rating:uv400')) parts.push('UV400')

    if (!parts.length) {
      if (includedRow) includedRow.remove()
      return
    }

    const label = parts.join(' · ')
    if (!includedRow) {
      includedRow = document.createElement('div')
      includedRow.className = 'rx-toggle-lensrow rx-toggle-lensrow--included'
      includedRow.innerHTML =
        '<span class="rx-toggle-ic" aria-hidden="true">' +
        '🕶' +
        '</span>' +
        '<span class="rx-toggle-tx"><b></b><span>Included on every pair</span></span>' +
        '<span class="rx-toggle-chk">Included ✓</span>'
      const actionRow = lensbox.querySelector('.rx-toggle-lensrow--action, .rx-toggle-action')
      if (actionRow) lensbox.insertBefore(includedRow, actionRow)
      else lensbox.prepend(includedRow)
    }
    const titleEl = includedRow.querySelector('.rx-toggle-tx b')
    if (titleEl) titleEl.textContent = label
  }

  function syncVisibleAtcBlocks(productId) {
    const id = productId != null
      ? String(productId)
      : String(window.pdp.currentProduct?.id || '')
    if (!id) return
    document.querySelectorAll('.product__information > .product__information_block.atc').forEach((atc) => {
      if (atc.classList.contains('rx-config-modal__atc')) return
      atc.classList.toggle('hidden', String(atc.getAttribute('product_id')) !== id)
    })
  }

  // Keep server-rendered block order; do not reorder on RX <-> sunglasses toggle.
  function syncPdpBlockOrderForProductType(_productType) {}

  function placeRxToggleForProductType(_productType) {}

  function hasJudgemeHtmlCache(handle) {
    return !!(handle && window.pdp.judgemeHtmls && Object.prototype.hasOwnProperty.call(window.pdp.judgemeHtmls, handle))
  }

  function getJudgemeBadgeRoot() {
    return (
      document.querySelector('.product__information > .pdp-lead .product__information_block.judgeme-badge') ||
      document.querySelector('.product__information .product__information_block.judgeme-badge')
    )
  }

  function applyJudgemeBadgeForHandle(handle) {
    if (!hasJudgemeHtmlCache(handle)) return false
    const badgeRoot = getJudgemeBadgeRoot()
    if (!badgeRoot) return false

    const html = window.pdp.judgemeHtmls[handle] || ''
    const div = new DOMParser().parseFromString(html, 'text/html')
    const wrap = div.querySelector('.jdgm-prev-badge')
    const widget = div.querySelector('.jdgm-widget.jdgm-preview-badge')
    const container = badgeRoot.querySelector('.reviews-badge-container') || badgeRoot
    const existingWidget = container.querySelector('.jdgm-widget.jdgm-preview-badge')
    const existingWrap = container.querySelector('.jdgm-prev-badge')

    // No reviews / empty badge HTML for this product
    if (!wrap || !wrap.querySelector('.jdgm-prev-badge__stars')) {
      badgeRoot.classList.add('hidden')
      if (typeof window.syncGalleryPdpLead === 'function') window.syncGalleryPdpLead()
      return true
    }

    badgeRoot.classList.remove('hidden')
    // Replace whole widget/badge so data-id + data-number-of-reviews stay in sync
    // (partial star swap left stale attrs; formatSepDesignReviewBadge then overwrote count)
    if (widget && existingWidget) {
      existingWidget.outerHTML = widget.outerHTML
    } else if (existingWrap) {
      existingWrap.outerHTML = wrap.outerHTML
    } else if (widget) {
      container.insertAdjacentHTML('afterbegin', widget.outerHTML)
    } else {
      container.insertAdjacentHTML('afterbegin', wrap.outerHTML)
    }

    const liveWrap = container.querySelector('.jdgm-prev-badge')
    const textElement = liveWrap?.querySelector('.jdgm-prev-badge__text')
    if (liveWrap && textElement) {
      const reviewCount = liveWrap.getAttribute('data-number-of-reviews') || '0'
      textElement.textContent = `(${Number(reviewCount).toLocaleString('en-US')})`
    }
    if (typeof window.formatSepDesignReviewBadge === 'function') {
      window.formatSepDesignReviewBadge()
    }
    if (typeof window.syncGalleryPdpLead === 'function') window.syncGalleryPdpLead()
    return true
  }

  function ensureJudgemeHtmlForHandle(handle) {
    if (!handle) return Promise.resolve()
    if (!window.pdp.judgemeHtmls) window.pdp.judgemeHtmls = {}
    if (hasJudgemeHtmlCache(handle)) return Promise.resolve()
    if (!window.pdp._judgemeEnsurePromises) window.pdp._judgemeEnsurePromises = {}
    if (window.pdp._judgemeEnsurePromises[handle]) return window.pdp._judgemeEnsurePromises[handle]

    const promise = fetchSectionHtml(`/products/${handle}?section_id=sep-pdp-judgeme`)
      .then((data) => {
        const div = new DOMParser().parseFromString(data, 'text/html')
        const p = div.querySelector('#shopify-section-sep-pdp-judgeme judgeme, judgeme, #shopify-section-sep-pdp-judgeme')
        window.pdp.judgemeHtmls[handle] = p ? p.innerHTML : ''
      })
      .catch(() => {})
      .finally(() => {
        delete window.pdp._judgemeEnsurePromises[handle]
      })

    window.pdp._judgemeEnsurePromises[handle] = promise
    return promise
  }

  function formatSepDesignOfferMoney(amount) {
    const moneyFormat = document.body.getAttribute('data-money-format') || (typeof Shopify !== 'undefined' && Shopify.money_format) || (window.SEP_DESIGN_OPH.moneyFormat || '')
    const cents = Math.round(parseFloat(amount) * 100)
    if (isNaN(cents)) return ''
    let formatted
    if (typeof Shopify !== 'undefined' && typeof Shopify.formatMoneyOrigin === 'function') {
      formatted = Shopify.formatMoneyOrigin(String(cents), moneyFormat)
    } else {
      formatted = '$' + (cents / 100).toFixed(2)
    }
    return String(formatted).replace(/\.00(?!\d)/, '')
  }
  window.formatSepDesignOfferMoney = formatSepDesignOfferMoney

  function isOphB1g2fType(ophType) {
    return ophType === 'blue-light' || ophType === 'plain'
  }

  function setSepDesignB1g2fContent(productType, price) {
    const b1g2fWrapper = document.querySelector('.product__information_block.b1g2f')
    if (!b1g2fWrapper) return

    if (productType === 'Sunglasses' || productType === 'Blue Light' || productType === 'b1g2f') {
      const amount = price != null ? price : window.pdp.selectedVariant?.price || window.pdp.currentProduct?.variants?.[0]?.price
      const badgePrice = formatSepDesignOfferMoney(amount)
      b1g2fWrapper.classList.add('pdp-offer')
      b1g2fWrapper.classList.remove('pdp-offer--rx')
      b1g2fWrapper.innerHTML =
        '<span class="pdp-offer__gift" aria-hidden="true">🕶</span>' +
        '<div class="pdp-offer__text">' +
          '<b>Buy 1, get any 2 free<sup>™</sup></b>' +
          '<span>Add All 3 Pairs to Your Cart. Rx & Mystery Pairs Excluded.</span>' +
        '</div>' +
        '<span class="pdp-offer__badge">3 for ' + badgePrice + '</span>'
      return
    }

    if (productType === 'Prescription' || productType === 'Ophthalmic' || productType === 'rx') {
      b1g2fWrapper.classList.add('pdp-offer', 'pdp-offer--rx')
      b1g2fWrapper.innerHTML =
        '<span class="pdp-offer__gift" aria-hidden="true">🕶</span>' +
        '<div class="pdp-offer__text">' +
          '<b>30% OFF ANY SINGLE PAIR</b>' +
          '<span>Auto-applied at checkout.</span>' +
        '</div>' +
        '<span class="pdp-offer__badge">SAVE 30%</span>'
      return
    }

    b1g2fWrapper.classList.remove('pdp-offer', 'pdp-offer--rx')
    b1g2fWrapper.innerHTML =
      '<div><strong><em>' +
      (window.SEP_DESIGN_OPH?.b1g2fRandomCopy || window.SEP_DESIGN_PDP?.b1g2fRandomCopy || '') +
      '</em>&trade;</strong> | JUST ADD ALL 3 PAIRS TO CART</div><div>or 30% OFF ANY SINGLE PAIR</div>'
  }
  window.setSepDesignB1g2fContent = setSepDesignB1g2fContent

  function syncOphOfferBannerFromType(ophType, price) {
    if (isOphB1g2fType(ophType)) {
      setSepDesignB1g2fContent('b1g2f', price)
    } else {
      setSepDesignB1g2fContent('rx')
    }
  }

  function buildAtcInlinePriceHtml(variant, opts = {}) {
    const priceRaw = variant?.price ?? window.pdp.currentProduct?.variants?.[0]?.price
    const price = parseFloat(priceRaw)
    if (isNaN(price)) return ''
    const pt = window.pdp.currentProduct?.product_type
    const useOffer =
      opts.applyRxDiscount ||
      pt === 'Sunglasses' ||
      pt === 'Prescription' ||
      (typeof window.isOphthalmicPdpProduct === 'function' && window.isOphthalmicPdpProduct(window.pdp.currentProduct))
    let html = ''
    if (useOffer) {
      const disc = formatSepDesignOfferMoney(price * 0.7)
      const full = formatSepDesignOfferMoney(price)
      if (disc) html += '<span class="price-block price">' + disc + '</span>'
      if (full) html += '<span class="price-block compare-at-price">' + full + '</span>'
    } else {
      const main = formatSepDesignOfferMoney(price)
      if (main) html += '<span class="price-block price">' + main + '</span>'
      const compareAt = variant?.compare_at_price != null ? parseFloat(variant.compare_at_price) : NaN
      if (!isNaN(compareAt) && compareAt > price) {
        const cmp = formatSepDesignOfferMoney(compareAt)
        if (cmp) html += '<span class="price-block compare-at-price">' + cmp + '</span>'
      }
    }
    return html
  }

  function getAddToCartButtonText(variant, opts = {}) {
    let base = 'ADD TO CART'
    if (window.pdp.editMode) {
      base = 'UPDATE YOUR PAIR'
    } else if (
      opts.hidePrice &&
      (window.pdp.currentProduct?.product_type === 'Prescription' ||
        window.pdp.currentProduct?.product_type === 'Ophthalmic' ||
        (typeof window.isOphthalmicPdpProduct === 'function' &&
          window.isOphthalmicPdpProduct(window.pdp.currentProduct)))
    ) {
      // Landed path OOS but another path in stock → pick a different lens type
      base =
        typeof isOphLandingPathOos === 'function' &&
        isOphLandingPathOos() &&
        !isOphSplitFullySoldOut()
          ? 'CHOOSE OTHER LENSES'
          : 'CHOOSE YOUR LENSES'
    }
    if (opts.hidePrice) return base
    const priceHtml = buildAtcInlinePriceHtml(variant, opts)
    if (!priceHtml) return base
    return (
      '<span class="atc-button__label">' + base + '</span>' +
      '<span class="atc-button__prices">' + priceHtml + '</span>'
    )
  }

  function usesRxConfigModal() {
    const t = window.pdp.currentProduct?.product_type
    return t === 'Prescription' || t === 'Ophthalmic'
  }

  function isOphSimpleAtcType() {
    const t = window.pdp?.rx?.['oph-type']
    if (t === 'blue-light' || t === 'plain') return true
    const role = window.pdp?.ophSplitRole
    return (role === 'bl' || role === 'pl') && !window.pdp?.rx?.['oph-type']
  }

  /** Ophthalmic first variant drives Prescription / Readers / Plain OOS (synced). */
  function isOphMainFirstVariantAvailable() {
    const main =
      window.pdp.ophMainProduct ||
      (window.pdp.ophSplitArchitecture ? window.pdp.currentProduct : null)
    if (!main?.variants?.length) return true
    return main.variants[0].available !== false
  }

  /** Blue Light (-bl) has its own inventory. */
  function isOphBlFirstVariantAvailable() {
    const bl = window.pdp.ophSplitBlProduct
    if (!bl?.variants?.length) return false
    return bl.variants[0].available !== false
  }

  function isOphTypePathAvailable(type) {
    if (type === 'blue-light') return isOphBlFirstVariantAvailable()
    if (type === 'prescription' || type === 'readers' || type === 'plain') {
      return isOphMainFirstVariantAvailable()
    }
    return true
  }

  /** Sold out only when ophthalmic (pl-synced) AND blue light are both unavailable. */
  function isOphSplitFullySoldOut() {
    if (!window.pdp.ophSplitArchitecture) return false
    if (!window.isOphthalmicPdpProduct(window.pdp.currentProduct)) return false
    const mainOk = isOphMainFirstVariantAvailable()
    const hasBl = !!(window.pdp.ophSplitBlProduct?.variants?.length)
    if (!hasBl) return !mainOk
    return !mainOk && !isOphBlFirstVariantAvailable()
  }

  /** Type tied to the URL the shopper first landed on (main / -bl / -pl). */
  function getOphLandingType() {
    const role = window.pdp?.ophSplitRole
    if (role === 'bl') return 'blue-light'
    if (role === 'pl') return 'plain'
    return 'prescription'
  }

  /** Landed product/path is OOS (BL own stock; main+PL share ophthalmic stock). */
  function isOphLandingPathOos() {
    if (!window.pdp?.ophSplitArchitecture) return false
    if (!window.isOphthalmicPdpProduct?.(window.pdp.currentProduct)) return false
    return !isOphTypePathAvailable(getOphLandingType())
  }

  function getOphLandingNotifyTarget() {
    return getOphTypeOosNotifyTarget(getOphLandingType())
  }

  /** Focus landing OOS type + show notify form inside RX modal. */
  function showOphLandingOosInModal() {
    if (!isOphLandingPathOos()) return false
    const type = getOphLandingType()
    const opt = document.querySelector(
      '#oph-type-panel .dropdown-option[data-value="' + type + '"]'
    )
    if (opt && typeof onOphTypeUnavailableClick === 'function') {
      onOphTypeUnavailableClick(opt)
      return true
    }
    return false
  }

  window.getOphLandingType = getOphLandingType
  window.isOphLandingPathOos = isOphLandingPathOos
  window.getOphLandingNotifyTarget = getOphLandingNotifyTarget
  window.showOphLandingOosInModal = showOphLandingOosInModal

  function syncOphTypeAvailabilityUi() {
    if (!window.pdp.ophSplitArchitecture) return
    if (!window.isOphthalmicPdpProduct(window.pdp.currentProduct)) return
    const panel = document.querySelector('#oph-type-panel')
    if (!panel) return
    panel.querySelectorAll('.dropdown-option[data-value]').forEach((opt) => {
      const type = opt.getAttribute('data-value')
      const available = isOphTypePathAvailable(type)
      opt.classList.toggle('is-unavailable', !available)
      opt.removeAttribute('aria-disabled')
      let badge = opt.querySelector('.oph-type-oos-badge')
      if (!available) {
        if (!badge) {
          badge = document.createElement('span')
          badge.className = 'oph-type-oos-badge'
          badge.textContent = 'Sold out'
          opt.appendChild(badge)
        }
      } else if (badge) {
        badge.remove()
      }
      if (!available && opt.classList.contains('selected')) {
        opt.classList.remove('selected')
        if (window.pdp.rx?.['oph-type'] === type) {
          window.pdp.rx['oph-type'] = ''
        }
      }
    })
  }
  window.syncOphTypeAvailabilityUi = syncOphTypeAvailabilityUi

  function getOphTypeOosNotifyTarget(type) {
    if (type === 'blue-light') {
      const bl = window.pdp.ophSplitBlProduct
      const variant = bl?.variants?.[0]
      return {
        productId: bl?.id || null,
        variantId: variant?.id || null,
        label: 'Blue Light'
      }
    }
    const main =
      window.pdp.ophMainProduct ||
      (window.pdp.ophSplitArchitecture ? window.pdp.currentProduct : null)
    const variant = main?.variants?.[0]
    const labels = {
      prescription: 'Prescription',
      readers: 'Readers',
      plain: 'Plain'
    }
    return {
      productId: main?.id || null,
      variantId: variant?.id || null,
      label: labels[type] || 'This option'
    }
  }

  function hideOphTypeOosForm() {
    const box = document.getElementById('rx-config-oph-oos')
    if (box) {
      box.hidden = true
      box.dataset.oosType = ''
      box.dataset.productId = ''
      box.dataset.variantId = ''
    }
    document.querySelectorAll('#oph-type-panel .dropdown-option.is-oos-focus').forEach((el) => {
      el.classList.remove('is-oos-focus')
    })
    const response = document.getElementById('rx-config-oph-oos-response')
    if (response) response.innerHTML = ''
  }
  window.hideOphTypeOosForm = hideOphTypeOosForm

  function onOphTypeUnavailableClick(option) {
    if (!option) return
    const type = option.getAttribute('data-value')
    const target = getOphTypeOosNotifyTarget(type)
    const box = document.getElementById('rx-config-oph-oos')
    if (!box) return

    document.querySelectorAll('#oph-type-panel .dropdown-option').forEach((el) => {
      el.classList.remove('selected')
      el.classList.toggle('is-oos-focus', el === option)
    })
    if (window.pdp?.rx) window.pdp.rx['oph-type'] = ''

    const labelEl = document.getElementById('rx-config-oph-oos-label')
    if (labelEl) {
      labelEl.textContent = (target.label || 'This option') + ' is sold out.'
    }
    box.dataset.oosType = type || ''
    box.dataset.productId = target.productId != null ? String(target.productId) : ''
    box.dataset.variantId = target.variantId != null ? String(target.variantId) : ''
    box.hidden = false

    const response = document.getElementById('rx-config-oph-oos-response')
    if (response) response.innerHTML = ''

    if (typeof window.RxConfigModalSteps?.syncContinueEnabledState === 'function') {
      window.RxConfigModalSteps.syncContinueEnabledState()
    }
  }
  window.onOphTypeUnavailableClick = onOphTypeUnavailableClick

  function bindOphTypeOosFormOnce() {
    const form = document.getElementById('rx-config-BIS_form')
    if (!form || form.dataset.bound === '1') return
    form.dataset.bound = '1'

    form.querySelectorAll('[name=rx_oos_method]').forEach((input) => {
      input.addEventListener('change', () => {
        form.querySelectorAll('[name=rx_oos_method]').forEach((el) => {
          el.parentElement?.classList.remove('active')
        })
        const checked = form.querySelector('[name=rx_oos_method]:checked')
        checked?.parentElement?.classList.add('active')
        const tab = checked?.getAttribute('data-tab')
        const phone = document.getElementById('rx-oos-phone-number')
        const email = document.getElementById('rx-oos-email-address')
        if (tab === 'phone-number') {
          if (phone) phone.style.display = ''
          if (email) email.style.display = 'none'
        } else {
          if (email) email.style.display = ''
          if (phone) phone.style.display = 'none'
        }
      })
    })

    form.addEventListener('submit', (e) => {
      e.preventDefault()
      const box = document.getElementById('rx-config-oph-oos')
      const response = document.getElementById('rx-config-oph-oos-response')
      const productId = Number(box?.dataset.productId || 0)
      const variantId = Number(box?.dataset.variantId || 0)
      if (!productId || !variantId) {
        if (response) {
          response.innerHTML = '<p style="background-color: #ffaaaa">Unable to notify for this option.</p>'
        }
        return
      }
      if (typeof BIS === 'undefined') {
        if (response) {
          response.innerHTML = '<p style="background-color: #ffaaaa">Notify service unavailable.</p>'
        }
        return
      }
      const method = form.querySelector('[name=rx_oos_method]:checked')?.getAttribute('data-tab')
      const showOk = (resp) => {
        if (response) {
          response.innerHTML =
            '<p style="background-color: #aaffaa">' + (resp.message || 'You will be notified.') + '</p>'
        }
      }
      const showErr = (resp) => {
        let message = ''
        if (resp?.errors) {
          Object.keys(resp.errors).forEach((k) => {
            message += '<p style="background-color: #ffaaaa">' + resp.errors[k] + '</p>'
          })
        } else {
          message = '<p style="background-color: #ffaaaa">Something went wrong.</p>'
        }
        if (response) response.innerHTML = message
      }

      if (method === 'phone-number') {
        const phoneInput = document.querySelector('#rx-oos-phone-number input')
        const phone =
          typeof window.toUSE164 === 'function'
            ? window.toUSE164(phoneInput?.value || '')
            : (phoneInput?.value || '')
        if (!phone) {
          showErr({ errors: { 0: 'Invalid phone number.' } })
          return
        }
        BIS.create(null, variantId, productId, { phone_number: phone }).then((resp) => {
          if (resp.status === 'OK') showOk(resp)
          else showErr(resp)
        })
      } else {
        const emailInput = document.querySelector('#rx-oos-email-address input')
        const email = emailInput?.value || ''
        if (!email) {
          showErr({ errors: { 0: 'Please enter your email address.' } })
          return
        }
        const optIn = !!document.getElementById('rx-oos-customer_accepts_marketing')?.checked
        BIS.create(email, variantId, productId, { accepts_marketing: optIn }).then((resp) => {
          if (resp.status === 'OK') showOk(resp)
          else showErr(resp)
        })
      }
    })
  }

  function ensureOphSimpleSelectedVariant() {
    if (!window.pdp?.ophSplitArchitecture || !isOphSimpleAtcType()) return
    const t = window.pdp.rx?.['oph-type']
    const role = window.pdp.ophSplitRole
    const wantBl = t === 'blue-light' || (!t && role === 'bl')
    const wantPl = t === 'plain' || (!t && role === 'pl')
    let product = null
    if (wantBl) product = window.pdp.ophSplitBlProduct
    else if (wantPl) product = window.pdp.ophSplitPlProduct
    if (!product?.variants?.length) return
    const currentId = window.pdp.selectedVariant?.id
    if (currentId && product.variants.some((v) => v.id === currentId)) return
    const variant =
      product.variants.find((v) => v.available !== false) || product.variants[0]
    if (variant) setState['selectedVariant'](variant)
  }

  function applyOphTypeFromUrl(options) {
    const force = options && options.force
    if (window.pdp.editMode) return false
    if (!force && window.pdp.rx?.['oph-type']) return false
    let raw = null
    try {
      raw = new URL(window.location.href).searchParams.get('oph-type')
    } catch (e) {
      return false
    }
    if (!raw) return false
    let type = String(raw)
      .toLowerCase()
      .trim()
      .replace(/\s+/g, '-')
    if (type === 'bluelight') type = 'blue-light'
    const tryClick = () => {
      const opt = document.querySelector('#oph-type-panel .dropdown-option[data-value="' + type + '"]')
      if (opt) {
        opt.click()
        return true
      }
      return false
    }
    if (tryClick()) return true
    requestAnimationFrame(() => tryClick())
    return false
  }

  function getMainAtcButton() {
    let productId = window.pdp.currentProduct?.id
    if (
      window.isOphthalmicPdpProduct(window.pdp.currentProduct) &&
      window.pdp.ophSplitArchitecture &&
      typeof window.getOphSplitActiveProductId === 'function'
    ) {
      productId = window.getOphSplitActiveProductId() || productId
    }
    if (!productId) return document.querySelector('.product__information .product__information_block.atc:not(.rx-config-modal__atc) .atc-button')
    return document.querySelector(`.product__information .product__information_block.atc[product_id="${productId}"] .atc-button`)
  }

  function getMainAtcBlock() {
    let productId = window.pdp.currentProduct?.id
    if (
      window.isOphthalmicPdpProduct(window.pdp.currentProduct) &&
      window.pdp.ophSplitArchitecture &&
      typeof window.getOphSplitActiveProductId === 'function'
    ) {
      productId = window.getOphSplitActiveProductId() || productId
    }
    if (productId) {
      const byId = document.querySelector(`.product__information .product__information_block.atc:not(.hidden)[product_id="${productId}"]`)
      if (byId) return byId
    }
    return document.querySelector('.product__information .product__information_block.atc:not(.hidden):not(.rx-config-modal__atc)')
  }

  function getRxConfigStickyAtcButton() {
    return document.querySelector('#rx-config-modal .rx-config-modal__atc .atc-button')
  }

  function syncRxConfigModalProductId() {
    const stickyAtc = document.querySelector('#rx-config-modal .rx-config-modal__atc')
    if (!stickyAtc) return
    let productId = window.pdp.currentProduct?.id
    if (
      window.isOphthalmicPdpProduct(window.pdp.currentProduct) &&
      window.pdp.ophSplitArchitecture &&
      typeof window.getOphSplitActiveProductId === 'function'
    ) {
      productId = window.getOphSplitActiveProductId() || productId
    }
    if (productId) stickyAtc.setAttribute('product_id', String(productId))
  }

  function mountRxConfigModal() {
    const modal = document.getElementById('rx-config-modal')
    const slot = document.getElementById('rx-config-modal-options')
    const source = document.querySelector('[data-rx-config-source]') || document.querySelector('.product__information_block.rx-information')
    if (!modal || !slot) return
    if (source && source.parentElement !== slot) {
      source.classList.add('rxc-options')
      slot.appendChild(source)
      source.classList.remove('hidden')
    }
    if (modal.dataset.bound === '1') return
    modal.dataset.bound = '1'
    modal.querySelectorAll('[data-rx-config-close]').forEach((el) => {
      el.addEventListener('click', (e) => {
        e.preventDefault()
        e.stopPropagation()
        closeRxConfigModal()
      })
    })
    document.addEventListener('keydown', (e) => {
      if (e.key === 'Escape' && !modal.hidden) closeRxConfigModal()
    })
    syncRxConfigModalProductId()
  }
  window.mountRxConfigModal = mountRxConfigModal

  function syncRxConfigModalGallery() {
    if (typeof window.updateRxConfigModalPreview === 'function') {
      window.updateRxConfigModalPreview()
    } else if (window.RxConfigModalSteps && typeof window.RxConfigModalSteps.updatePreviewMeta === 'function') {
      window.RxConfigModalSteps.updatePreviewMeta()
    }
  }

  function keepRxConfigOptionPanelsOpen() {
    const modal = document.getElementById('rx-config-modal')
    const root = modal || document
    root.querySelectorAll(
      '.dropdown.lens-style .dropdown-panel, .dropdown.lens-color .dropdown-panel, .dropdown.lens-type .dropdown-panel, .dropdown.oph-type .dropdown-panel, .dropdown.lens-upgrade .dropdown-panel'
    ).forEach((panel) => {
      panel.classList.remove('disabled')
    })
  }
  window.keepRxConfigOptionPanelsOpen = keepRxConfigOptionPanelsOpen

  function openRxConfigModal() {
    mountRxConfigModal()
    const modal = document.getElementById('rx-config-modal')
    if (!modal) return
    syncRxConfigModalProductId()
    keepRxConfigOptionPanelsOpen()
    syncOphTypeAvailabilityUi()
    bindOphTypeOosFormOnce()
    hideOphTypeOosForm()
    modal.hidden = false
    document.documentElement.style.overflow = 'hidden'
    requestAnimationFrame(() => {
      modal.classList.add('is-open')
      keepRxConfigOptionPanelsOpen()
      syncOphTypeAvailabilityUi()
      if (typeof changeSliderImages === 'function') changeSliderImages()
      if (typeof window.syncRxLensColorProductImages === 'function') {
        window.syncRxLensColorProductImages()
      }
      updateATCText()
      if (window.RxConfigModalSteps && typeof window.RxConfigModalSteps.onOpen === 'function') {
        window.RxConfigModalSteps.onOpen()
      }
      if (typeof window.syncPdpMobileStickyAtc === 'function') window.syncPdpMobileStickyAtc()
    })
    const closeBtn = modal.querySelector('.rx-config-modal__close')
    if (closeBtn) closeBtn.focus()
  }
  window.openRxConfigModal = openRxConfigModal

  function closeRxConfigModal() {
    const modal = document.getElementById('rx-config-modal')
    if (!modal || modal.hidden) return
    modal.classList.remove('is-open')
    document.documentElement.style.overflow = ''
    let closed = false
    const finish = () => {
      if (closed) return
      closed = true
      modal.hidden = true
      modal.removeEventListener('transitionend', onEnd)
      // Re-apply lens color to gallery thumbs + frame swatches after modal unmounts
      if (typeof changeSliderImages === 'function') changeSliderImages()
      if (typeof window.syncPdpMobileStickyAtc === 'function') window.syncPdpMobileStickyAtc()
    }
    const onEnd = (e) => {
      if (e.target !== modal.querySelector('.rx-config-modal__shell')) return
      finish()
    }
    modal.addEventListener('transitionend', onEnd)
    setTimeout(finish, 400)
  }
  window.closeRxConfigModal = closeRxConfigModal

  // Size family: std / xl / xxl. Always check -xxl before -xl (substring trap).
  function getSizeKeyFromHandle(handle) {
    if (!handle) return 'std'
    if (handle.includes('-xxl')) return 'xxl'
    if (handle.includes('-xl')) return 'xl'
    return 'std'
  }

  function getSizeBaseHandle(handle) {
    if (!handle) return ''
    return handle
      .replace('-xxl-rx', '-rx')
      .replace('-xl-rx', '-rx')
      .replace('-xxl', '')
      .replace('-xl', '')
  }

  function getSizeHandleForKey(baseHandle, sizeKey) {
    if (!baseHandle) return ''
    const isRx = baseHandle.includes('-rx')
    if (sizeKey === 'std') return baseHandle
    if (sizeKey === 'xl') return isRx ? baseHandle.replace('-rx', '-xl-rx') : baseHandle + '-xl'
    if (sizeKey === 'xxl') return isRx ? baseHandle.replace('-rx', '-xxl-rx') : baseHandle + '-xxl'
    return baseHandle
  }

  function getSizeFamilyHandles(handle) {
    const base = getSizeBaseHandle(handle)
    return {
      base,
      current: getSizeKeyFromHandle(handle),
      std: getSizeHandleForKey(base, 'std'),
      xl: getSizeHandleForKey(base, 'xl'),
      xxl: getSizeHandleForKey(base, 'xxl')
    }
  }

  function getSizeCounterpartHandle(handle) {
    const family = getSizeFamilyHandles(handle)
    if (family.current === 'std') return family.xl
    return family.std
  }

  function normalizeProductTags(tags) {
    if (Array.isArray(tags)) return tags
    if (typeof tags === 'string') {
      return tags.split(',').map(tag => tag.trim()).filter(Boolean)
    }
    return []
  }

  function updateSepPerkFeatures(product) {
    const sepPerks = document.querySelector('.product__information_block.sep-perks')
    if (!sepPerks || !product) return

    const isSunglasses = product.product_type === 'Sunglasses'
    const isPrescription = product.product_type === 'Prescription'
    const isOphthalmic =
      typeof window.isOphthalmicPdpProduct === 'function'
        ? window.isOphthalmicPdpProduct(product)
        : product.product_type === 'Ophthalmic'
    const showShip3 = isPrescription || isOphthalmic
    sepPerks.querySelector('[data-perk="sunglasses"]')?.classList.toggle('hidden', !isSunglasses)
    sepPerks.querySelector('[data-perk="prescription"]')?.classList.toggle('hidden', !showShip3)
    sepPerks.querySelector('[data-perk="default"]')?.classList.toggle('hidden', isSunglasses || showShip3)
  }

  function getPdpSizeSelectorElement() {
    const visibleContainer = document.querySelector('.other-products-container:not(.hidden)')
    return visibleContainer?.querySelector('[data-size-selector]') ||
      document.querySelector('[data-size-selector]')
  }

  function getFrameTagValues(tags) {
    const values = { width: '', size: '' }
    normalizeProductTags(tags).forEach(tag => {
      const value = String(tag)
      if (value.includes('_frame_width:')) {
        values.width = value.replace('_frame_width:', '').replace('number:', '')
      } else if (value.includes('_frame_size:')) {
        values.size = value.replace('_frame_size:', '').replace(/_/g, ' ')
      }
    })
    return values
  }

  function frameTagsFromProductOrDataset(product, sizeSelector, sizeKey) {
    if (product?.handle) return getFrameTagValues(product.tags)
    const width =
      sizeKey === 'xxl'
        ? sizeSelector.dataset.xxlWidth || ''
        : sizeKey === 'xl'
          ? sizeSelector.dataset.xlWidth || ''
          : sizeSelector.dataset.stdWidth || ''
    const size = sizeKey === 'std' ? sizeSelector.dataset.stdSize || '' : ''
    return { width, size }
  }

  function fitTagValue(tags, key, rxKey) {
    let value = ''
    normalizeProductTags(tags).forEach((raw) => {
      const tag = String(raw)
      if (rxKey && tag.indexOf(rxKey) === 0) value = tag.slice(rxKey.length)
      else if (tag.indexOf(key) === 0) value = tag.slice(key.length)
    })
    return value.replace(/^number:/, '').trim()
  }

  function getFitDimsFromTags(tags) {
    return {
      frame: fitTagValue(tags, '_frame_width:', '_rx_frame_width:'),
      lensW: fitTagValue(tags, '_lens_width:', '_rx_lens_width:'),
      lensH: fitTagValue(tags, '_lens_height:', '_rx_lens_height:'),
      bridge: fitTagValue(tags, '_bridge_width:', '_rx_bridge_width:'),
      temple: fitTagValue(tags, '_temple_length:', '_rx_temple_length:')
    }
  }

  function formatFitMm(value) {
    const s = String(value || '').trim()
    if (!s) return '—'
    return /mm$/i.test(s) ? s : s + 'mm'
  }

  function formatFitLens(w, h) {
    const a = String(w || '').trim()
    const b = String(h || '').trim()
    if (!a && !b) return '—'
    return a + ' × ' + b
  }

  function isZ87FitProduct(product) {
    if (!product) return false
    if (product.product_type === 'Safety') return true
    return /-z87(?:-|$)/.test(product.handle || '')
  }

  function rememberFitFamily(byKey, fromFetch) {
    if (!window.pdp.fitFamily) window.pdp.fitFamily = { std: null, xl: null, xxl: null }
    ;['std', 'xl', 'xxl'].forEach((key) => {
      if (byKey && byKey[key] && byKey[key].handle) window.pdp.fitFamily[key] = byKey[key]
    })
    if (fromFetch) {
      window.pdp.fitFamilyPainted = true
      paintPdpFitModal()
    }
  }

  function paintPdpFitModal() {
    const modal = document.getElementById('pdp-fit-modal')
    const tb = modal && modal.querySelector('[data-fit-rows]')
    if (!tb) return
    const product = window.pdp.currentProduct
    if (!product || !product.handle) return
    const family = getSizeFamilyHandles(product.handle)
    const fam = window.pdp.fitFamily || {}
    const pick = (key, handle) => {
      if (!handle) return null
      if (product.handle === handle) return product
      if (fam[key] && fam[key].handle === handle) return fam[key]
      return null
    }
    const stdP = pick('std', family.std)
    const xlP = pick('xl', family.xl)
    const xxlP = pick('xxl', family.xxl)
    const z87 = isZ87FitProduct(product)
    const rows = [
      { key: 'std', label: 'Standard', product: stdP, off: false },
      { key: 'xl', label: 'XL', product: xlP, off: false }
    ]
    if (xxlP && xxlP.handle && !z87) {
      rows.push({ key: 'xxl', label: 'XXL', product: xxlP, off: false })
    } else if (z87) {
      rows.push({ key: 'xxl', label: 'XXL', product: null, off: true, frame: '157' })
    }
    tb.innerHTML = rows
      .map((row) => {
        const dims = getFitDimsFromTags(row.product && row.product.tags)
        const frame = row.off ? formatFitMm(row.frame || '157') : formatFitMm(dims.frame)
        const lens = row.off ? '—' : formatFitLens(dims.lensW, dims.lensH)
        const bridge = row.off ? '—' : formatFitMm(dims.bridge)
        return (
          '<tr' +
          (row.off ? ' class="is-off"' : '') +
          ' data-fit-row="' +
          row.key +
          '"><td>' +
          row.label +
          '</td><td data-fit-cell="frame">' +
          frame +
          '</td><td data-fit-cell="lens">' +
          lens +
          '</td><td data-fit-cell="bridge">' +
          bridge +
          '</td></tr>'
        )
      })
      .join('')
    const note = modal.querySelector('[data-fit-note]')
    if (note) {
      const temple =
        getFitDimsFromTags(stdP && stdP.tags).temple ||
        getFitDimsFromTags(xlP && xlP.tags).temple ||
        '135'
      const templeMm = formatFitMm(temple)
      if (z87) {
        note.textContent =
          'Temple length is ' +
          templeMm +
          ' on both. XXL runs 157mm but there is no Z87+ XXL yet — the regular line has it.'
      } else {
        note.textContent = 'Temple length is ' + templeMm + ' on both.'
      }
    }
  }

  function roundWidthMm(width) {
    if (width == null || width === '') return ''
    const n = Number.parseFloat(String(width).replace(/[^\d.-]/g, ''))
    if (!Number.isFinite(n)) return ''
    return String(Math.round(n))
  }

  function sizeSelectorHelpText(sizeKey, width) {
    const mm = roundWidthMm(width)
    const prefix = sizeKey === 'xl' ? 'For wider faces' : sizeKey === 'xxl' ? 'Our widest frame yet' : 'Our everyday fit'
    if (mm) return `${prefix} — ${mm}mm.`
    return `${prefix}.`
  }

  function buildPdpSizeSelectorCopy(stdWidth, stdSize, xlWidth, xxlWidth) {
    const stdMm = roundWidthMm(stdWidth)
    const xlMm = roundWidthMm(xlWidth)
    const xxlMm = roundWidthMm(xxlWidth)
    return {
      stdTitle: 'Standard',
      stdLabel: stdMm ? `Standard · ${stdMm}mm` : 'Standard',
      stdDesc: stdMm ? `${stdMm}mm` : '',
      stdHelp: sizeSelectorHelpText('std', stdWidth),
      xlTitle: 'XL',
      xlLabel: xlMm ? `XL · ${xlMm}mm` : 'XL',
      xlDesc: xlMm ? `${xlMm}mm` : '',
      xlHelp: sizeSelectorHelpText('xl', xlWidth),
      xxlTitle: 'XXL',
      xxlLabel: xxlMm ? `XXL · ${xxlMm}mm` : 'XXL',
      xxlDesc: xxlMm ? `${xxlMm}mm` : '',
      xxlHelp: sizeSelectorHelpText('xxl', xxlWidth)
    }
  }

  function productHasNewSizeBadge(product) {
    return normalizeProductTags(product?.tags).some((tag) => String(tag) === '_size_badge:new')
  }

  function sizeKeyHasNewBadge(product, sizeSelector, sizeKey, fromFetch) {
    if (product?.handle) return productHasNewSizeBadge(product)
    if (fromFetch) return false
    if (sizeKey === 'xxl') return sizeSelector.dataset.xxlBadgeNew === 'true'
    if (sizeKey === 'xl') return sizeSelector.dataset.xlBadgeNew === 'true'
    return sizeSelector.dataset.stdBadgeNew === 'true'
  }

  function syncSizeSelectorNewBadge(btn, show) {
    let badge = btn.querySelector('.pdp-size-selector__new')
    if (show) {
      if (!badge) {
        badge = document.createElement('span')
        badge.className = 'pdp-size-selector__new'
        badge.textContent = 'NEW'
        btn.prepend(badge)
      }
      return
    }
    if (badge) badge.remove()
  }

  function applyPdpSizeSelectorState(sizeSelector, currentProduct, sizeProductsByKey) {
    if (!sizeSelector || !currentProduct?.handle) return

    const family = getSizeFamilyHandles(currentProduct.handle)
    const byKey = Object.assign(
      { std: null, xl: null, xxl: null },
      sizeProductsByKey || {}
    )
    byKey[family.current] = currentProduct

    const hasXxl =
      !!(byKey.xxl && byKey.xxl.handle) || sizeSelector.dataset.hasXxl === 'true'
    sizeSelector.dataset.hasXxl = hasXxl ? 'true' : 'false'
    sizeSelector.classList.toggle('pdp-size-selector--tri', hasXxl)

    const stdTags = frameTagsFromProductOrDataset(byKey.std, sizeSelector, 'std')
    const xlTags = frameTagsFromProductOrDataset(byKey.xl, sizeSelector, 'xl')
    const xxlTags = frameTagsFromProductOrDataset(byKey.xxl, sizeSelector, 'xxl')
    const copy = buildPdpSizeSelectorCopy(
      stdTags.width,
      stdTags.size,
      xlTags.width,
      xxlTags.width
    )

    sizeSelector.dataset.stdHandle = family.std
    sizeSelector.dataset.xlHandle = family.xl
    sizeSelector.dataset.xxlHandle = family.xxl
    sizeSelector.dataset.stdWidth = stdTags.width
    sizeSelector.dataset.stdSize = stdTags.size
    sizeSelector.dataset.xlWidth = xlTags.width
    sizeSelector.dataset.xxlWidth = xxlTags.width
    if (byKey.std?.handle) {
      sizeSelector.dataset.stdBadgeNew = productHasNewSizeBadge(byKey.std) ? 'true' : 'false'
    }
    if (byKey.xl?.handle) {
      sizeSelector.dataset.xlBadgeNew = productHasNewSizeBadge(byKey.xl) ? 'true' : 'false'
    }
    if (byKey.xxl?.handle) {
      sizeSelector.dataset.xxlBadgeNew = productHasNewSizeBadge(byKey.xxl) ? 'true' : 'false'
    }

    const fromFetch = !!sizeProductsByKey
    const configs = [
      { key: 'std', title: copy.stdTitle, label: copy.stdLabel, desc: copy.stdDesc, help: copy.stdHelp },
      { key: 'xl', title: copy.xlTitle, label: copy.xlLabel, desc: copy.xlDesc, help: copy.xlHelp },
      { key: 'xxl', title: copy.xxlTitle, label: copy.xxlLabel, desc: copy.xxlDesc, help: copy.xxlHelp }
    ]

    configs.forEach(({ key, title, label, desc, help }) => {
      const btn = sizeSelector.querySelector(`[data-size="${key}"]`)
      if (!btn) return
      if (sizeProductsByKey) {
        const available = !!(byKey[key] && byKey[key].handle)
        btn.classList.toggle('hidden', !available)
      }
      btn.classList.toggle('on', family.current === key)
      btn.dataset.label = label
      btn.dataset.help = help
      const titleEl = btn.querySelector('.pdp-size-selector__t')
      const descEl = btn.querySelector('.pdp-size-selector__d')
      if (titleEl) titleEl.textContent = title
      if (descEl) {
        descEl.textContent = desc || ''
        descEl.hidden = !desc
      }
      syncSizeSelectorNewBadge(btn, sizeKeyHasNewBadge(byKey[key], sizeSelector, key, fromFetch))
    })

    const visibleCount = configs.filter(({ key }) => {
      const btn = sizeSelector.querySelector(`[data-size="${key}"]`)
      return btn && !btn.classList.contains('hidden')
    }).length
    const seg = sizeSelector.querySelector('.pdp-size-selector__seg')
    if (seg) seg.dataset.n = String(visibleCount)

    if (!sizeSelector.querySelector('.pdp-size-selector__help')) {
      const helpRow = document.createElement('div')
      helpRow.className = 'pdp-size-selector__help'
      helpRow.innerHTML =
        '<span data-size-help></span><a href="#pdp-fit-modal" data-pdp-open-fit-modal>Find your fit →</a>'
      sizeSelector.appendChild(helpRow)
    }
    retargetPdpSizeFitLinks()
    rememberFitFamily(byKey, fromFetch)

    const active = configs.find((c) => c.key === family.current)
    const labelEl = sizeSelector.querySelector('[data-size-label]')
    if (labelEl && active) labelEl.textContent = active.label
    const helpEl = sizeSelector.querySelector('[data-size-help]')
    if (helpEl && active) helpEl.textContent = active.help
  }

  function isSizeSelectableProductType(productType) {
    return productType === 'Sunglasses' || productType === 'Prescription'
  }

  function cacheSepDesignProductSectionAssets(handle, div) {
    if (!handle || !div) return

    if (!window.pdp.swiperHtmls[handle]) {
      const p = div.querySelector('sep-pdp-mainslider')
      if (p) window.pdp.swiperHtmls[handle] = p.innerHTML
    }

    if (!window.pdp.productPriceHtmls[handle]) {
      const p = div.querySelector('sep-pdp-price')
      if (p) window.pdp.productPriceHtmls[handle] = p.innerHTML
    }

    if (!hasJudgemeHtmlCache(handle)) {
      const p = div.querySelector('judgeme')
      if (p) window.pdp.judgemeHtmls[handle] = p.innerHTML
    }
    if (window.pdp.currentProduct?.handle === handle) {
      applyJudgemeBadgeForHandle(handle)
    }

    const varPrices = div.querySelector('sep-pdp-varprices')
    if (varPrices) {
      varPrices.querySelectorAll('.variant-price').forEach(pElement => {
        const variantId = pElement.getAttribute('data-variant-id')
        if (variantId) {
          window.pdp.variantPriceHtmls[variantId] = pElement.innerHTML
        }
      })
    }

    if (!window.pdp.atcHtmls[handle]) {
      const p = div.querySelector('sep-pdp-atc')
      if (p) {
        window.pdp.atcHtmls[handle] = p.innerHTML
        const atcElement = document.querySelector('.product__information > atc')
        const newAtc = p.querySelector('.product__information_block.atc, .atc')
        const newProductId = newAtc?.getAttribute('product_id')
        if (atcElement && newAtc && newProductId) {
          const existing = document.querySelector(
            `.product__information > .product__information_block.atc[product_id="${newProductId}"]`
          )
          if (!existing) {
            atcElement.insertAdjacentHTML('afterend', p.innerHTML)
          }
          if (typeof syncOphSplitAtcBlockVisibility === 'function') {
            syncOphSplitAtcBlockVisibility(window.pdp.currentProduct?.id)
          } else {
            syncVisibleAtcBlocks(window.pdp.currentProduct?.id)
          }
          if (typeof placeRxToggleForProductType === 'function' && window.pdp.currentProduct?.product_type) {
            placeRxToggleForProductType(window.pdp.currentProduct.product_type)
          }
          if (typeof renderWishlistButton === 'function') renderWishlistButton()
          if (typeof window.syncPdpMobileStickyAtc === 'function') window.syncPdpMobileStickyAtc()
        }
      }
    }
  }

  function swiperHostEl(swiper) {
    if (!swiper) return null
    const el = swiper.el
    if (el && typeof el.closest === 'function') return el
    if (el && el[0] && typeof el[0].closest === 'function') return el[0]
    return null
  }

  function swiperClosest(swiper, selector) {
    const el = swiperHostEl(swiper)
    return el ? el.closest(selector) : null
  }

  function isOtherProductsSwiperEntry(entry) {
    return !!(entry && swiperClosest(entry.swiper, '.other-products-container'))
  }

  function getMainSliderRootForHandle(handle) {
    if (!handle) return null
    const roots = document.querySelectorAll('.product__sep-design__mainSlider.swiper-' + handle)
    const entry = window.pdp.swipers && window.pdp.swipers[handle]
    if (isOtherProductsSwiperEntry(entry)) {
      return roots.length ? roots[roots.length - 1] : null
    }
    if (roots.length === 1) return roots[0]
    if (roots.length > 1) {
      const preferred =
        swiperClosest(entry?.thumbSwiper, '.product__sep-design__mainSlider') ||
        swiperClosest(entry?.swiper, '.product__sep-design__mainSlider') ||
        roots[roots.length - 1]
      return preferred
    }
    if (!entry) return null
    return (
      swiperClosest(entry.thumbSwiper, '.product__sep-design__mainSlider') ||
      swiperClosest(entry.swiper, '.product__sep-design__mainSlider') ||
      null
    )
  }

  function destroyMainSwiperEntry(handle) {
    const entry = window.pdp.swipers && window.pdp.swipers[handle]
    if (!entry) return
    try {
      if (entry.swiper && typeof entry.swiper.destroy === 'function') entry.swiper.destroy(true, true)
    } catch (e) {}
    try {
      if (entry.thumbSwiper && typeof entry.thumbSwiper.destroy === 'function') {
        entry.thumbSwiper.destroy(true, true)
      }
    } catch (e) {}
    delete window.pdp.swipers[handle]
  }

  function restoreMainSliderWrapperIntoRoot(handle, root) {
    const entry = window.pdp.swipers && window.pdp.swipers[handle]
    const mainslider = root || getMainSliderRootForHandle(handle)
    if (!mainslider) return
    const wrapper =
      swiperClosest(entry?.swiper, '.mainslider-wrapper') ||
      mainslider.querySelector('.mainslider-wrapper')
    if (!wrapper) return
    const galleryMedia = mainslider.querySelector('.product-gallery-media')
    const restoreTarget = galleryMedia || mainslider
    if (wrapper.parentNode !== restoreTarget) {
      const thumbs = restoreTarget.querySelector(':scope > .thumbnail-wrapper')
      if (thumbs) thumbs.after(wrapper)
      else restoreTarget.insertBefore(wrapper, restoreTarget.firstChild)
    }
    wrapper.classList.remove('sticky', 'floating')
  }

  function handleFromMainSliderWrapper(wrap) {
    const swiperEl = wrap && wrap.querySelector && wrap.querySelector('[class*="main-swiper-"]')
    if (!swiperEl) return ''
    const cls = Array.from(swiperEl.classList).find((c) => c.indexOf('main-swiper-') === 0)
    return cls ? cls.slice('main-swiper-'.length) : ''
  }

  // Mobile hoists a gallery's .mainslider-wrapper onto .product__main, outside its root.
  // Removing only the root left that wrapper behind: a second slideshow stacked over the remount.
  function removeMainSliderForHandle(handle) {
    document.querySelectorAll('.product__sep-design__mainSlider.swiper-' + handle).forEach((el) => el.remove())
    document.querySelectorAll('.product__main > .mainslider-wrapper').forEach((wrap) => {
      if (handleFromMainSliderWrapper(wrap) === handle) wrap.remove()
    })
  }

  // Only the active gallery may sit hoisted on .product__main: put every other one back in its
  // root, and drop leftovers whose root is gone or already holds a wrapper again
  function removeOrphanedMainSliderWrappers(keepWrap) {
    const keepHandle = keepWrap ? handleFromMainSliderWrapper(keepWrap) : ''
    document.querySelectorAll('.product__main > .mainslider-wrapper').forEach((wrap) => {
      if (wrap === keepWrap) return
      const handle = handleFromMainSliderWrapper(wrap)
      if (!handle) return
      const root = document.querySelector('.product__sep-design__mainSlider.swiper-' + handle)
      if (handle === keepHandle || !root || root.querySelector('.mainslider-wrapper')) {
        wrap.remove()
        return
      }
      const target = root.querySelector('.product-gallery-media') || root
      const thumbs = target.querySelector(':scope > .thumbnail-wrapper')
      if (thumbs) thumbs.after(wrap)
      else target.insertBefore(wrap, target.firstChild)
      wrap.classList.remove('sticky', 'floating')
    })
  }

  function dedupeMainSliderRoots(handle) {
    const roots = Array.from(
      document.querySelectorAll('.product__sep-design__mainSlider.swiper-' + handle)
    )
    if (!roots.length) return null
    if (roots.length === 1) return roots[0]
    const entry = window.pdp.swipers && window.pdp.swipers[handle]
    const preferred =
      swiperClosest(entry?.thumbSwiper, '.product__sep-design__mainSlider') ||
      swiperClosest(entry?.swiper, '.product__sep-design__mainSlider') ||
      roots[roots.length - 1]
    roots.forEach((root) => {
      if (root === preferred) return
      root.remove()
    })
    return preferred
  }

  function refreshMainSwiperForHandle(handle) {
    const entry = window.pdp.swipers && window.pdp.swipers[handle]
    if (!entry) return
    try {
      if (entry.swiper) {
        entry.swiper.update()
        if (typeof entry.swiper.updateSize === 'function') entry.swiper.updateSize()
      }
      if (entry.thumbSwiper) {
        entry.thumbSwiper.update()
        if (typeof entry.thumbSwiper.updateSize === 'function') entry.thumbSwiper.updateSize()
      }
      if (typeof entry.syncPagination === 'function') entry.syncPagination()
    } catch (e) {}
  }

  function revealMainSliderForHandle(handle) {
    if (!handle) return false
    if (!window.pdp._mainSliderShowGen) window.pdp._mainSliderShowGen = 0
    const gen = ++window.pdp._mainSliderShowGen
    window.pdp._activeMainSliderHandle = handle

    Object.keys(window.pdp.swipers || {}).forEach((h) => {
      if (!window.pdp.swipers[h]?.swiper && !window.pdp.swipers[h]?.thumbSwiper) return
      restoreMainSliderWrapperIntoRoot(h)
    })

    const root = dedupeMainSliderRoots(handle) || getMainSliderRootForHandle(handle)
    document.querySelectorAll('.product__sep-design__mainSlider').forEach((el) => {
      el.classList.add('hidden')
    })
    if (!root) return false

    root.classList.remove('hidden')
    restoreMainSliderWrapperIntoRoot(handle, root)

    requestAnimationFrame(() => {
      requestAnimationFrame(() => {
        if (gen !== window.pdp._mainSliderShowGen) return
        if (window.pdp._activeMainSliderHandle !== handle) return
        refreshMainSwiperForHandle(handle)
        if (typeof window.syncGalleryPdpLead === 'function') window.syncGalleryPdpLead()
        if (typeof handleMainSliderPosition === 'function') handleMainSliderPosition(handle)
      })
    })
    return true
  }

  function sepStorefrontEnabled() {
    return !!(window.sepStorefront && typeof window.sepStorefront.enabled === 'function' && window.sepStorefront.enabled())
  }

  // Storefront-first variant prices: fill variantPriceHtmls from GraphQL variant data.
  // Returns true on success; false (never throws) so callers can fall back to Section Rendering.
  function populateVariantPricesFromStorefront(handle, productType) {
    if (!sepStorefrontEnabled() || !handle) return Promise.resolve(false)
    return window.sepStorefront
      .productByHandle(handle)
      .then(function (product) {
        if (!product || !product.variants || !product.variants.length) return false
        const pt = productType || product.product_type
        product.variants.forEach(function (v) {
          if (v.id == null) return
          const html = buildSepDesignRxPriceBlockHtml(v, pt)
          if (html) window.pdp.variantPriceHtmls[v.id] = html
        })
        return true
      })
      .catch(function () {
        return false
      })
  }

  // Storefront-first subtitle from custom.product_subtitle metafield.
  function applySubtitleFromStorefront(handle) {
    if (!sepStorefrontEnabled() || !handle) return Promise.resolve(false)
    return window.sepStorefront
      .productByHandle(handle)
      .then(function (product) {
        if (!product) return false
        const subtitle = (product.metafields && product.metafields.product_subtitle) || ''
        window.pdp.subtitleHtmls[handle] = subtitle
        const subtitleElement = document.querySelector('.product__information_block.subtitle')
        if (subtitleElement) {
          if (subtitle) {
            subtitleElement.innerHTML = subtitle
            subtitleElement.classList.remove('hidden')
          } else {
            subtitleElement.innerHTML = ''
            subtitleElement.classList.add('hidden')
          }
        }
        return true
      })
      .catch(function () {
        return false
      })
  }

  function applyAtcHtmlForHandle(handle, atcHtml) {
    if (!handle || !atcHtml) return
    window.pdp.atcHtmls[handle] = atcHtml
    const wrap = document.createElement('div')
    wrap.innerHTML = atcHtml
    const newAtc = wrap.querySelector('.product__information_block.atc, .atc')
    const newProductId = newAtc?.getAttribute('product_id')
    const atcElement = document.querySelector('.product__information > atc')
    if (atcElement && newAtc && newProductId) {
      const existing = document.querySelector(
        `.product__information > .product__information_block.atc[product_id="${newProductId}"]`
      )
      if (!existing) {
        atcElement.insertAdjacentHTML('afterend', atcHtml)
      }
      syncVisibleAtcBlocks(window.pdp.currentProduct?.id)
      if (typeof placeRxToggleForProductType === 'function' && window.pdp.currentProduct?.product_type) {
        placeRxToggleForProductType(window.pdp.currentProduct.product_type)
      }
      if (typeof renderWishlistButton === 'function') renderWishlistButton()
    }
  }

  function cacheSepDesignProductAssetsFromStorefront(handle, product) {
    if (!handle || !product || !window.sepStorefront) return false
    if (!window.pdp.swiperHtmls[handle]) {
      window.pdp.swiperHtmls[handle] = window.sepStorefront.buildMainSliderHtml(product)
    }
    if (!window.pdp.atcHtmls[handle]) {
      applyAtcHtmlForHandle(handle, window.sepStorefront.buildAtcHtml(product))
    }
    const pt = product.product_type
    ;(product.variants || []).forEach(function (v) {
      if (v.id == null) return
      if (window.pdp.variantPriceHtmls[v.id]) return
      const html = buildSepDesignRxPriceBlockHtml(v, pt)
      if (html) window.pdp.variantPriceHtmls[v.id] = html
    })
    if (typeof product.metafields?.product_subtitle === 'string' && window.pdp.subtitleHtmls[handle] == null) {
      window.pdp.subtitleHtmls[handle] = product.metafields.product_subtitle
    }
    return !!(window.pdp.swiperHtmls[handle] && window.pdp.atcHtmls[handle])
  }

  function ensureSepDesignProductAssets(handle) {
    if (!handle) return Promise.resolve()
    if (!window.pdp._assetEnsurePromises) window.pdp._assetEnsurePromises = {}
    // Initial PDP product already has a live swiper in the DOM; do not require swiperHtmls
    const hasLiveSwiper = !!(window.pdp.swipers?.[handle]?.swiper && window.pdp.swipers?.[handle]?.thumbSwiper)
    const assetsReady =
      ((window.pdp.swiperHtmls[handle] || hasLiveSwiper) && window.pdp.atcHtmls[handle]) ||
      (hasLiveSwiper &&
        document.querySelector('.product__information_block.atc, .product__information > .atc, atc')) ||
      (window.pdp.swiperHtmls[handle] && window.pdp.atcHtmls[handle])

    // Gallery/ATC may already be cached while Judge.me badge is still missing
    if (assetsReady) {
      return ensureJudgemeHtmlForHandle(handle).then(() => {
        if (window.pdp.currentProduct?.handle === handle) applyJudgemeBadgeForHandle(handle)
      })
    }
    if (window.pdp._assetEnsurePromises[handle]) {
      return window.pdp._assetEnsurePromises[handle]
    }

    const fetchViaSection = () =>
      fetchSectionHtml(`/products/${handle}?section_id=sep-pdp-product`).then(data => {
        const div = new DOMParser().parseFromString(data, 'text/html')
        cacheSepDesignProductSectionAssets(handle, div)
      })

    const promise = (
      sepStorefrontEnabled()
        ? window.sepStorefront
            .productByHandle(handle)
            .then(product => {
              if (!product || !cacheSepDesignProductAssetsFromStorefront(handle, product)) {
                return fetchViaSection()
              }
              return ensureJudgemeHtmlForHandle(handle).then(() => {
                if (window.pdp.currentProduct?.handle === handle) applyJudgemeBadgeForHandle(handle)
              })
            })
            .catch(() => fetchViaSection())
        : fetchViaSection()
    )
      .then(() => ensureJudgemeHtmlForHandle(handle))
      .catch(() => {})
      .finally(() => {
        delete window.pdp._assetEnsurePromises[handle]
      })
    window.pdp._assetEnsurePromises[handle] = promise
    return promise
  }

  function paintPdpSizeSelectorSelection(targetHandle, sizeSelector = getPdpSizeSelectorElement()) {
    if (!sizeSelector || !targetHandle) return
    const key = getSizeKeyFromHandle(targetHandle)
    ;['std', 'xl', 'xxl'].forEach((sizeKey) => {
      const btn = sizeSelector.querySelector(`[data-size="${sizeKey}"]`)
      if (btn) btn.classList.toggle('on', sizeKey === key)
    })
    const label = sizeSelector.querySelector('[data-size-label]')
    const activeBtn = sizeSelector.querySelector(`[data-size="${key}"]`)
    if (label && activeBtn?.dataset.label) {
      label.textContent = activeBtn.dataset.label
    }
    const helpEl = sizeSelector.querySelector('[data-size-help]')
    if (helpEl && activeBtn?.dataset.help) {
      helpEl.textContent = activeBtn.dataset.help
    }
  }

  function refreshOtherProductsForHandle(handle) {
    if (!handle) return Promise.resolve()

    const applyOtherProductsMount = (collectionHandle, htmlNodeOrString, products) => {
      const otherProductsRoot = $(document).find('.product__information_block.other-products')
      otherProductsRoot.find('.other-products-container').addClass('hidden')

      if (collectionHandle && window.pdp.swipers[collectionHandle]) {
        $(window.pdp.swipers[collectionHandle].swiper.el)
          .closest('.other-products-container')
          .removeClass('hidden')
        window.pdp.mainCollection = collectionHandle
      } else if (htmlNodeOrString) {
        if (typeof htmlNodeOrString === 'string') {
          otherProductsRoot.append(htmlNodeOrString)
          if (collectionHandle && window.sepStorefront) {
            window.sepStorefront.mountOtherProductsSwiper(collectionHandle)
          }
        } else {
          otherProductsRoot.append(htmlNodeOrString)
          runAllScripts(htmlNodeOrString.get ? htmlNodeOrString.get(0) : htmlNodeOrString)
        }
        if (collectionHandle) window.pdp.mainCollection = collectionHandle
      }

      const pending = window.pdp.pendingSizeHandle
      if (pending) {
        paintPdpSizeSelectorSelection(pending)
      } else {
        requestAnimationFrame(updatePdpSizeSelector)
      }

      if (collectionHandle && products) {
        window.pdp.mainCollectionProducts = products
        fetchProductsByHandles(products.map(product => product.handle))
      }
    }

    const viaSection = () =>
      fetchSectionHtml(`/products/${handle}?section_id=sep-pdp-otherproducts`).then(data => {
        const div = new DOMParser().parseFromString(data, 'text/html')
        const content = $(div).find('#shopify-section-sep-pdp-otherproducts')
        const newContainer = content.find('.other-products-container').get(0)
        if (!newContainer) return

        const collectionClass = Array.from(newContainer.classList).find(c =>
          c.startsWith('other-products-swiper-container-')
        )
        const collectionHandle = collectionClass
          ? collectionClass.replace('other-products-swiper-container-', '')
          : ''

        applyOtherProductsMount(collectionHandle, content, null)

        if (collectionHandle) {
          if (sepStorefrontEnabled()) {
            window.sepStorefront
              .collectionByHandle(collectionHandle)
              .then(collection => {
                if (!collection) return
                window.pdp.mainCollectionProducts = collection.products
                fetchProductsByHandles(collection.products.map(product => product.handle))
              })
              .catch(() => {})
          } else {
            fetch(`/collections/${collectionHandle}/products.json`)
              .then(res => res.json())
              .then(collectionData => {
                window.pdp.mainCollectionProducts = collectionData.products
                fetchProductsByHandles(collectionData.products.map(product => product.handle))
              })
              .catch(() => {})
          }
        }
      })

    if (sepStorefrontEnabled()) {
      return window.sepStorefront
        .loadOtherProductsForHandle(handle)
        .then(payload => {
          if (!payload || !payload.html) return viaSection()
          applyOtherProductsMount(payload.collectionHandle, payload.html, payload.collection.products)
        })
        .catch(() => viaSection())
        .catch(() => {})
    }

    return viaSection().catch(() => {})
  }

  function setPdpSizeSelectorBusy(busy) {
    const sizeSelector = getPdpSizeSelectorElement()
    if (!sizeSelector) return
    sizeSelector.classList.toggle('is-busy', !!busy)
    sizeSelector.setAttribute('aria-busy', busy ? 'true' : 'false')
  }

  function setPdpProductSwitchBusyUi(busy) {
    setPdpSizeSelectorBusy(busy)
    document.querySelector('.product__information_block.rx-toggle')?.classList.toggle('is-busy', !!busy)
    document.querySelector('.product__information_block.other-products')?.classList.toggle('is-busy', !!busy)
  }

  function isPdpProductSwitchBusy() {
    return !!(window.pdp.pendingProductSwitch || window.pdp.pendingSizeHandle)
  }

  function beginPdpProductSwitch(kind, targetKey) {
    // Allow replacing an in-flight size toggle (XL <> Regular) so rapid clicks don't stack stale reveals
    if (isPdpProductSwitchBusy()) {
      if (kind === 'size' && window.pdp.pendingProductSwitch?.kind === 'size') {
        window.pdp.pendingProductSwitch = { kind, targetKey }
        window.pdp.pendingSizeHandle = targetKey
        if (!window.pdp._mainSliderShowGen) window.pdp._mainSliderShowGen = 0
        window.pdp._mainSliderShowGen++
        setPdpProductSwitchBusyUi(true)
        if (window.pdp._productSwitchUnlockTimer) clearTimeout(window.pdp._productSwitchUnlockTimer)
        window.pdp._productSwitchUnlockTimer = setTimeout(() => {
          endPdpProductSwitch(kind, targetKey, true)
        }, 8000)
        return true
      }
      return false
    }
    window.pdp.pendingProductSwitch = { kind, targetKey }
    if (kind === 'size') window.pdp.pendingSizeHandle = targetKey
    if (kind === 'size') {
      if (!window.pdp._mainSliderShowGen) window.pdp._mainSliderShowGen = 0
      window.pdp._mainSliderShowGen++
    }
    setPdpProductSwitchBusyUi(true)
    if (window.pdp._productSwitchUnlockTimer) clearTimeout(window.pdp._productSwitchUnlockTimer)
    window.pdp._productSwitchUnlockTimer = setTimeout(() => {
      endPdpProductSwitch(kind, targetKey, true)
    }, 8000)
    return true
  }

  function endPdpProductSwitch(kind, targetKey, force) {
    const pending = window.pdp.pendingProductSwitch
    if (!pending && !window.pdp.pendingSizeHandle) {
      setPdpProductSwitchBusyUi(false)
      return
    }
    if (!force && pending) {
      if (kind && pending.kind !== kind) return
      if (targetKey && pending.targetKey !== targetKey) return
    }
    if (window.pdp._productSwitchUnlockTimer) {
      clearTimeout(window.pdp._productSwitchUnlockTimer)
      window.pdp._productSwitchUnlockTimer = null
    }
    window.pdp.pendingProductSwitch = null
    window.pdp.pendingSizeHandle = null
    setPdpProductSwitchBusyUi(false)
  }

  function resolvePdpProductSwitchFromProduct(product) {
    const pending = window.pdp.pendingProductSwitch
    if (!pending || !product) return
    if (pending.kind === 'size' || pending.kind === 'frame') {
      const candidates = [product.handle, window.pdp.currentProductHandle]
      if (typeof window.getOphSplitSliderHandle === 'function') {
        candidates.push(window.getOphSplitSliderHandle(product.handle))
      }
      if (candidates.includes(pending.targetKey)) endPdpProductSwitch(pending.kind, pending.targetKey)
      return
    }
    if (pending.kind === 'rx') {
      const expectedType = pending.targetKey === 'prescription' ? 'Prescription' : 'Sunglasses'
      if (product.product_type === expectedType) endPdpProductSwitch('rx', pending.targetKey)
    }
  }

  window.isPdpProductSwitchBusy = isPdpProductSwitchBusy
  window.beginPdpProductSwitch = beginPdpProductSwitch
  window.endPdpProductSwitch = endPdpProductSwitch

  function switchPdpSizeProduct(targetHandle) {
    if (!targetHandle || targetHandle === window.pdp.currentProduct?.handle) return
    if (!beginPdpProductSwitch('size', targetHandle)) return

    paintPdpSizeSelectorSelection(targetHandle)

    ensureSepDesignProductAssets(targetHandle)
      .then(() => {
        if (window.pdp.pendingSizeHandle !== targetHandle) return
        setState['currentProductHandle'](targetHandle)
        refreshOtherProductsForHandle(targetHandle)
      })
      .catch(() => {
        endPdpProductSwitch('size', targetHandle, true)
      })
  }

  function updatePdpSizeSelector() {
    const sizeSelector = getPdpSizeSelectorElement()
    if (!sizeSelector) return

    const currentProduct = window.pdp.currentProduct
    const currentHandle = currentProduct?.handle
    const pendingHandle = window.pdp.pendingSizeHandle

    if (pendingHandle && currentHandle !== pendingHandle) {
      paintPdpSizeSelectorSelection(pendingHandle, sizeSelector)
      setPdpProductSwitchBusyUi(true)
      return
    }
    if (pendingHandle && currentHandle === pendingHandle) {
      endPdpProductSwitch('size', pendingHandle)
    }

    if (!currentHandle || !isSizeSelectableProductType(currentProduct?.product_type)) {
      sizeSelector.classList.add('hidden')
      return
    }

    const family = getSizeFamilyHandles(currentHandle)
    const sizeKeys = ['std', 'xl', 'xxl']

    const matchesInitialRender =
      sizeSelector.dataset.hasCounterpart === 'true' &&
      [sizeSelector.dataset.stdHandle, sizeSelector.dataset.xlHandle, sizeSelector.dataset.xxlHandle].includes(
        currentHandle
      )

    if (matchesInitialRender) {
      sizeSelector.classList.remove('hidden')
      applyPdpSizeSelectorState(sizeSelector, currentProduct, null)
    }

    const siblingFetches = sizeKeys
      .filter((key) => family[key] && family[key] !== currentHandle)
      .map((key) =>
        fetchProductJsonMerged(`/products/${family[key]}.json`)
          .then((res) => ({ key, product: res?.product?.handle ? res.product : null }))
          .catch(() => ({ key, product: null }))
      )

    Promise.all(siblingFetches)
      .then((results) => {
        if (window.pdp.pendingSizeHandle && window.pdp.pendingSizeHandle !== currentHandle) {
          paintPdpSizeSelectorSelection(window.pdp.pendingSizeHandle)
          return
        }
        if (window.pdp.currentProduct?.handle !== currentHandle) return

        const byKey = { std: null, xl: null, xxl: null }
        byKey[family.current] = currentProduct
        results.forEach(({ key, product }) => {
          byKey[key] = product
        })

        const availableCount = sizeKeys.filter((key) => byKey[key]?.handle).length
        if (availableCount < 2) {
          sizeSelector.classList.add('hidden')
          sizeSelector.dataset.hasCounterpart = 'false'
          return
        }

        sizeSelector.classList.remove('hidden')
        sizeSelector.dataset.hasCounterpart = 'true'
        applyPdpSizeSelectorState(sizeSelector, currentProduct, byKey)
        sizeKeys.forEach((key) => {
          if (byKey[key]?.handle && family[key] !== currentHandle) {
            ensureSepDesignProductAssets(family[key])
          }
        })
      })
      .catch(() => {
        if (window.pdp.pendingSizeHandle && window.pdp.pendingSizeHandle !== currentHandle) {
          paintPdpSizeSelectorSelection(window.pdp.pendingSizeHandle)
          return
        }
        if (window.pdp.currentProduct?.handle !== currentHandle) return
        if (matchesInitialRender) {
          sizeSelector.classList.remove('hidden')
          applyPdpSizeSelectorState(sizeSelector, currentProduct, null)
        } else {
          sizeSelector.classList.add('hidden')
        }
      })
  }

  console.log("INITIALIZING SET STATE")
  const setState = {
    'currentProductHandle': (value) => {
      if (!value) return
      const normalized =
        typeof window.getOphSplitSliderHandle === 'function'
          ? window.getOphSplitSliderHandle(value)
          : value
      if (window.pdp.currentProductHandle === normalized) return

      window.pdp.mainSliderPosition.isFirstLoad = true
      const prevRaw = window.pdp.currentProductHandle || window.pdp.currentProduct?.handle || normalized
      const prevHandle =
        typeof window.getOphSplitSliderHandle === 'function'
          ? window.getOphSplitSliderHandle(prevRaw)
          : prevRaw

      if (prevHandle && prevHandle !== normalized) {
        restoreMainSliderWrapperIntoRoot(prevHandle)
      }

      window.pdp.currentProductHandle = normalized
      document.dispatchEvent(new CustomEvent('state:change:currentProductHandle', {
        detail: {
          value: normalized
        }
      }))
    },
    'currentProduct': (value) => {
      window.pdp.currentProduct = value
      document.dispatchEvent(new CustomEvent('state:change:currentProduct', {
        detail: {
          value
        }
      }))
    },
    'initialized': (value) => {
      if (window.pdp.initialized === value) return
      window.pdp.initialized = value
      document.dispatchEvent(new CustomEvent('state:change:initialized', {
        detail: {
          value
        }
      }))
    },
    'currentProductType': (value) => {
      if (window.pdp.currentProductType === value) return
      window.pdp.currentProductType = value
      document.dispatchEvent(new CustomEvent('state:change:currentProductType', {
        detail: {
          value
        }
      }))
    },
    'mainCollection': (value) => {
      if (window.pdp.mainCollection === value) return
      window.pdp.mainCollection = value
      document.dispatchEvent(new CustomEvent('state:change:mainCollection', {
        detail: {
          value
        }
      }))
    },
    'lens-color': (value) => {
      // if (window.pdp.rx['lens-color'] === value) return
      
      // Handle transition from tinted colors to clear/black/brown (and aligned colors)
      const previousLensColor = window.pdp.rx['lens-color']
      const tintedLensColors = ['coastal-blue', 'rose-pink', 'silver', 'green-vibrant', 'purple-pastel']
      const standardLensTargets = ['clear', 'black', 'brown', 'yellow', 'photochromic-gray', 'photochromic-brown']
      if (tintedLensColors.includes(previousLensColor) &&
          standardLensTargets.includes(value)) {
        
        // Check if impact-resistant is selected
        if (window.pdp.rx['lens-upgrade'] && window.pdp.rx['lens-upgrade']['impact-resistant']) {
          // Mark impact-resistant as false and make standard true
          const currentUpgrades = Object.keys(window.pdp.rx['lens-upgrade']).filter(k => 
            window.pdp.rx['lens-upgrade'][k] && k !== 'impact-resistant'
          )
          currentUpgrades.push('standard')
          setState['lens-upgrade'](currentUpgrades)
          console.log('[lens-color] switched from impact-resistant to standard due to color change', {
            from: previousLensColor,
            to: value,
            newUpgrades: currentUpgrades
          })
        }
      }
      
      window.pdp.rx['lens-color'] = value
      document.dispatchEvent(new CustomEvent('state:change:lens-color', {
        detail: {
          value
        }
      }))
    },
    'lens-type': (value) => {
      // if (window.pdp.rx['lens-type'] === value) return
      window.pdp.rx['lens-type'] = value
      document.dispatchEvent(new CustomEvent('state:change:lens-type', {
        detail: {
          value
        }
      }))
    },
    'lens-style': (value) => {
      window.pdp.rx['lens-style'] = value
      document.dispatchEvent(new CustomEvent('state:change:lens-style', {
        detail: {
          value
        }
      }))
    },
    'oph-type': (value) => {
      // if (window.pdp.rx['oph-type'] === value) return
      window.pdp.rx['oph-type'] = value
      document.dispatchEvent(new CustomEvent('state:change:oph-type', {
        detail: {
          value
        }
      }))
    },
    'lens-upgrade': (value) => {
      if (compareArrays(Object.keys(window.pdp.rx['lens-upgrade']).filter(k => window.pdp.rx['lens-upgrade'][k]).map(k => window.pdp.rx['lens-upgrade'][k]), value)) return
      Object.keys(window.pdp.rx['lens-upgrade']).forEach(k => {
        if (value.includes(k)) {
          window.pdp.rx['lens-upgrade'][k] = true
        } else {
          window.pdp.rx['lens-upgrade'][k] = false
        }
      })
      document.dispatchEvent(new CustomEvent('state:change:lens-upgrade', {
        detail: {
          value
        }
      }))
    },
    'selectedVariant': (value) => {
      // if (!value) return
      if (window.pdp.selectedVariant?.id === value?.id) return
      window.pdp.selectedVariant = value
      document.dispatchEvent(new CustomEvent('state:change:selectedVariant', {
        detail: {
          value
        }
      }))
    },
    'variant-id': (value) => {
      if (window.pdp.variantId === value) return
      window.pdp.variantId = value
      document.dispatchEvent(new CustomEvent('state:change:variant-id', {
        detail: {
          value
        }
      }))
    }
  }

  function getProductHandleForVariant(variant) {
    if (!variant || !variant.product_id) return window.pdp.currentProduct?.handle
    if (window.pdp.ophMainProduct && variant.product_id === window.pdp.ophMainProduct.id) return window.pdp.ophMainProduct.handle
    if (window.pdp.currentProduct && variant.product_id === window.pdp.currentProduct.id) return window.pdp.currentProduct.handle
    if (window.pdp.ophSplitBlProduct && variant.product_id === window.pdp.ophSplitBlProduct.id) return window.pdp.ophSplitBlProduct.handle
    if (window.pdp.ophSplitPlProduct && variant.product_id === window.pdp.ophSplitPlProduct.id) return window.pdp.ophSplitPlProduct.handle
    return window.pdp.currentProduct?.handle
  }

  function getOphSplitRoleFromSelection() {
    const ophType = window.pdp?.rx?.['oph-type']
    if (ophType === 'blue-light') return 'bl'
    if (ophType === 'plain') return 'pl'
    return 'main'
  }

  /** Which product handle owns the visible main gallery for the current oph-type (split PDP). */
  function getSepDesignActiveSliderHandle() {
    if (window.pdp.ophSplitArchitecture) {
      const ophType = window.pdp.rx?.['oph-type']
      if (ophType === 'blue-light' && window.pdp.ophSplitBlHandle) return window.pdp.ophSplitBlHandle
      if (ophType === 'plain' && window.pdp.ophSplitPlHandle) return window.pdp.ophSplitPlHandle
      if (window.pdp.ophMainHandle) return window.pdp.ophMainHandle
    }
    const curHandle = window.pdp.currentProduct?.handle
    return typeof window.getOphSplitSliderHandle === 'function'
      ? window.getOphSplitSliderHandle(curHandle)
      : curHandle
  }

  /** Sliders filter/reorder as prescription until the customer picks a glass type. */
  function getEffectiveOphTypeForSliders() {
    return window.pdp.rx?.['oph-type'] || 'prescription'
  }

  function sepDesignMatchesOphType(img, ophType) {
    if (!img?.src || !ophType) return false
    const src = String(img.src).toLowerCase()
    const tail = src.split(/_\d{2}_/).pop() || src
    if (ophType === 'blue-light') {
      return tail.includes('bluelight') || tail.includes('blue-light') || tail.includes('blue_light')
    }
    if (ophType === 'prescription' || ophType === 'readers' || ophType === 'plain') {
      if (tail.includes('bluelight') || tail.includes('blue-light') || tail.includes('blue_light')) return false
      return tail.includes('clear')
    }
    return false
  }

  function forceSwiperSlideTo(swiper, index) {
    if (!swiper || index == null || index < 0) return
    swiper.update()
    const maxIndex = Math.max(0, swiper.slides.length - 1)
    const targetIndex = Math.min(index, maxIndex)
    if (swiper.activeIndex === targetIndex) {
      const bump =
        targetIndex + 1 <= maxIndex ? targetIndex + 1 : Math.max(0, targetIndex - 1)
      swiper.slideTo(bump, 0, false)
    }
    swiper.slideTo(targetIndex, 0, false)
  }

  function resetSepDesignSiblingSliderVisibility(swiperRootEl, ophType) {
    if (!swiperRootEl) return
    const wrapper = swiperRootEl.querySelector('.swiper-wrapper')
    if (!wrapper) return
    let customActiveSlideSet = false
    wrapper.querySelectorAll(':scope > .swiper-slide').forEach((slide) => {
      const isCase = slide.getAttribute('data-special-slide') === 'slim-hard-case'
      slide.classList.remove('swiper-slide-custom-active')
      if (isCase) {
        slide.classList.toggle('hidden', ophType === 'blue-light')
        return
      }
      slide.classList.remove('hidden')
      if (!customActiveSlideSet) {
        slide.classList.add('swiper-slide-custom-active')
        customActiveSlideSet = true
      }
    })
  }

  function applySepDesignSliderVisibility(thumbRoot, sliderHandle) {
    const ophType = window.pdp.rx?.['oph-type']
    const useSiblingGallery =
      window.pdp.ophSplitArchitecture &&
      ((ophType === 'blue-light' && sliderHandle === window.pdp.ophSplitBlHandle) ||
        (ophType === 'plain' && sliderHandle === window.pdp.ophSplitPlHandle))
    if (useSiblingGallery) {
      resetSepDesignSiblingSliderVisibility(thumbRoot, ophType)
    } else {
      toggleSlidersWithColor(thumbRoot)
    }
  }

  function getOphBaseHandle(handle) {
    if (!handle) return handle
    const blSuffix = '-bl'
    const plSuffix = '-pl'
    if (handle.endsWith(blSuffix)) return handle.slice(0, -blSuffix.length)
    if (handle.endsWith(plSuffix)) return handle.slice(0, -plSuffix.length)
    return handle
  }

  function resolveOphSplitHandleForNavigation(handle) {
    if (!handle || !window.pdp?.ophSplitArchitecture) return handle
    let role = getOphSplitRoleFromSelection()
    // Prefer landing -bl/-pl role until shopper picks a type (avoids URL flicker to main).
    if (role === 'main' && !window.pdp.rx?.['oph-type']) {
      if (window.pdp.ophSplitRole === 'bl' || window.pdp.ophSplitRole === 'pl') {
        role = window.pdp.ophSplitRole
      } else {
        // Fallback: current path still on sibling (role may have been reset mid-load)
        try {
          const pathHandle = (window.location.pathname.match(/\/products\/([^\/]+)/) || [])[1] || ''
          if (pathHandle.endsWith('-bl')) role = 'bl'
          else if (pathHandle.endsWith('-pl')) role = 'pl'
        } catch (e) {}
      }
    }
    const baseHandle = getOphBaseHandle(handle)
    if (role === 'bl') return `${baseHandle}-bl`
    if (role === 'pl') return `${baseHandle}-pl`
    return baseHandle
  }

  window.resolveOphSplitHandleForNavigation = resolveOphSplitHandleForNavigation

  function fetchProductJson(handle) {
    return window.fetchOphSplitProductJson(handle)
  }

  /** Auto-select Blue Light / Plain when URL is a split sibling (-bl / -pl). */
  function selectOphTypeFromSplitRole(options) {
    const force = options && options.force
    if (!window.pdp.ophSplitArchitecture || window.pdp.editMode) return false
    const role = window.pdp.ophSplitRole
    const typeFromRole =
      role === 'bl' ? 'blue-light' : role === 'pl' ? 'plain' : null
    if (!typeFromRole) return false
    if (!force && window.pdp.rx['oph-type']) return false
    if (typeof isOphTypePathAvailable === 'function' && !isOphTypePathAvailable(typeFromRole)) {
      return false
    }

    const tryClick = () => {
      const opt = document.querySelector(
        '#oph-type-panel .dropdown-option[data-value="' + typeFromRole + '"]'
      )
      if (opt && !opt.classList.contains('is-unavailable')) {
        opt.click()
        return true
      }
      return false
    }

    if (tryClick()) return true
    requestAnimationFrame(() => tryClick())
    return false
  }

  function applyOphSplitLandingPriceFallback() {
    if (window.pdp.selectedVariant) {
      applyPriceBlockForVariant(window.pdp.selectedVariant)
      return
    }
    // OOS -bl/-pl: type not auto-selected, but still show that sibling's real price
    const role = window.pdp.ophSplitRole
    let variant = null
    if (role === 'bl') variant = window.pdp.ophSplitBlProduct?.variants?.[0] || null
    else if (role === 'pl') variant = window.pdp.ophSplitPlProduct?.variants?.[0] || null
    if (variant && variant.price != null && String(variant.price) !== '0.00') {
      applyPriceBlockForVariant(variant)
    }
  }

  document.addEventListener('oph-split:ready', () => {
    if (!window.pdp.ophSplitArchitecture) return
    const splitSiblingRole =
      window.pdp.ophSplitRole === 'bl' || window.pdp.ophSplitRole === 'pl'
    selectOphTypeFromSplitRole({ force: splitSiblingRole })
    getProductVariantWithAvailability().then(() => {
      findSelectedVariant()
      applyOphSplitLandingPriceFallback()
      syncOphTypeAvailabilityUi()
      updateATCText()
    })
  })

  function fetchCollectionProductsStorefrontFirst(collectionHandle) {
    if (!collectionHandle) return Promise.resolve([])
    if (sepStorefrontEnabled()) {
      return window.sepStorefront
        .collectionByHandle(collectionHandle)
        .then(collection => (collection && collection.products) || [])
        .catch(() =>
          fetch(`/collections/${collectionHandle}/products.json`)
            .then(res => res.json())
            .then(data => data.products || [])
        )
    }
    return fetch(`/collections/${collectionHandle}/products.json`)
      .then(res => res.json())
      .then(data => data.products || [])
  }

  fetchProductJsonMerged('/products/' + window.SEP_DESIGN_OPH.productHandle + '.json')
    .then((data) => window.loadOphthalmicSplitProducts(data.product).then(() => data))
    .then((data) => {
      const canonical =
        window.pdp.ophSplitReady.main && window.pdp.ophMainProduct ? window.pdp.ophMainProduct : data.product
      setState['currentProduct'](canonical)
      if (canonical?.handle) {
        setState['currentProductHandle'](canonical.handle)
      }
      setState['initialized'](true)
    })
  
  if (window.pdp.mainCollection) {
    fetchCollectionProductsStorefrontFirst(window.pdp.mainCollection).then(products => {
      window.pdp.mainCollectionProducts = products
      fetchProductsByHandles(products.map(product => product.handle))
    })
  }
    
  function fetchProductsByHandles(handles) {
    const list = [...new Set((handles || []).filter(Boolean))]
    if (!list.length) return Promise.resolve()
    const concurrency = 2
    let index = 0
    const workers = Array.from({ length: Math.min(concurrency, list.length) }, async () => {
      while (index < list.length) {
        const handle = list[index++]
        await ensureSepDesignProductAssets(handle)
      }
    })
    return Promise.all(workers).then(() => {})
  }

  function pdpBackgroundTask() {
    // fetch all products in collection
    const mainCollection = window.pdp.mainCollection
    const currentProduct = window.pdp.currentProduct

    fetchProductsByHandles([currentProduct.handle])
    const splitHandles = []
    if (window.pdp.ophSplitReady?.main && window.pdp.ophMainProduct) splitHandles.push(window.pdp.ophMainProduct.handle)
    if (window.pdp.ophSplitReady?.bl && window.pdp.ophSplitBlProduct) splitHandles.push(window.pdp.ophSplitBlProduct.handle)
    if (window.pdp.ophSplitReady?.pl && window.pdp.ophSplitPlProduct) splitHandles.push(window.pdp.ophSplitPlProduct.handle)
    const uniq = [...new Set(splitHandles.filter((h) => h && h !== currentProduct.handle))]
    if (uniq.length) fetchProductsByHandles(uniq)

    if (mainCollection) {
      // fetch counter part products of sunglasses
      if (currentProduct?.product_type === 'Sunglasses') {
        fetchCollectionProductsStorefrontFirst('prescription-' + mainCollection).then(products => {
          window.pdp.counterPartCollectionProducts = products
          fetchProductsByHandles(products.map(product => product.handle))
        })
      }

      // fetch counter part products of prescription
      if (currentProduct?.product_type === 'Prescription') {
        fetchCollectionProductsStorefrontFirst(mainCollection.replace('prescription-', '')).then(products => {
          window.pdp.counterPartCollectionProducts = products
          fetchProductsByHandles(products.map(product => product.handle))
        })
      }
    }
  }

  function haveSameElements(arr1, arr2) {
    return arr1.length === arr2.length && 
      arr1.every(item => arr2.includes(item))
  }

  function updateLensUpgradeAvailability() {
    if (!window.isOphOrRxPdpProduct(window.pdp.currentProduct)) return
    
    const lensUpgradeOptions = document.querySelectorAll('.dropdown.lens-upgrade .dropdown-option[data-value]')
    
    // Reset all options to visible first
    lensUpgradeOptions.forEach(option => {
      if (option) {
        option.classList.remove('hidden')
      }
    })
    
    if (window.pdp.currentProduct?.product_type === 'Prescription') {
      const lensColor = window.pdp.rx['lens-color']
      // Apply restrictions based on lens color
      if (['clear', 'yellow', 'photochromic-gray', 'photochromic-brown'].includes(lensColor)) {
        const antiReflectiveOption = document.querySelector('.dropdown-option[data-value="anti-reflective-coating"]')
        const blueLightOption = document.querySelector('.dropdown-option[data-value="blue-light"]')
        const polarizationOption = document.querySelector('.dropdown-option[data-value="polarized"]')

        if (polarizationOption) {
          polarizationOption.classList.add('hidden')
          // Set polarization to false using setState
          if (window.pdp.rx['lens-upgrade']) {
            const currentUpgrades = Object.keys(window.pdp.rx['lens-upgrade']).filter(k => window.pdp.rx['lens-upgrade'][k] && k !== 'polarized')
            setState['lens-upgrade'](currentUpgrades)
          }
        }
        
        if (antiReflectiveOption) {
          antiReflectiveOption.classList.remove('hidden')
        }
        
        if (blueLightOption) {
          blueLightOption.classList.remove('hidden')
        }
      } else if (['black', 'brown'].includes(lensColor)) {
        // Show anti-reflective coating and polarized; hide blue light
        const antiReflectiveOption = document.querySelector('.dropdown-option[data-value="anti-reflective-coating"]')
        const blueLightOption = document.querySelector('.dropdown-option[data-value="blue-light"]')
        const polarizationOption = document.querySelector('.dropdown-option[data-value="polarized"]')
        
        if (antiReflectiveOption) {
          antiReflectiveOption.classList.remove('hidden')
        }
        
        if (polarizationOption) {
          polarizationOption.classList.remove('hidden')
        }

        if (blueLightOption) {
          blueLightOption.classList.add('hidden')
          // Set polarization to false using setState
          if (window.pdp.rx['lens-upgrade']) {
            const currentUpgrades = Object.keys(window.pdp.rx['lens-upgrade']).filter(k => window.pdp.rx['lens-upgrade'][k] && k !== 'blue-light')
            setState['lens-upgrade'](currentUpgrades)
          }
        }
      } else if (['coastal-blue', 'rose-pink', 'silver', 'green-vibrant', 'purple-pastel'].includes(lensColor)) {
        // Mirrored: Standard not available. Hide AR + blue light. Default to Impact Resistant if Standard was selected.
        const standardOption = document.querySelector('.dropdown-option[data-value="standard"]')
        const antiReflectiveOption = document.querySelector('.dropdown-option[data-value="anti-reflective-coating"]')
        const blueLightOption = document.querySelector('.dropdown-option[data-value="blue-light"]')

        if (standardOption) {
          standardOption.classList.add('hidden')
        }

        if (antiReflectiveOption) {
          antiReflectiveOption.classList.add('hidden')
        }
        
        if (blueLightOption) {
          blueLightOption.classList.add('hidden')
        }
        
        if (window.pdp.rx['lens-upgrade']) {
          const currentUpgrades = Object.keys(window.pdp.rx['lens-upgrade']).filter(k => 
            window.pdp.rx['lens-upgrade'][k] && 
            k !== 'anti-reflective-coating' && 
            k !== 'blue-light' &&
            k !== 'standard'
          )
          if (window.pdp.rx['lens-upgrade']['standard']) currentUpgrades.push('impact-resistant')
          setState['lens-upgrade'](currentUpgrades)
        }
        
        const polarizationOption = document.querySelector('.dropdown-option[data-value="polarized"]')
        if (polarizationOption) {
          polarizationOption.classList.remove('hidden')
        }
      }
    }

    if (window.isOphthalmicPdpProduct(window.pdp.currentProduct)) {
      const ophType = window.pdp.rx['oph-type']

      const standardOption = document.querySelector('.dropdown-option[data-value="standard"]')
      const impactResistantOption = document.querySelector('.dropdown-option[data-value="impact-resistant"]')
      const blueLightOption = document.querySelector('.dropdown-option[data-value="blue-light"]')
      const highIndexOption = document.querySelector('.dropdown-option[data-value="high-index"]')
      const antiReflectiveCoatingOption = document.querySelector('.dropdown-option[data-value="anti-reflective-coating"]')
      const polarizedOption = document.querySelector('.dropdown-option[data-value="polarized"]')

      if (ophType === 'prescription') {

        if (polarizedOption) {
          polarizedOption.classList.add('hidden')
        }

        if (standardOption) {
          standardOption.classList.remove('hidden')
        }

        if (impactResistantOption) {
          impactResistantOption.classList.remove('hidden')
        }

        if (blueLightOption) {
          blueLightOption.classList.remove('hidden')
        }

        if (highIndexOption) {
          highIndexOption.classList.remove('hidden')
        }

        if (antiReflectiveCoatingOption) {
          antiReflectiveCoatingOption.classList.remove('hidden')
        }

        if (window.pdp.rx['lens-upgrade']) {
          const currentUpgrades = Object.keys(window.pdp.rx['lens-upgrade']).filter(k => window.pdp.rx['lens-upgrade'][k] && k !== 'polarized')
          setState['lens-upgrade'](currentUpgrades)
        }
      } else if (ophType === 'readers') {
        if (standardOption) {
          standardOption.classList.add('hidden')
        }

        if (impactResistantOption) {
          impactResistantOption.classList.add('hidden')
        }

        if (highIndexOption) {
          highIndexOption.classList.add('hidden')
        }

        if (antiReflectiveCoatingOption) {
          antiReflectiveCoatingOption.classList.add('hidden')
        }

        if (polarizedOption) {
          polarizedOption.classList.add('hidden')
        }

        if (blueLightOption) {
          blueLightOption.classList.remove('hidden')
        }

        if (window.pdp.rx['lens-upgrade']) {
          const currentUpgrades = Object.keys(window.pdp.rx['lens-upgrade']).filter(k => window.pdp.rx['lens-upgrade'][k] && k !== 'standard' && k !== 'impact-resistant' && k !== 'high-index' && k !== 'anti-reflective-coating' && k !== 'polarized')
          currentUpgrades.push('standard')
          setState['lens-upgrade'](currentUpgrades)
        }
      } else {
        setState['lens-upgrade'](['standard'])
      }
    }
    
    // Update the dropdown display to reflect current selections
    const upgradeSelect = document.querySelector('[data-dropdown="lens-upgrade"]')
    if (upgradeSelect) {
      const event = new CustomEvent('lens-upgrade:availability-changed')
      upgradeSelect.dispatchEvent(event)
    }
  }

  function updateLensUpgradePricing() {
    if (!window.isOphOrRxPdpProduct(window.pdp.currentProduct)) return

    const lensType = window.pdp.rx['lens-type']
    const lensColor = window.pdp.rx['lens-color']
    
    // Get the upgrade options
    const highIndexOption = document.querySelector('.dropdown-option[data-value="high-index"]')
    const impactResistantOption = document.querySelector('.dropdown-option[data-value="impact-resistant"]')
    
    if (!highIndexOption || !impactResistantOption) return
    
    const highIndexText = highIndexOption.querySelector('.dropdown-text-main')
    const impactResistantText = impactResistantOption.querySelector('.dropdown-text-main')
    
    if (!highIndexText || !impactResistantText) return
    
    // Define pricing based on lens type and color
    let highIndexPrice = ''
    let impactResistantPrice = ''
    
    const standardLensColorsPricing = ['clear', 'black', 'brown', 'yellow', 'photochromic-gray', 'photochromic-brown']
    const tintedLensColorsPricing = ['coastal-blue', 'rose-pink', 'silver', 'green-vibrant', 'purple-pastel']
    if (lensType === 'single-vision') {
      if (standardLensColorsPricing.includes(lensColor) || window.isOphthalmicPdpProduct(window.pdp.currentProduct)) {
        highIndexPrice = ' +$135'
        impactResistantPrice = ' +$35'
      } else if (tintedLensColorsPricing.includes(lensColor)) {
        highIndexPrice = ' +$135'
        impactResistantPrice = ' FREE'
      }
    } else if (lensType === 'progressive') {
      if (standardLensColorsPricing.includes(lensColor) || window.isOphthalmicPdpProduct(window.pdp.currentProduct)) {
        highIndexPrice = ' +$55'
        impactResistantPrice = ' +$35'
      } else if (tintedLensColorsPricing.includes(lensColor)) {
        highIndexPrice = ' +$55'
        impactResistantPrice = ' FREE'
      }
    }
    
    // Update the text content
    if (highIndexPrice && highIndexText) {
      const baseText = highIndexText.textContent.replace(/\s*\+\$\d+\s*$/, '').replace(/\s*FREE\s*$/, '')
      highIndexText.textContent = baseText + highIndexPrice
    }
    
    if (impactResistantPrice && impactResistantText) {
      const baseText = impactResistantText.textContent.replace(/\s*\+\$\d+\s*$/, '').replace(/\s*FREE\s*$/, '')
      impactResistantText.textContent = baseText + impactResistantPrice
    }
  }
  
  function updateLensTypeAvailability() {
    if (!window.isOphthalmicPdpProduct(window.pdp.currentProduct)) return

    const ophType = window.pdp.rx['oph-type']

    const lensTypeOptions = document.querySelectorAll('#lens-type-panel .dropdown-option[data-value]')
    if (ophType === 'prescription') {
      lensTypeOptions.forEach(option => {
        if (option) {
          if (['single-vision', 'progressive'].includes(option.getAttribute('data-value'))) option.classList.remove('hidden')
          if (['+1.5', '+2.0', '+2.5'].includes(option.getAttribute('data-value'))) option.classList.add('hidden')
        }
      })
      const lensTypeDropdown = document.querySelector('.dropdown.lens-type')
      if (lensTypeDropdown) {
        lensTypeDropdown.classList.remove('hidden')
      }
      const singleVisionOption = document.querySelector('.dropdown-option[data-value="single-vision"]')
      if (singleVisionOption) {
        singleVisionOption.click()
      }
      const lensUpgradeDropdown = document.querySelector('.dropdown.lens-upgrade')
      if (lensUpgradeDropdown) {
        lensUpgradeDropdown.classList.remove('hidden')
      }
    } else if (ophType === 'readers') {
      lensTypeOptions.forEach(option => {
        if (option) {
          if (['+1.5', '+2.0', '+2.5'].includes(option.getAttribute('data-value'))) option.classList.remove('hidden')
          if (['single-vision', 'progressive'].includes(option.getAttribute('data-value'))) option.classList.add('hidden')
        }
      })
      const lensTypeDropdown = document.querySelector('.dropdown.lens-type')
      if (lensTypeDropdown) {
        lensTypeDropdown.classList.remove('hidden')
      }
      const readersOption = document.querySelector('.dropdown-option[data-value="+1.5"]')
      if (readersOption) {
        readersOption.click()
      }
      const lensUpgradeDropdown = document.querySelector('.dropdown.lens-upgrade')
      if (lensUpgradeDropdown) {
        lensUpgradeDropdown.classList.remove('hidden')
      }
    } else {
      lensTypeOptions.forEach(option => {
        if (option) {
          option.classList.add('hidden')
        }
      })
      const lensTypeDropdown = document.querySelector('.dropdown.lens-type')
      if (lensTypeDropdown) {
        lensTypeDropdown.classList.add('hidden')
      }
      const lensUpgradeDropdown = document.querySelector('.dropdown.lens-upgrade')
      if (lensUpgradeDropdown) {
        lensUpgradeDropdown.classList.add('hidden')
      }
      const singleVisionOption = document.querySelector('.dropdown-option[data-value="single-vision"]')
      if (singleVisionOption) {
        singleVisionOption.click()
      }
    }

    // Update the dropdown display to reflect current selections
    const upgradeSelect = document.querySelector('[data-dropdown="lens-upgrade"]')
    if (upgradeSelect) {
      const event = new CustomEvent('lens-upgrade:availability-changed')
      upgradeSelect.dispatchEvent(event)
    }
  }

  function normalizeRxOptionHandle(value) {
    if (value == null || value === '') return ''
    return String(value)
      .trim()
      .toLowerCase()
      .replace(/\s+/g, '-')
      .replace(/_/g, '-')
      .replace(/[\u2010-\u2015\u2212\uFE58\uFE63\uFF0D]/g, '-')
  }

  function findSelectedVariant() {
    if (!window.pdp?.currentProduct) return null
    console.log('[findSelectedVariant] Product type:', window.pdp.currentProduct.product_type)
    let selectedVariant = null
    const selectedUpgrades = Object.keys(window.pdp.rx['lens-upgrade'] || {}).filter(k => window.pdp.rx['lens-upgrade'][k])
    const withDefaultStandard = (option3) => {
      let opt3 = option3 == null ? '' : String(option3)
      const lower = opt3.toLowerCase()
      if (!(lower.includes('standard') || lower.includes('impact resistant') || lower.includes('high index'))) {
        opt3 = opt3 ? (opt3 + ' + Standard') : 'Standard'
      }
      return opt3
    }
    const matchesOphMain = (v) => {
      if (!v?.option1 || v.option2 == null) return false
      const opt3 = withDefaultStandard(v.option3)
      return (
        v.option1.toLowerCase().split(' ').join('-') === window.pdp.rx['oph-type'] &&
        v.option2.toLowerCase().split(' ').join('-') === window.pdp.rx['lens-type'] &&
        haveSameElements(opt3.split(' + ').map((o) => o.toLowerCase().split(' ').join('-')), selectedUpgrades)
      )
    }
    if (window.pdp.currentProduct.product_type === 'Prescription') {
      selectedVariant = window.pdp.currentProduct.variants?.find(v => {
        if (!v?.option1 || v.option2 == null) return false
        const opt3 = withDefaultStandard(v.option3)
        return v.option1.toLowerCase().split(' ').join('-') === window.pdp.rx['lens-type'] &&
          normalizeRxOptionHandle(v.option2) === window.pdp.rx['lens-color'] &&
          haveSameElements(opt3.split(' + ').map(o => o.toLowerCase().split(' ').join('-')), selectedUpgrades)
      })
    } else if (window.isOphthalmicPdpProduct(window.pdp.currentProduct)) {
      const ophType = window.pdp.rx['oph-type']
      const r = window.pdp.ophSplitReady
      const splitActive =
        window.pdp.ophSplitArchitecture && r && (r.main || r.bl || r.pl)

      if (splitActive) {
        if (ophType === 'blue-light') {
          selectedVariant = r.bl && window.pdp.ophSplitBlProduct ? window.pdp.ophSplitBlProduct.variants?.[0] || null : null
        } else if (ophType === 'plain') {
          selectedVariant = r.pl && window.pdp.ophSplitPlProduct ? window.pdp.ophSplitPlProduct.variants?.[0] || null : null
        } else {
          const main = window.pdp.ophMainProduct
          selectedVariant = r.main && main ? main.variants?.find(matchesOphMain) : null
        }
      } else {
        selectedVariant = window.pdp.currentProduct.variants?.find(matchesOphMain)
      }
    } else {
      selectedVariant = window.pdp.currentProduct.variants[0]
    }
    selectedVariant = selectedVariant?.price !== '0.00' ? selectedVariant : null
    setState['selectedVariant'](selectedVariant)
    return selectedVariant
  }

  window.pdpFindSelectedVariant = findSelectedVariant

  function applyAvailabilityFromFinalSelectedView(html, variantList) {
    const t = document.createElement('div')
    t.innerHTML = html
    const options = t.querySelectorAll('option')
    if (!options || !variantList) return
    options.forEach((e) => {
      const id = e.getAttribute('data-id')
      const dataAvailable = e.getAttribute('data-available')
      if (id) {
        variantList.forEach((v) => {
          if (v.id === +id) {
            v.available = dataAvailable === 'true'
          }
        })
      }
    })
  }

  function getProductVariantWithAvailability() {
    const jobs = []
    const seen = new Set()
    const addJob = (handle, variants) => {
      if (!handle || !variants || seen.has(handle)) return
      seen.add(handle)
      jobs.push({ handle, variants })
    }
    if (window.pdp.ophSplitReady?.main && window.pdp.ophMainProduct) {
      addJob(window.pdp.ophMainProduct.handle, window.pdp.ophMainProduct.variants)
    }
    if (!window.pdp.ophSplitReady?.main && window.pdp.currentProduct?.variants) {
      addJob(window.pdp.currentProduct.handle, window.pdp.currentProduct.variants)
    }
    if (window.pdp.ophSplitReady?.bl && window.pdp.ophSplitBlProduct) {
      addJob(window.pdp.ophSplitBlProduct.handle, window.pdp.ophSplitBlProduct.variants)
    }
    if (window.pdp.ophSplitReady?.pl && window.pdp.ophSplitPlProduct) {
      addJob(window.pdp.ophSplitPlProduct.handle, window.pdp.ophSplitPlProduct.variants)
    }
    if (!jobs.length) return Promise.resolve()
    return jobs.reduce(
      (p, job) =>
        p.then(() =>
          fetch(`/products/${job.handle}?view=final_selected_variant`)
            .then((res) => res.text())
            .then((data) => applyAvailabilityFromFinalSelectedView(data, job.variants))
        ),
      Promise.resolve()
    )
  }

  function productJsonIncludesLensColorImageAsset(product, lensColorDisplayToken) {
    if (!product || !lensColorDisplayToken) return false
    const needle = String(lensColorDisplayToken).toLowerCase()
    const images = product.images
    if (Array.isArray(images)) {
      for (let i = 0; i < images.length; i++) {
        const im = images[i]
        const src = im && typeof im.src === 'string' ? im.src : (typeof im === 'string' ? im : '')
        if (src && src.toLowerCase().indexOf(needle) !== -1) return true
      }
    }
    const variants = product.variants
    if (Array.isArray(variants)) {
      for (let j = 0; j < variants.length; j++) {
        const src = variants[j] && variants[j].featured_image && variants[j].featured_image.src
        if (src && String(src).toLowerCase().indexOf(needle) !== -1) return true
      }
    }
    return false
  }

  /**
   * Image src from a collection product JSON whose filename is shot `slot` ('01'/'02') with exactly
   * lens color `lensHandle` after `_Rx_` (so "brown" does not match "photochromic-brown"). Allows a
   * suffix after the color (e.g. a Shopify upload uuid). Shopify renames uploaded videos, so a video
   * is matched on its alt text instead (e.g. `HUDSON_Nightfall_02_Rx_Photochromic-Gray`) and
   * resolves to its preview image. Images win over videos. Returns '' when the product has none.
   */
  function findRxSlideImageSrc(product, slot, lensHandle) {
    if (!product || !lensHandle) return ''
    const colors = Array.from(new Set([lensHandle, lensHandle.replaceAll('-', '')]))
    const entries = []
    const add = (src, name) => {
      if (src) entries.push({ src, file: String(name).split('?')[0].split('/').pop().toLowerCase() })
    }
    ;(product.images || []).forEach(im => {
      const src = typeof im === 'string' ? im : im && im.src
      add(src, src)
    })
    ;(product.variants || []).forEach(v => {
      const src = v && v.featured_image && v.featured_image.src
      add(src, src)
    })
    ;(product.media || []).forEach(m => {
      if (m && m.media_type === 'video' && m.alt) add(m.src, m.alt)
    })
    const hit = entries.find(({ file }) => {
      const parts = file.split('_' + slot + '_rx_')
      if (parts.length < 2) return false
      const after = parts.pop()
      return colors.some(c => after === c || after.startsWith(c + '_') || after.startsWith(c + '.'))
    })
    return hit ? hit.src : ''
  }

  function replaceSrcWithColor(element) {
    const slides = element.querySelectorAll('.swiper-slide')
    slides.forEach(s => {
      const handle = s.getAttribute('data-product-handle')
      const catalogImg = (u) => (typeof window.resolveShopifyCdnMediaFromCatalog === 'function'
        ? window.resolveShopifyCdnMediaFromCatalog(u, handle)
        : u)
      const image01 = s.querySelector('img.other-products-image-01')
      const image02 = s.querySelector('img.other-products-image-02')
      if (window.pdp.currentProduct.product_type === 'Prescription') {
        // Replace lens color in image URL if lens color is selected
        const lensColor = window.pdp.rx?.['lens-color']
        if (lensColor) {
          // Pattern: STYLE-NAME_frame-name_2digitnumber(_Rx_ or _BlueLight_ or empty)(_Clear_ or _Brown_ or _Black_ or _Coastal-Blue_ or _Rose-Pink_ or _Silver_)(some letters or empty).jpg(some other string)
          // Replace any existing lens color with current lens color
          const colorMapping = {
            'clear': 'Clear',
            'black': 'Black',
            'brown': 'Brown',
            'coastal-blue': 'Coastal-Blue', 
            'rose-pink': 'Rose-Pink',
            'silver': 'Silver',
            'yellow': 'Yellow',
            'green-vibrant': 'Green-Vibrant',
            'purple-pastel': 'Purple-Pastel',
            'photochromic-gray': 'Photochromic-Gray',
            'photochromic-brown': 'Photochromic-Brown',
          }
          const newColor = colorMapping[lensColor]

          function replaceImageColorToken(url, targetColor) {
            if (!url || !targetColor) return url
            const withColor = url.replace(
              /(Photochromic-Gray|Photochromic-Brown|Coastal-Blue|Rose-Pink|Green-Vibrant|Purple-Pastel|Clear|Black|Brown|Silver|Yellow)/gi,
              targetColor
            )
            return catalogImg(withColor)
          }

          // Guessed URLs may not exist (e.g. GIF uploads with a unique suffix), so only swap
          // once the guessed image has actually loaded; otherwise keep the current image.
          function swapWhenLoaded(img, url) {
            if (!img || !url || url === img.src) return
            const probe = new Image()
            probe.onload = () => { img.src = url }
            probe.src = url
          }

          function applyTokenReplaceFallback() {
            if (!newColor || !image02?.src || !image01?.src) return
            swapWhenLoaded(image02, replaceImageColorToken(image02.src, newColor))
            swapWhenLoaded(image01, replaceImageColorToken(image01.src, newColor))
          }
          
          // Wait for mainCollectionProducts to be available
          var attempts1 = 0
          var intervalId1 = setInterval(() => {
            attempts1++
            const productsReady = window.pdp.mainCollectionProducts && window.pdp.mainCollectionProducts.length > 0
            if (!productsReady && attempts1 < 50) return

            if (!productsReady) {
              applyTokenReplaceFallback()
              clearInterval(intervalId1)
              return
            }

            const product = window.pdp.mainCollectionProducts.find(p => p.handle === handle)
            // After a size switch the slider is rebuilt before mainCollectionProducts is
            // replaced with the new size's collection, so keep waiting for this handle
            if (!product && attempts1 < 50) return
            if (!product) {
              applyTokenReplaceFallback()
              clearInterval(intervalId1)
              return
            }

            const lensHandle = normalizeRxOptionHandle(lensColor)
            const variant = product.variants && product.variants.find(v =>
              normalizeRxOptionHandle(v.option2) === lensHandle
            )
            if (image02 && image01) {
              // Pick real catalog files: uploads can carry a unique suffix
              // (_Rx_Photochromic-brown_<uuid>.gif), so guessing _02_ -> _01_ or a color token 404s.
              // A frame without images for this lens color shows its Clear images instead.
              let src02 = findRxSlideImageSrc(product, '02', lensHandle) || variant?.featured_image?.src
              let src01 = findRxSlideImageSrc(product, '01', lensHandle)
              if (!src02) {
                src02 = findRxSlideImageSrc(product, '02', 'clear')
                src01 = findRxSlideImageSrc(product, '01', 'clear')
              }
              if (src02) {
                image02.src = catalogImg(src02)
                image01.src = catalogImg(src01 || src02)
              }
            }
            clearInterval(intervalId1)
          }, 100)
        }
      } else if (window.isOphthalmicPdpProduct(window.pdp.currentProduct)) {
        // Replace lens color in image URL if lens color is selected
        const ophType = window.pdp.rx?.['oph-type']
        if (ophType) {
          const typeMapping = {
            'prescription': 'Prescription',
            'readers': 'Readers',
            'blue-light': 'Blue Light',
            'plain': 'Plain', 
          }
          const newType = typeMapping[ophType]

          // Wait for mainCollectionProducts to be available
          var intervalId2 = setInterval(() => {
            if (window.pdp.mainCollectionProducts && window.pdp.mainCollectionProducts.length > 0) {
              const product = window.pdp.mainCollectionProducts.find(p => p.handle === handle)
              if (!product) {
                return
              }
              if (product) {
                const variant = product.variants.find(v => v.option1 === newType)
                if (!variant) {
                  return
                }
                if (variant && variant.featured_image && image02 && image01) {
                  image02.src = catalogImg(variant.featured_image.src)
                  image01.src = catalogImg(variant.featured_image.src.replace('_02.', '_01.').replace('_02_', '_01_'))
                  clearInterval(intervalId2)
                }
              }
            }
          }, 100)
        }
      }
    })
    return element
  }

  function sepDesignSlideMediaText(slide, img) {
    if (!slide) return ''
    const imageEl = img || slide.querySelector('img')
    const parts = []
    if (imageEl?.src) parts.push(String(imageEl.src))
    if (imageEl?.getAttribute('alt')) parts.push(imageEl.getAttribute('alt'))
    ;[slide, slide.querySelector('[data-html5-video]'), slide.querySelector('.image-wrapper')].forEach((el) => {
      if (!el) return
      const label = el.getAttribute('data-sep-design-media-label')
      if (label) parts.push(label)
      const sourceName = el.getAttribute('data-video-source-name')
      if (sourceName) parts.push(sourceName)
    })
    const cap = slide.querySelector('.image-wrapper')?.getAttribute('data-caption')
    if (cap) parts.push(cap)
    const video = slide.querySelector('video')
    if (video?.getAttribute('title')) parts.push(video.getAttribute('title'))
    video?.querySelectorAll('source').forEach((source) => {
      if (source.src) parts.push(source.src)
    })
    return parts.join(' ').toLowerCase()
  }

  function sepDesignHasVideo360Marker(text) {
    if (!text) return false
    return /video[\s_-]?360/.test(String(text).toLowerCase())
  }

  /** Lifestyle / on-model shots are not named like Rx color or OPH type tokens; keep them visible whenever filtering slides. */
  function isSepDesignLifestyleSlide(slide, img) {
    const text = sepDesignSlideMediaText(slide, img)
    if (!text) return false
    return (
      text.includes('lifestyle') ||
      text.includes('life style') ||
      text.includes('life-style')
    )
  }

  /** product.media video slides stay visible across oph-type filters and are pinned to slide 2. */
  function isSepDesignVideo360Slide(slide, img) {
    if (!slide) return false
    if (slide.getAttribute('data-video-360') === 'true') return true
    if (slide.querySelector('[data-video-360="true"]')) return true
    if (slide.getAttribute('data-media-type') === 'video') return true
    if (slide.querySelector('[data-media-type="video"]')) return true
    if (slide.querySelector('[data-html5-video]')) return true
    if (slide.querySelector('.media-badge[data-icon="video-thumbnail"]')) return true
    const sourceName = slide.getAttribute('data-video-source-name') ||
      slide.querySelector('[data-video-source-name]')?.getAttribute('data-video-source-name')
    if (sepDesignHasVideo360Marker(sourceName)) return true
    return sepDesignHasVideo360Marker(sepDesignSlideMediaText(slide, img))
  }

  /**
   * After visibility toggles: first visible regular slide, Video_360 at 2nd, lifestyle at 3rd (when present),
   * then other visible product slides, slim-hard-case, then hidden slides last.
   * Without Video_360: first two visible regular slides, then lifestyle(s) (unchanged).
   * Hidden slides stay after the case so activeIndex is never a display:none slide between
   * the last product shot and the case (that desynced mobile pagination dots).
   */
  function reorderLifestyleSlidesToThird(swiperRootEl) {
    if (!swiperRootEl) return
    const swiperWrapper = swiperRootEl.querySelector('.swiper-wrapper')
    if (!swiperWrapper) return
    const all = [...swiperWrapper.querySelectorAll(':scope > .swiper-slide')]
    if (all.length < 2) return

    const caseSlide = all.find((el) => el.getAttribute('data-special-slide') === 'slim-hard-case')
    const productSlides = all.filter((el) => el !== caseSlide)
    const isHidden = (el) => el.classList.contains('hidden')
    const visibleSlides = productSlides.filter((el) => !isHidden(el))
    const hiddenSlides = productSlides.filter(isHidden)

    const visibleRegular = []
    const visibleVideo360 = []
    const visibleLif = []
    visibleSlides.forEach((slide) => {
      const img = slide.querySelector('img')
      if (isSepDesignVideo360Slide(slide, img)) visibleVideo360.push(slide)
      else if (isSepDesignLifestyleSlide(slide, img)) visibleLif.push(slide)
      else visibleRegular.push(slide)
    })

    if (visibleLif.length === 0 && visibleVideo360.length === 0) {
      visibleSlides.forEach((slide) => swiperWrapper.appendChild(slide))
      if (caseSlide) swiperWrapper.appendChild(caseSlide)
      hiddenSlides.forEach((slide) => swiperWrapper.appendChild(slide))
      return
    }

    const leadingRegularCount = visibleVideo360.length > 0 ? 1 : 2
    const ordered = []
    ordered.push(...visibleRegular.slice(0, leadingRegularCount))
    if (visibleVideo360.length > 0) ordered.push(...visibleVideo360)
    ordered.push(...visibleLif)
    ordered.push(...visibleRegular.slice(leadingRegularCount))
    ordered.forEach((slide) => swiperWrapper.appendChild(slide))
    if (caseSlide) swiperWrapper.appendChild(caseSlide)
    hiddenSlides.forEach((slide) => swiperWrapper.appendChild(slide))
  }

  function sepDesignSlideMediaKey(slide) {
    if (!slide) return null
    const special = slide.getAttribute('data-special-slide')
    if (special) return 'special:' + special
    const imageWrapper = slide.querySelector('.image-wrapper')
    let dataIndex = imageWrapper?.getAttribute('data-index')
    if (dataIndex != null && dataIndex !== '') return 'idx:' + dataIndex
    const video = slide.querySelector('[data-html5-video][data-index]')
    dataIndex = video?.getAttribute('data-index')
    if (dataIndex != null && dataIndex !== '') return 'idx:' + dataIndex
    const img = slide.querySelector('img')
    if (img?.src) {
      try {
        const file = new URL(img.src, window.location.origin).pathname.split('/').pop().split('?')[0]
        if (file) return 'file:' + file
      } catch (e) { /* ignore */ }
    }
    return null
  }

  function copySepDesignSliderSlideStateFromThumb(thumbRoot, mainRoot) {
    const thumbWrapper = thumbRoot?.querySelector('.swiper-wrapper')
    const mainWrapper = mainRoot?.querySelector('.swiper-wrapper')
    if (!thumbWrapper || !mainWrapper) return

    const mainByKey = new Map()
    mainWrapper.querySelectorAll(':scope > .swiper-slide').forEach((slide) => {
      const key = sepDesignSlideMediaKey(slide)
      if (key) mainByKey.set(key, slide)
    })

    thumbWrapper.querySelectorAll(':scope > .swiper-slide').forEach((thumbSlide) => {
      const key = sepDesignSlideMediaKey(thumbSlide)
      const mainSlide = key && mainByKey.get(key)
      if (!mainSlide) return
      mainSlide.classList.toggle('hidden', thumbSlide.classList.contains('hidden'))
      mainSlide.classList.toggle(
        'swiper-slide-custom-active',
        thumbSlide.classList.contains('swiper-slide-custom-active')
      )
    })
  }

  function syncSepDesignMainSlideOrderFromThumb(thumbWrapper, mainWrapper) {
    if (!thumbWrapper || !mainWrapper) return

    const mainByKey = new Map()
    mainWrapper.querySelectorAll(':scope > .swiper-slide').forEach((slide) => {
      const key = sepDesignSlideMediaKey(slide)
      if (key) mainByKey.set(key, slide)
    })

    const orderedMainSlides = []
    const usedKeys = new Set()
    thumbWrapper.querySelectorAll(':scope > .swiper-slide').forEach((thumbSlide) => {
      const key = sepDesignSlideMediaKey(thumbSlide)
      const mainSlide = key && mainByKey.get(key)
      if (mainSlide) {
        orderedMainSlides.push(mainSlide)
        usedKeys.add(key)
      }
    })

    mainWrapper.querySelectorAll(':scope > .swiper-slide').forEach((slide) => {
      const key = sepDesignSlideMediaKey(slide)
      if (key && !usedKeys.has(key)) orderedMainSlides.push(slide)
    })

    orderedMainSlides.forEach((slide) => mainWrapper.appendChild(slide))
  }

  function resolveSepDesignSliderHandle(preferredHandle) {
    const activeHandle = getSepDesignActiveSliderHandle()
    const hasSwiper = (handle) =>
      handle && window.pdp.swipers[handle]?.swiper && window.pdp.swipers[handle]?.thumbSwiper

    if (hasSwiper(activeHandle)) return activeHandle
    if (hasSwiper(preferredHandle)) return preferredHandle

    const currentHandle = window.pdp.currentProduct?.handle
    if (hasSwiper(currentHandle)) return currentHandle

    if (window.pdp.ophSplitArchitecture) {
      const role = window.pdp.ophSplitRole
      if (role === 'bl' && hasSwiper(window.pdp.ophSplitBlHandle)) return window.pdp.ophSplitBlHandle
      if (role === 'pl' && hasSwiper(window.pdp.ophSplitPlHandle)) return window.pdp.ophSplitPlHandle
      if (hasSwiper(window.pdp.ophMainHandle)) return window.pdp.ophMainHandle
    }

    return activeHandle || preferredHandle
  }

  function sepDesignSlideIndexInWrapper(wrapper, targetSlide) {
    if (!wrapper || !targetSlide) return -1
    const slides = wrapper.querySelectorAll(':scope > .swiper-slide')
    return Array.from(slides).indexOf(targetSlide)
  }

  function sepDesignFirstVisibleActiveSlide(wrapper) {
    if (!wrapper) return null
    let fallback = null
    const slides = wrapper.querySelectorAll(':scope > .swiper-slide')
    for (let i = 0; i < slides.length; i++) {
      const slide = slides[i]
      if (slide.classList.contains('hidden')) continue
      if (slide.classList.contains('swiper-slide-custom-active')) return slide
      if (!fallback) fallback = slide
    }
    return fallback
  }

  /** Keep main + thumb swipers on the same slide after oph-type / color filters. */
  function syncSepDesignMainAndThumbSliders(sliderHandle) {
    sliderHandle = resolveSepDesignSliderHandle(sliderHandle)
    const s = sliderHandle && window.pdp.swipers[sliderHandle]
    if (!s?.swiper || !s?.thumbSwiper) return false

    const thumbRoot = s.thumbSwiper.el
    const mainRoot = s.swiper.el
    const pt = thumbRoot.getAttribute('data-product-type')
    if (pt !== 'ophthalmic' && pt !== 'prescription') return false

    applySepDesignSliderVisibility(thumbRoot, sliderHandle)
    copySepDesignSliderSlideStateFromThumb(thumbRoot, mainRoot)

    const thumbWrapper = thumbRoot.querySelector('.swiper-wrapper')
    const mainWrapper = mainRoot.querySelector('.swiper-wrapper')
    if (!thumbWrapper || !mainWrapper) return false

    reorderLifestyleSlidesToThird(thumbRoot)
    syncSepDesignMainSlideOrderFromThumb(thumbWrapper, mainWrapper)

    const activeThumb = sepDesignFirstVisibleActiveSlide(thumbWrapper)
    if (!activeThumb) return false

    const mediaKey = sepDesignSlideMediaKey(activeThumb)
    const thumbSlideIndex = sepDesignSlideIndexInWrapper(thumbWrapper, activeThumb)
    let mainSlideIndex = thumbSlideIndex
    if (mediaKey) {
      mainWrapper.querySelectorAll(':scope > .swiper-slide').forEach((slide, i) => {
        if (sepDesignSlideMediaKey(slide) === mediaKey) mainSlideIndex = i
      })
    }
    if (thumbSlideIndex < 0) return false

    const markActive = (slide, i, activeIndex) => {
      slide.classList.toggle('swiper-slide-custom-active', i === activeIndex)
    }
    thumbWrapper.querySelectorAll(':scope > .swiper-slide').forEach((slide, i) => {
      markActive(slide, i, thumbSlideIndex)
    })
    mainWrapper.querySelectorAll(':scope > .swiper-slide').forEach((slide, i) => {
      markActive(slide, i, mainSlideIndex)
    })

    s.thumbSwiper.update()
    s.swiper.update()
    forceSwiperSlideTo(s.thumbSwiper, thumbSlideIndex)
    forceSwiperSlideTo(s.swiper, mainSlideIndex)
    if (typeof s.syncPagination === 'function') s.syncPagination()
    return true
  }

  function srcMatchesRxLensColor(src, newColor) {
    if (!src || !newColor) return false
    const parts = String(src).split('_Rx_')
    if (parts.length < 2) return false
    const after = parts.pop().split(/[?#]/)[0].toLowerCase()
    const color = String(newColor).toLowerCase()
    // Exact token after _Rx_ (avoids "brown" matching "photochromic-brown")
    return after === color || after.startsWith(color + '_') || after.startsWith(color + '.')
  }

  /**
   * What an Rx slide's lens color is read from: its image src, or for a video whose alt carries an
   * `_Rx_` lens token (e.g. `HUDSON_Nightfall_02_Rx_Photochromic-Gray`) that alt, since Shopify
   * renames uploaded videos and their src never carries the original filename.
   */
  function rxSlideMediaName(slide, img) {
    const alt = slide.getAttribute('data-media-type') === 'video' ? slide.getAttribute('data-media-alt') || '' : ''
    if (alt.indexOf('_Rx_') !== -1) return alt
    return img ? img.src : ''
  }

  function toggleSlidersWithColor(element) {
    const slides = element.querySelectorAll('.swiper-slide')
    let customActiveSlideSet = false
    slides.forEach(slide => {
      const img = slide.querySelector('img')
      if (window.pdp.currentProduct.product_type === 'Prescription') {
        const lensColor = window.pdp.rx?.['lens-color'] ? window.pdp.rx?.['lens-color'] : 'clear'
        const mediaName = rxSlideMediaName(slide, img)
        if (mediaName && lensColor) {
          const colorMapping = {
            'clear': 'Clear',
            'black': 'Black',
            'brown': 'Brown',
            'coastal-blue': 'Coastal-Blue', 
            'rose-pink': 'Rose-Pink',
            'silver': 'Silver',
            'yellow': 'Yellow',
            'green-vibrant': 'Green-Vibrant',
            'purple-pastel': 'Purple-Pastel',
            'photochromic-gray': 'Photochromic-Gray',
            'photochromic-brown': 'Photochromic-Brown',
          }
          const newColor = colorMapping[lensColor]
          const isCase = slide.getAttribute('data-special-slide') === 'slim-hard-case'
          const isLifestyle = isSepDesignLifestyleSlide(slide, img)
          // A video tagged with an Rx lens color belongs to that color, not to every color
          const isLensColorVideo = mediaName.indexOf('_Rx_') !== -1 && slide.getAttribute('data-media-type') === 'video'
          const isVideo360 = !isLensColorVideo && isSepDesignVideo360Slide(slide, img)
          if (slide) {
            if (!isCase && !isLifestyle && !isVideo360) slide.classList.add('hidden')
            slide.classList.remove('swiper-slide-custom-active')
            const matchesLensColor = srcMatchesRxLensColor(mediaName, newColor)
            if (isLifestyle || isVideo360) {
              slide.classList.remove('hidden')
            } else if (matchesLensColor) {
              slide.classList.remove('hidden')
              if (!customActiveSlideSet) {
                slide.classList.add('swiper-slide-custom-active')
                customActiveSlideSet = true
              }
            }
            if (slide.classList.contains('hidden')) slide.querySelectorAll('video').forEach(video => video.pause())
          }
        }
      } else if (window.isOphthalmicPdpProduct(window.pdp.currentProduct)) {
        const ophType = getEffectiveOphTypeForSliders()
        const isCase = slide.getAttribute('data-special-slide') === 'slim-hard-case'
        const isLifestyle = isSepDesignLifestyleSlide(slide, img)
        const isVideo360 = isSepDesignVideo360Slide(slide, img)
        if (slide) {
          if (!isCase && !isLifestyle && !isVideo360) slide.classList.add('hidden')
          else if (isCase) {
            if (ophType === 'blue-light') slide.classList.add('hidden')
            else slide.classList.remove('hidden')
          }
          slide.classList.remove('swiper-slide-custom-active')
          const matchesOphType = img && sepDesignMatchesOphType(img, ophType)
          if (isLifestyle || isVideo360) {
            slide.classList.remove('hidden')
          } else if (matchesOphType) {
            slide.classList.remove('hidden')
            if (!customActiveSlideSet) {
              slide.classList.add('swiper-slide-custom-active')
              customActiveSlideSet = true
            }
          }
        }
      }
    })
  }

  /** Dots are built before slides are filtered, so CSS keeps them hidden until the first filter pass. */
  function revealMainSliderPagination(handle) {
    const s = handle && window.pdp.swipers?.[handle]
    const pagination = s?.swiper?.el?.closest('.mainslider-wrapper')?.querySelector('.sep-main-pagination')
    if (pagination) pagination.classList.add('is-ready')
  }

  function changeSliderImages() {
    const sliderHandle = getSepDesignActiveSliderHandle()
    const otherRoot = document.querySelector('.product__information_block.other-products')
    if (otherRoot && sliderHandle && !otherRoot.querySelector(`.swiper-slide[data-product-handle="${sliderHandle}"].swiper-slide-custom-active`)) {
      document.querySelectorAll('.swiper-slide-custom-active').forEach(s => {
        s.classList.remove('swiper-slide-custom-active')
      })
      const currentSlide = otherRoot.querySelector('.swiper-slide[data-product-handle="' + sliderHandle + '"]')
      if (currentSlide) {
        const swiperWrapper = currentSlide.closest('.swiper-wrapper')
        if (swiperWrapper) {
          swiperWrapper.querySelectorAll('.swiper-slide').forEach((s, i) => {
            if (s && s.getAttribute('data-product-handle') === sliderHandle) {
              s.classList.add('swiper-slide-custom-active')
              if (window.pdp.mainCollection && window.pdp.swipers[window.pdp.mainCollection]?.swiper) {
                window.pdp.swipers[window.pdp.mainCollection].swiper.slideTo(i)
              }
            }
          })
        }
      }
    }

    if (window.isOphOrRxPdpProduct(window.pdp.currentProduct)) {
      Object.values(window.pdp.swipers).forEach(s => {
        if (s.swiper && !s.thumbSwiper) {
          const element = s.swiper.el
          if (element && (s.swiper.el.getAttribute('data-product-type') === 'ophthalmic' || s.swiper.el.getAttribute('data-product-type') === 'prescription')) {
            replaceSrcWithColor(element)
          }
        }
      })
      if (window.pdp.ophSplitArchitecture && window.isOphthalmicPdpProduct(window.pdp.currentProduct)) {
        switchMainSliderForHandle(sliderHandle, (handle) => {
          syncSepDesignMainAndThumbSliders(handle)
          syncOphthalmicGlassonAppBlock()
          revealMainSliderPagination(handle)
        })
        return
      } else {
        const s = sliderHandle && window.pdp.swipers[sliderHandle]
        if (s && s.swiper && s.thumbSwiper && s.thumbSwiper.el) {
          const pt = s.thumbSwiper.el.getAttribute('data-product-type')
          if (pt === 'ophthalmic' || pt === 'prescription') {
            syncSepDesignMainAndThumbSliders(sliderHandle)
          }
        }
      }
    } else if (sliderHandle && window.pdp.swipers[sliderHandle]) {
      window.pdp.swipers[sliderHandle].thumbSwiper.el.querySelectorAll('.swiper-slide').forEach(slide => {
        slide.classList.remove('swiper-slide-custom-active')
        if (slide.classList.contains('swiper-slide-active')) slide.classList.add('swiper-slide-custom-active')
      })
    }
    revealMainSliderPagination(sliderHandle)
  }

  function checkEditMode() {
    const url = new URL(window.location.href);
    const searchParams = new URLSearchParams(url.search);
    if (searchParams.has('edit')) {
      window.pdp.editMode = true
      window.pdp.editVariant = {
        id: searchParams.get('edit'),
        qty: searchParams.get('qty')
      }
    } else {
      window.pdp.editMode = false
    }
    updateATCText()
  }

  function readFromVariantParam() {
    window.pdp.lock.variantParam = true
    const url = new URL(window.location)
    const variantId = url.searchParams.get('variant')

    if (variantId && (window.isOphOrRxPdpProduct(window.pdp.currentProduct))) {
      setState['variant-id'](variantId)
      let selectedVariant = window.pdp.currentProduct.variants.find(v => v.id === +variantId)
      if (!selectedVariant && window.pdp.ophMainProduct) {
        selectedVariant = window.pdp.ophMainProduct.variants?.find(v => v.id === +variantId)
      }
      if (!selectedVariant && window.pdp.ophSplitArchitecture && window.pdp.ophSplitBlProduct) {
        selectedVariant = window.pdp.ophSplitBlProduct.variants?.find(v => v.id === +variantId)
      }
      if (!selectedVariant && window.pdp.ophSplitArchitecture && window.pdp.ophSplitPlProduct) {
        selectedVariant = window.pdp.ophSplitPlProduct.variants?.find(v => v.id === +variantId)
      }
      if (selectedVariant) {
        if (window.pdp.ophSplitArchitecture && window.pdp.ophSplitBlProduct?.variants?.some(v => v.id === selectedVariant.id)) {
          document.querySelector('.dropdown-option[data-value="blue-light"]')?.click()
        } else if (window.pdp.ophSplitArchitecture && window.pdp.ophSplitPlProduct?.variants?.some(v => v.id === selectedVariant.id)) {
          document.querySelector('.dropdown-option[data-value="plain"]')?.click()
        } else {
          // update rx information
          document.querySelector(`.dropdown-option[data-value="${normalizeRxOptionHandle(selectedVariant.option1)}"]`)?.click()
          document.querySelector(`.dropdown-option[data-value="${normalizeRxOptionHandle(selectedVariant.option2)}"]`)?.click()
          // lens upgrades
          const lensUpgrades = selectedVariant.option3.toLowerCase().split(' + ').map(o => o.toLowerCase().split(' ').join('-'))
          if (!lensUpgrades.includes('impact-resistant') && !lensUpgrades.includes('high-index')) {
            lensUpgrades.push('standard')
          }
          lensUpgrades.forEach(upgrade => {
            document.querySelector(`#lens-upgrade-panel .dropdown-option[data-value="${upgrade}"]`)?.click()
          })
        }
      }
    } else {
      document.querySelector('.dropdown-option[data-value="standard"]')?.click()
    }
    if (window.pdp.currentProduct?.product_type === 'Prescription') {
      applyRxLensColorFromUrlIfApplicable()
    }
    window.pdp.lock.variantParam = false
  }

  function runAllScripts(target, options) {
    const forceReexecute = !!(options && options.forceReexecute)
    const scripts = target.querySelectorAll('script')
    scripts.forEach(script => {
      const newScript = document.createElement('script')
      if (script.src) {
        // Module scripts run once per URL per document, so a unique query is
        // needed when re-mounting a widget that already booted on first paint
        newScript.src =
          forceReexecute && script.type === 'module'
            ? script.src + (script.src.includes('?') ? '&' : '?') + '_pdp=' + Date.now()
            : script.src
      } else {
        newScript.textContent = script.textContent
      }
      if (script.type) {
        newScript.type = script.type
      }
      if (script.async) {
        newScript.async = script.async
      }
      if (script.defer) {
        newScript.defer = script.defer
      }
      document.head.appendChild(newScript)
      document.head.removeChild(newScript)
    })
  }

  function getCompareSection() {
    // compare section rendering
    if (!window.pdp.currentProduct.handle) return
    fetchSectionHtml(`/products/${window.pdp.currentProduct.handle}?section_id=compare-section`).then(res => {
      const parsed = document.createElement('div')
      parsed.innerHTML = res
      const compareSection = document.querySelector('.shopify-section.compare-section .product-compare')
      if (compareSection) {
        const parsedCompare = parsed.querySelector('.product-compare')
        if (parsedCompare) {
          compareSection.innerHTML = parsedCompare.innerHTML
          const missing = 3 - compareSection.querySelectorAll('.product-item').length
          if (missing > 0) {
            const dest = compareSection.querySelector('.product-items')
            if (dest) {
              fetchSectionHtml(`/recommendations/products?product_id=${window.pdp.currentProduct.id}&section_id=compare-section-recommended&limit=${missing}`).then(res => {
                const elem = document.createElement('div')
                elem.innerHTML = res
                const target = elem.querySelectorAll('div.product-item')
                for (let i = 0; i < target.length; i++) {
                  const targetElem = target[i];
                  if (targetElem) {
                    dest.appendChild(targetElem)
                  }
                }
              })
            }
          }
        }
      }
    })
    // compare section rendering: END
  }

  /** Glasson VTO expects `len-color-id` (underscore form), same as assets/rx-product.js */
  function syncGlassonTryOnLenColorIdFromRxState() {
    const el = document.querySelector('glasson-try-on')
    if (!el) return
    const raw = window.pdp?.rx?.['lens-color']
    const handle = normalizeRxOptionHandle(raw || '')
    if (!handle) {
      el.removeAttribute('len-color-id')
      return
    }
    el.setAttribute('len-color-id', handle.replace(/-/g, '_'))
  }

  /** Main product owns Glasson models on ophthalmic split PDPs (-bl / -pl siblings). */
  function getGlassonSourceHandleForOphSplit() {
    if (
      window.pdp.ophSplitArchitecture &&
      window.isOphthalmicPdpProduct(window.pdp.currentProduct) &&
      window.pdp.ophMainHandle
    ) {
      return window.pdp.ophMainHandle
    }
    return null
  }

  /** Render Try-On / 360 into the visible slider container on split ophthalmic PDPs. */
  function getGlassonAppBlockTargetHandle() {
    const ophMainHandle = getGlassonSourceHandleForOphSplit()
    if (ophMainHandle) {
      return getSepDesignActiveSliderHandle() || ophMainHandle
    }
    return window.pdp.currentProduct?.handle
  }

  function parseGlassonPdataFromHtml(html) {
    const t = document.createElement('div')
    t.innerHTML = html
    return {
      glassonUserId: t.querySelector('.glass-on-user-id')?.innerHTML?.trim() || '',
      glassonProductId: t.querySelector('.glass-on-product-id')?.innerHTML?.trim() || '',
      glassonVtoEnabled: t.querySelector('.glass-on-vto-enabled')?.innerHTML?.trim() || '',
      selectedProductId: t.querySelector('.product-id')?.innerHTML?.trim() || ''
    }
  }

  function applyGlassonFromPdataHtml(html) {
    const parsed = parseGlassonPdataFromHtml(html)
    getGlassOnAppBlock(
      parsed.selectedProductId,
      parsed.glassonUserId,
      parsed.glassonProductId,
      parsed.glassonVtoEnabled
    )
  }

  function syncOphthalmicGlassonAppBlock() {
    const sourceHandle = getGlassonSourceHandleForOphSplit()
    if (!sourceHandle) return Promise.resolve(false)

    window.pdp.glassonPdataByHandle = window.pdp.glassonPdataByHandle || {}
    const cached = window.pdp.glassonPdataByHandle[sourceHandle]
    if (cached) {
      applyGlassonFromPdataHtml(cached)
      return Promise.resolve(true)
    }

    return fetch(`/products/${sourceHandle}?view=pdata`)
      .then((res) => res.text())
      .then((html) => {
        window.pdp.glassonPdataByHandle[sourceHandle] = html
        applyGlassonFromPdataHtml(html)
        return true
      })
      .catch((err) => {
        console.error('Error loading Glasson pdata:', err)
        return false
      })
  }

  function getGlassOnAppBlock(productId, userId, groupId, vtoEnabled) {
    console.log('----------------------')
    console.log('productId', productId)
    console.log('userId', userId)
    console.log('groupId', groupId)
    console.log('vtoEnabled', vtoEnabled)
    console.log('----------------------')

    const targetHandle = getGlassonAppBlockTargetHandle()
    const target = targetHandle
      ? document.querySelector('.atc_app_blocks.handle-' + targetHandle)
      : null

    if (!target) return

    if (getGlassonSourceHandleForOphSplit()) {
      document.querySelectorAll('.product__sep-design__mainSlider .atc_app_blocks').forEach((block) => {
        if (!block.classList.contains('handle-' + targetHandle)) block.innerHTML = ''
      })
    }

    if (!productId || !userId || !groupId || !vtoEnabled) {
      target.innerHTML = ''
      return
    }

    const glassOnBlockHTML = '<div id="shopify-block-AYitjV1ZnTTdLQUtaQ__glasson_app_block_both_UXwFF9" class="shopify-block shopify-app-block"> <link href="//cdn.shopify.com/extensions/c62fcfee-4211-441b-94c6-c36f4b59972c/glasson-79/assets/app.css" rel="stylesheet" type="text/css" media="all"> <div class="glasson-wrap" style="justify-content: center;"> <button class="glasson-btn glasson-btn-live" style="color: #1f2937; border-color: #1f2937; background-color: ;" onclick="window.openTryOn(event, \'live\')"> <!-- BEGIN app snippet: icon-tryon --> <svg width="26" height="17" viewBox="0 0 26 17" fill="currentColor" xmlns="http://www.w3.org/2000/svg"> <path d="M25.99 10.957v-.13l-.593-7.974C25.27 1.169 24.023 0 22.343 0h-2.047c-.158 0-.316.02-.435.11a.532.532 0 0 0-.238.415.46.46 0 0 0 .178.436c.129.1.306.139.495.149h2.056c.544 0 1.008.178 1.345.475.336.307.554.752.593 1.297.178 2.12.316 4.23.484 6.35.02.258.03.525.049.783.02.209.03.406.039.624h-.238c-.167-1.11-.534-2.061-1.146-2.833-.622-.803-1.483-1.397-2.6-1.734-1.335-.406-2.54-.376-3.618.05-1.038.425-1.928 1.199-2.679 2.278-1.058-.565-2.115-.555-3.144.01-.692-1-1.503-1.734-2.452-2.17-.979-.456-2.096-.565-3.332-.298-1.265.278-2.243.842-2.955 1.675-.682.793-1.117 1.822-1.325 3.032h-.218c0-.1-.01-.178 0-.258.039-.575.09-1.159.128-1.733.04-.575.09-1.16.129-1.734.109-1.387.187-2.764.326-4.141.09-.99.87-1.665 1.868-1.665H5.72a.81.81 0 0 0 .425-.1c.138-.089.218-.237.237-.435a.473.473 0 0 0-.187-.426C6.077.057 5.9.018 5.712.018H3.568C2.048.03.782 1.148.654 2.675.515 4.15.426 5.646.307 7.123L.16 9.114c-.049.664-.1 1.317-.158 1.981-.01.188.02.358.129.486.109.14.267.188.464.188h.01c.257.01.534 0 .781 0 .02.12.05.219.059.317.405 2.665 2.856 4.687 5.516 4.548 2.254-.11 4.123-1.506 4.874-3.438v-.01a5.66 5.66 0 0 0 .247-3.14v-.01a4.998 4.998 0 0 1-.168-.574c.277-.219.653-.337 1.038-.358.415-.03.82.07 1.117.268 0 0 .02.02.03.05.009.009.009.019.009.029v.02h.01l-.09.316c0 .01-.01.02-.01.02-.01.01-.01.02-.01.029-.009.01-.019.02-.019.04-.01.029-.03.07-.039.118-.03.11-.07.258-.1.446a4.56 4.56 0 0 0 0 1.426v.04c.317 2.586 2.432 4.527 5.131 4.706 2.462.168 4.835-1.565 5.467-4.013.059-.277.109-.555.168-.842h.73c.198 0 .387-.03.505-.158.129-.13.149-.317.149-.526 0-.039 0-.08-.01-.119l.001.003Zm-6.811 4.557c-2.382-.039-4.29-1.98-4.261-4.349.03-2.387 1.986-4.32 4.35-4.29 2.41.04 4.29 1.991 4.27 4.449-.01 2.298-2.027 4.23-4.36 4.19Zm-8.076-4.28c-.02 2.358-1.967 4.3-4.33 4.29-2.51-.02-4.379-2.14-4.3-4.478.058-2.239 2.016-4.17 4.33-4.16 2.382.009 4.31 1.96 4.3 4.348Z" fill="currentColor"></path> </svg> <!-- END app snippet --> <span class="pl-2" style="color: #1f2937"> Try on virtually</span> </button> <button class="glasson-btn glasson-btn-360" style="color: #1f2937; border-color: #1f2937; background-color: ;" onclick="window.openTryOn(event, \'360\')"> <!-- BEGIN app snippet: icon-view360 --> <svg width="32" height="18" viewBox="0 0 32 18" fill="currentColor" xmlns="http://www.w3.org/2000/svg"> <path fill-rule="evenodd" clip-rule="evenodd" d="M9.823 3.475c-1.71 0-3.116 1.42-3.116 3.199 0 1.778 1.406 3.198 3.116 3.198 1.71 0 3.117-1.42 3.117-3.198s-1.406-3.199-3.117-3.199ZM5.607 6.674c0-2.363 1.876-4.299 4.216-4.299 2.34 0 4.217 1.936 4.217 4.299 0 2.362-1.876 4.298-4.217 4.298-2.34 0-4.216-1.936-4.216-4.298Z" fill="currentColor"></path> <path fill-rule="evenodd" clip-rule="evenodd" d="m13.786 2.155-4.853 1.45a.55.55 0 0 1-.315-1.054l4.865-1.453a2.264 2.264 0 0 1 2.788 1.701l.148.608a.55.55 0 1 1-1.068.261l-.152-.621a1.164 1.164 0 0 0-1.413-.892Zm6.77 1.449c-1.71 0-3.117 1.42-3.117 3.199 0 1.778 1.407 3.198 3.117 3.198s3.117-1.42 3.117-3.198-1.407-3.199-3.117-3.199Zm-4.217 3.199c0-2.363 1.877-4.299 4.217-4.299s4.217 1.936 4.217 4.299c0 2.362-1.877 4.298-4.217 4.298s-4.217-1.936-4.217-4.298Z" fill="currentColor"></path> <path fill-rule="evenodd" clip-rule="evenodd" d="M25.181 2.263c.649-.073 1.284.348 1.408.941l.13.617a.55.55 0 1 0 1.076-.226l-.13-.616c-.26-1.248-1.516-1.958-2.662-1.802a.55.55 0 0 0-.066.013l-4.91 1.29a.55.55 0 1 0 .28 1.064l4.874-1.281ZM4.465 6.181a.55.55 0 0 1-.182.757c-1.595.978-2.35 2.004-2.35 2.954 0 1.123.993 2.32 3.06 3.337 2.024.994 4.89 1.712 8.192 1.96a.55.55 0 0 1-.082 1.096c-3.397-.254-6.41-.996-8.594-2.069C2.37 13.166.832 11.692.832 9.892.832 8.338 2.036 7.026 3.708 6a.55.55 0 0 1 .757.181Zm23.245.073a.55.55 0 0 1 .761-.163c1.57 1.013 2.784 2.242 2.784 3.801 0 .957-.451 1.828-1.176 2.577-.723.747-1.744 1.404-2.967 1.954-2.45 1.1-5.811 1.82-9.539 1.947a.55.55 0 0 1-.037-1.1c3.623-.123 6.837-.822 9.125-1.85 1.145-.515 2.033-1.101 2.627-1.716.593-.612.867-1.223.867-1.812 0-.945-.746-1.887-2.28-2.877a.55.55 0 0 1-.164-.76Z" fill="currentColor"></path> <path fill-rule="evenodd" clip-rule="evenodd" d="M12.333 14.205a.55.55 0 0 1 .768.126l.898 1.252a.55.55 0 0 1-.117.761l-1.225.918a.55.55 0 0 1-.66-.88l.794-.595-.584-.815a.55.55 0 0 1 .126-.767Zm1.5-6.973a.55.55 0 0 1-.822-.73l.411.365a50.7 50.7 0 0 1-.41-.366v-.002l.003-.002.007-.008a1.786 1.786 0 0 1 .096-.098 3.74 3.74 0 0 1 1.222-.79 2.524 2.524 0 0 1 1.453-.115c.548.124 1.089.445 1.596 1.015a.55.55 0 1 1-.822.731c-.382-.43-.73-.608-1.015-.673a1.426 1.426 0 0 0-.826.073 2.62 2.62 0 0 0-.885.592l-.008.009Zm0 0v.001h-.001c0 .001 0 0 0 0Z" fill="currentColor"></path> </svg> <!-- END app snippet --> <span class="pl-2" style="color: #1f2937"> 360 VIEW</span> </button> </div> </div>'
    target.innerHTML = glassOnBlockHTML

    const requestUrl = `https://glasson.sk-global.biz/shopify/check-product-duplicated?shopId=48794468508&productId=${productId}`;
    fetch(requestUrl).then((response) => {
      return response.json();
    }).then((data) => {
      if (data.duplicated) {
        const glassonWrap = document.querySelector('.glasson-wrap')
        if (glassonWrap) {
          glassonWrap.style.display = 'none'
        }
      }
    }).catch((err) => {
      console.error('Error:', err);
    });
    // Create and append a script element for the virtual try-on UI
    var script = document.createElement('script');
    script.type = 'module';
    script.src = 'https://media.glasses4u.io/build/try-on-ui-v5.esm.js';
    document.body.appendChild(script);
    // Create and append a custom element for the virtual try-on
    let glassonTryOn = document.querySelector('glasson-try-on')

    if (!glassonTryOn) {
      glassonTryOn = document.createElement('glasson-try-on');
      document.body.appendChild(glassonTryOn);
    }

    glassonTryOn.setAttribute('user-id', userId); // Set user ID
    glassonTryOn.setAttribute('group-id', groupId); // Set group ID from the metafield
    console.log('glasson product type', window.pdp.currentProduct.product_type)
    if (
      window.pdp.currentProduct.product_type === 'Prescription' ||
      window.isOphthalmicPdpProduct(window.pdp.currentProduct)
    ) glassonTryOn.setAttribute('screen', 'neven');
    else glassonTryOn.removeAttribute('screen');
    if (window.pdp.currentProduct.product_type === 'Prescription') {
      glassonTryOn.setAttribute('lens-source', 'shopify');
    } else {
      glassonTryOn.removeAttribute('lens-source');
    }
    syncGlassonTryOnLenColorIdFromRxState()
    // Don't remove this line, it's used for versioning
    console.log('GLASSON INSTALLED: v3.0.0');
    window.openTryOn = function (e, mode = 'live') {
      e.preventDefault();
      e.stopPropagation();
      const glassonComponent = document.querySelector('glasson-try-on');
      syncGlassonTryOnLenColorIdFromRxState()
      glassonComponent.setAttribute('mode', mode);
      glassonComponent.setAttribute('open', true);
    }
  }

  function getStaticSection(topWrapperSelector, sectionType) {
    console.log("function running with ", sectionType)
    if (!window.pdp.currentProduct.handle) return
    const target = document.querySelector(topWrapperSelector)
    if (!target) return
    const targetId = target.getAttribute('id')
    const sectionId = targetId.split('-section-').pop()
    fetchSectionHtml(`/products/${window.pdp.currentProduct.handle}?section_id=${sectionId}`).then(res => {
        const parsed = document.createElement('div')
        parsed.innerHTML = res
        const elem = parsed.querySelector(`#${targetId}`)
        if (elem) target.innerHTML = elem.innerHTML
        else target.innerHTML = ''
        switch (sectionType) {
            case 'recommended':
                // window.PXUTheme.jsRecommendedProducts?.init($(target))
                runAllScripts(target)
                break;
            case 'faq':
                window.PXUTheme.jsFAQ?.init()
                break;
            default:
                break;
        }
    })
  }
  
  function judgeMeWidgetsMounted(root) {
    if (!root) return false
    if (root.querySelector('.jdgm-widget.jdgm--done-setup')) return true
    if (root.querySelector('.jdgm-widget-actions-wrapper')) return true
    if (root.querySelector('.jdgm-sort-dropdown, .jdgm-rev-widg__sort-wrapper select')) return true
    const writeLink = root.querySelector('.jdgm-write-rev-link')
    return !!(writeLink && writeLink.style.display !== 'none')
  }

  // Judge.me app-block section: Section Rendering returns correct product markup
  // but unmounted. jdgm.initializeWidgets only works once its lazily loaded review
  // form chunk is present, otherwise it throws _renderAndSetupReviewForm errors.
  function remountJudgeMeWidgets(root) {
    if (judgeMeWidgetsMounted(root)) return true

    if (root) {
      root.querySelectorAll('.jdgm-temp-hiding-style').forEach((style) => style.remove())
      root.querySelectorAll('.jdgm-rev-widg[style*="display: none"], .jdgm-rev-widg[style*="display:none"]').forEach((el) => {
        el.style.removeProperty('display')
      })
    }

    const jm = window.jdgm
    const chunkReady = !!(jm && typeof jm._renderAndSetupReviewForm === 'function')

    // At most twice per root: repeated calls on a half-mounted widget can double-render
    const initCalls = root ? root._jdgmInitCalls || 0 : 0
    if (chunkReady && typeof jm.initializeWidgets === 'function' && initCalls < 2) {
      if (root) root._jdgmInitCalls = initCalls + 1
      try {
        jm.initializeWidgets()
        return judgeMeWidgetsMounted(root) || !root
      } catch (err) {
        console.warn('jdgm.initializeWidgets failed', err)
      }
    }
    if (chunkReady) return false

    // Pull the missing widget chunks once; loader.js initializes on its own
    if (!window.pdp._jdgmLoaderPending) {
      window.pdp._jdgmLoaderPending = true
      const host = (jm && jm.CDN_HOST) || 'https://cdn.judge.me/'
      const done = () => {
        window.pdp._jdgmLoaderPending = false
      }
      try {
        if (jm && typeof jm.loadJS === 'function') {
          jm.loadJS(host + 'loader.js', done)
        } else {
          const script = document.createElement('script')
          script.src = host + 'loader.js'
          script.onload = done
          script.onerror = done
          document.head.appendChild(script)
        }
      } catch (err) {
        console.warn('judgeme loader fetch failed', err)
        done()
      }
    }

    return false
  }

  // Keep retrying until Judge.me has actually rendered into `root` (loader.js
  // chunks land async; a mid-mount swap can leave the section blank). One
  // watcher per section; a newer call replaces the older one.
  // Waits until 2.5s after window load before stepping in, so Judge.me's own
  // first-paint loader gets to mount the widget untouched.
  function ensureJudgeMeWidgetsMounted(root) {
    if (!root) return
    if (root._jdgmMountTimer) clearInterval(root._jdgmMountTimer)
    if (root._jdgmMountDelay) clearTimeout(root._jdgmMountDelay)
    root._jdgmMountTimer = null
    root._jdgmMountDelay = null
    if (judgeMeWidgetsMounted(root)) return

    if (document.readyState !== 'complete') {
      window.addEventListener('load', () => ensureJudgeMeWidgetsMounted(root), { once: true })
      return
    }
    const nav = performance.getEntriesByType ? performance.getEntriesByType('navigation')[0] : null
    const wait = (nav && nav.loadEventEnd ? nav.loadEventEnd : 0) + 2500 - performance.now()
    if (wait > 0) {
      root._jdgmMountDelay = setTimeout(() => ensureJudgeMeWidgetsMounted(root), wait)
      return
    }

    if (remountJudgeMeWidgets(root)) return
    let tries = 0
    root._jdgmMountTimer = setInterval(() => {
      tries += 1
      // Second initializeWidgets attempt only after ~5s of waiting on the first
      if (tries === 10) root._jdgmInitCalls = Math.min(root._jdgmInitCalls || 0, 1)
      if (!root.isConnected || remountJudgeMeWidgets(root) || tries >= 30) {
        clearInterval(root._jdgmMountTimer)
        root._jdgmMountTimer = null
      }
    }, 500)
  }

  // Badge click handler (product__sep-design__judgemeBadge) remounts before scrolling
  window.remountSepJudgeMeWidgets = ensureJudgeMeWidgetsMounted

  function getJudgemeReviewsSectionEl(doc) {
    const el =
      doc.querySelector('#judgeme_product_reviews') ||
      doc.querySelector('.jdgm-review-widget') ||
      doc.querySelector('.reviews-wrapper-area')
    return el ? el.closest('.shopify-section') : null
  }

  function getJudgemeReviewsSection(handle) {
    if (!handle) return
    const target = getJudgemeReviewsSectionEl(document)
    const targetId = target && target.getAttribute('id')
    if (!targetId) return
    const sectionId = targetId.replace('shopify-section-', '')

    if (!window.pdp.judgemeReviewsHtmls) window.pdp.judgemeReviewsHtmls = {}

    const widgetProductId = (root) => {
      const w =
        root.querySelector('#judgeme_product_reviews') ||
        root.querySelector('.jdgm-review-widget') ||
        root.querySelector('.jdgm-rev-widg')
      return w ? String(w.getAttribute('data-id') || w.getAttribute('data-product-id') || '') : ''
    }

    // Already showing this product (first paint, or back to where we started):
    // never swap the markup out from under Judge.me, which is what blanked the
    // section when our fetch landed while loader.js was still mounting it.
    const currentId = window.pdp.currentProduct?.id ? String(window.pdp.currentProduct.id) : ''
    const liveProductId = widgetProductId(target)
    if (currentId && liveProductId && currentId === liveProductId) {
      ensureJudgeMeWidgetsMounted(target)
      return
    }

    const apply = (html) => {
      if (window.pdp.currentProduct?.handle && window.pdp.currentProduct.handle !== handle) return
      const live = getJudgemeReviewsSectionEl(document)
      if (!live) return
      const parsed = document.createElement('div')
      parsed.innerHTML = html
      const source =
        parsed.querySelector(`#${CSS.escape(targetId)}`) ||
        getJudgemeReviewsSectionEl(parsed) ||
        parsed
      // Bail on empty/error bodies rather than wiping the live widget
      if (!source.querySelector('#judgeme_product_reviews, .jdgm-widget, .jdgm-rev-widg, .jdgm-review-widget')) {
        return
      }

      const nextProductId = widgetProductId(source)
      if (nextProductId && nextProductId === widgetProductId(live) && judgeMeWidgetsMounted(live)) {
        return
      }

      live.innerHTML = source.innerHTML
      ensureJudgeMeWidgetsMounted(live)
    }

    const cached = window.pdp.judgemeReviewsHtmls[handle]
    if (cached) {
      apply(cached)
      return
    }

    // The section id is scoped to this page's JSON template. Products on another
    // template (sunglasses <-> Rx, safety, oph...) 404 on it, which left the old
    // product's reviews up. `view=` renders the target product with this page's
    // template so the id resolves; the default template has no view name, so fall
    // back to the full product page and pull the reviews section out of it.
    const templateSuffix = document.body?.dataset.templateSuffix || ''
    const sectionUrl =
      `/products/${handle}?section_id=${encodeURIComponent(sectionId)}` +
      (templateSuffix ? `&view=${encodeURIComponent(templateSuffix)}` : '')

    const load = (url) =>
      fetch(url).then((res) => (res.ok ? res.text() : Promise.reject(new Error(`reviews section ${res.status}`))))

    load(sectionUrl)
      .catch(() => load(`/products/${handle}`))
      .then((html) => {
        if (!html || !html.trim()) throw new Error('reviews section empty')
        window.pdp.judgemeReviewsHtmls[handle] = html
        apply(html)
      })
      .catch((err) => {
        console.warn('judgeme reviews section update failed', err)
      })
  }

  function attachJudgeMeEvents() {
    window.jdgm = window.jdgm || {};
    jdgm.CDN_HOST = "https://cdn.judge.me/";

    jdgm.docReady = function (callback) {
      if (
        document.attachEvent
          ? document.readyState === "complete"
          : document.readyState !== "loading"
      ) {
        setTimeout(callback, 0);
      } else {
        document.addEventListener("DOMContentLoaded", callback);
      }
    };

    jdgm.loadJS = function (url, callback) {
      var xhr = new XMLHttpRequest();
      xhr.onreadystatechange = function () {
        if (xhr.readyState === 4) {
          Function(xhr.response)();
          if (callback) callback(xhr.response);
        }
      };
      xhr.open("GET", url);
      xhr.send();
    };

    jdgm.docReady(function () {
      if (
        window.jdgmLoadCSS ||
        document.querySelectorAll(".jdgm-widget, .jdgm-all-reviews-page").length >
        0
      ) {
        jdgm.loadJS(jdgm.CDN_HOST + "loader.js");
      }
    });
  }

  function renderAdditionalSections() {
    const handle =
      window.pdp.currentProduct?.handle ||
      window.location.pathname.split('/products/').pop()?.split('?')[0] ||
      ''
    if (!handle) return

    // Reviews section doesn't depend on pdata; don't let a slow/failed pdata skip it
    getJudgemeReviewsSection(handle)

    const reqId = (window.pdp._pdataReqId = (window.pdp._pdataReqId || 0) + 1)

    fetch(`/products/${handle}?view=pdata`).then(res => res.text()).then(data => {
      if (reqId !== window.pdp._pdataReqId) return
      if (window.pdp.currentProduct?.handle && window.pdp.currentProduct.handle !== handle) return

      // GLASSON HANDLER
      const t = document.createElement('div')
      window.pdp.pdata = t;
      t.innerHTML = data;
      try {
        if (getGlassonSourceHandleForOphSplit()) {
          syncOphthalmicGlassonAppBlock()
        } else {
          const glassonUserIdEl = t.querySelector('.glass-on-user-id')
          const glassonProductIdEl = t.querySelector('.glass-on-product-id')
          const glassonVtoEnabledEl = t.querySelector('.glass-on-vto-enabled')
          const selectedProductIdEl = t.querySelector('.product-id')
          if (glassonUserIdEl && glassonProductIdEl && glassonVtoEnabledEl && selectedProductIdEl) {
            getGlassOnAppBlock(
              selectedProductIdEl.innerHTML,
              glassonUserIdEl.innerHTML,
              glassonProductIdEl.innerHTML,
              glassonVtoEnabledEl.innerHTML
            )
          }
        }
      } catch (err) {
        console.warn('Glasson pdata hydrate failed', err)
      }
      // GLASSON HANDLER: END
  
      getCompareSection();
      // getting FAQ
      getStaticSection('.shopify-section.sep-pdp-faq', 'faq')
      // getting global recommendation
      getStaticSection('.shopify-section.sep-pdp-recommendation', 'recommended')
      // getting mattex recommendation
      // getStaticSection('.shopify-section.related.recommended-products-section', 'recommended')
  
      // calculateDate()

      // Prefer pdata badge (always product-scoped) over stale cache from prior visits
      const badgeSource = t.querySelector('.judgeme-preview-badge')
      if (badgeSource) {
        if (!window.pdp.judgemeHtmls) window.pdp.judgemeHtmls = {}
        window.pdp.judgemeHtmls[handle] = badgeSource.innerHTML
        applyJudgemeBadgeForHandle(handle)
      }
  
      // update judgeme product featured review
      if (document.querySelector('.product__information_block.featured-review')) {
        const target = document.querySelector('.product__information_block.featured-review')
        if (window.pdp.featuredReviewSwiper) {
          try {
            window.pdp.featuredReviewSwiper.destroy(true, true)
          } catch (e) {}
          window.pdp.featuredReviewSwiper = null
        }
        const reviewNodes = t.querySelectorAll(
          '.judgeme-preview-reviews .jdgm-rev-widg__body .jdgm-rev-widg__reviews .jdgm-rev'
        )
        const length = reviewNodes.length
        if (length > 1) {
          const innerSliderTiles = Array.from(reviewNodes)
          .reduce((acc, e, i) => {
            const rating = e.querySelector('.jdgm-rev__rating')
            const titleEl = e.querySelector('.jdgm-rev__title')
            const bodyEl = e.querySelector('.jdgm-rev__body')
            const authorEl = e.querySelector('.jdgm-rev__author')
            const tsEl = e.querySelector('.jdgm-rev__timestamp')
            if (!rating || !titleEl || !bodyEl || !authorEl || !tsEl) return acc
            const date = (tsEl.getAttribute('data-content') || '').split(' ')[0].replaceAll('-', '/')
            if (i > 2) return acc
            return acc + `
              <div class="swiper-slide">
                <div class="stars">${rating.outerHTML}</div>
                <div class="title">${titleEl.innerHTML}</div>
                <div class="content">${bodyEl.innerHTML}</div>
                <div class="name-date">
                  <div class="name">${authorEl.innerHTML}</div>
                  <div class="date">${date}</div>
                </div>
              </div>
            `
          }, '')

          const swiperHtml = `
            <div class="review-swiper-container swiper">
              <div class="swiper-wrapper">
                ${innerSliderTiles}
              </div>
              <div class="swiper-pagination"></div>
            </div>
          `

          if (target && innerSliderTiles) {
            target.classList.remove('hidden')
            target.innerHTML = swiperHtml
            window.pdp.featuredReviewSwiper = new Swiper(target.querySelector('.review-swiper-container'), {
              slidesPerView: 1,
              loop: true,
              pagination: {
                el: target.querySelector('.swiper-pagination'),
                type: 'bullets',
                clickable: true,
              },
              autoplay: {
                delay: 15000
              }
            })
          }
        } else {
          if (target) {
            target.innerHTML = ''
            target.classList.add('hidden')
          }
        }
      }

      const additionalInformation = document.querySelector('.product__information_block.additional-information')
      const addInfoSource = t.querySelector('.product__information_block.additional-information')
      if (additionalInformation && addInfoSource) {
        additionalInformation.innerHTML = addInfoSource.innerHTML
      }
    }).catch((err) => {
      console.warn('pdata hydrate failed', err)
    })

    // Size selector (Standard / XL) below other-products slider
    updatePdpSizeSelector()

    fetch(`https://api.neveneyewear.com/api/product-meta/${window.pdp.currentProduct.handle}/purchases_in_24`)
      .then(res => res.json())
      .then(res => {
        const purchaseHistorySpan = document.querySelector('.product__information_block .purchase-history-banner-text span')
        if (purchaseHistorySpan) {
          purchaseHistorySpan.innerHTML = res.data || '0'
        }
      })
      .catch(() => {
        const purchaseHistorySpan = document.querySelector('.product__information_block .purchase-history-banner-text span')
        if (purchaseHistorySpan) {
          purchaseHistorySpan.innerHTML = '0'
        }
      })

    fetchSectionHtml(`/products/${window.pdp.currentProduct.handle}?section_id=sep-pdp-happyfaces&section_lazy_loading=true`)
      .then(data => {
        const div = new DOMParser().parseFromString(data, 'text/html')
        const happyfaces = div.querySelector('#shopify-section-sep-pdp-happyfaces .happy-faces-container')?.innerHTML
        if (happyfaces && document.querySelector('.happy-faces-container')) {
          document.querySelector('.happy-faces-container').innerHTML = happyfaces
        }
      })
  }

  function syncOphSplitAtcBlockVisibility(fallbackProductId) {
    const atcs = document.querySelectorAll('.product__information_block.atc')
    if (!atcs.length) return
    const atcMatchId =
      window.pdp.ophSplitArchitecture && typeof window.getOphSplitActiveProductId === 'function'
        ? window.getOphSplitActiveProductId() || fallbackProductId
        : fallbackProductId
    if (!atcMatchId) return
    atcs.forEach((atc) => {
      const atcProductId = atc.getAttribute('product_id')
      if (+atcProductId === +atcMatchId) {
        atc.classList.remove('hidden')
      } else {
        atc.classList.add('hidden')
      }
    })
    renderWishlistButton()
  }

  function switchMainSliderForHandle(handle, afterSwitch) {
    if (!handle) return
    const runAfter = () => {
      if (window.pdp._activeMainSliderHandle !== handle) return
      refreshMainSwiperForHandle(handle)
      if (typeof window.syncGalleryPdpLead === 'function') window.syncGalleryPdpLead()
      if (typeof afterSwitch === 'function') afterSwitch(handle)
    }
    if (revealMainSliderForHandle(handle)) {
      requestAnimationFrame(() => {
        requestAnimationFrame(runAfter)
      })
      return
    }
    if (window.pdp.swiperHtmls[handle]) {
      removeMainSliderForHandle(handle)
      destroyMainSwiperEntry(handle)

      const html = new DOMParser().parseFromString(window.pdp.swiperHtmls[handle], 'text/html')
      const content = $(html).find('.product__sep-design__mainSlider').first()

      document.querySelectorAll('.product__sep-design__mainSlider').forEach((el) => {
        el.classList.add('hidden')
      })
      const productImages = $(document).find('.product__images')

      if (content.length > 0 && productImages.length > 0) {
        productImages.append(content)
        runAllScripts(content.get(0))
        if (!window.pdp.swipers?.[handle]?.swiper && window.sepStorefront) {
          window.sepStorefront.initMainSliderForHandle(handle)
        }
      }
      if (window.PXUTheme?.video?.init) window.PXUTheme.video.init()
      window.pdp._activeMainSliderHandle = handle
      const gen = ++window.pdp._mainSliderShowGen
      requestAnimationFrame(() => {
        requestAnimationFrame(() => {
          if (gen !== window.pdp._mainSliderShowGen) return
          runAfter()
          if (typeof handleMainSliderPosition === 'function') handleMainSliderPosition(handle)
        })
      })
      return
    }
    ensureSepDesignProductAssets(handle).then(() => {
      if (window.pdp.currentProductHandle !== handle && window.pdp._activeMainSliderHandle !== handle) {
        // A newer size/color switch won — do not remount this stale handle
        if (typeof afterSwitch === 'function') afterSwitch(handle)
        return
      }
      if (getMainSliderRootForHandle(handle) || window.pdp.swiperHtmls[handle]) {
        switchMainSliderForHandle(handle, afterSwitch)
      } else if (typeof afterSwitch === 'function') {
        afterSwitch(handle)
      }
    })
  }

  function syncPdpMobileBottomMenuOffset() {
    const menu = document.querySelector('nav.nvn-mobile-bottom-menu')
    const height = menu && window.getComputedStyle(menu).display !== 'none'
      ? Math.ceil(menu.getBoundingClientRect().height)
      : 0
    document.documentElement.style.setProperty('--nvn-mobile-bottom-menu-height', `${height || 73}px`)
  }

  function syncPdpMobileStickyAtc() {
    const bar = document.getElementById('pdp-sticky-atc')
    const stickyBtn = bar?.querySelector('.atc-button')
    const mainBtn = getMainAtcButton()
    if (!bar || !stickyBtn || !mainBtn) return

    let productId = window.pdp.currentProduct?.id
    if (
      window.isOphthalmicPdpProduct(window.pdp.currentProduct) &&
      window.pdp.ophSplitArchitecture &&
      typeof window.getOphSplitActiveProductId === 'function'
    ) {
      productId = window.getOphSplitActiveProductId() || productId
    }
    if (productId) bar.setAttribute('product_id', String(productId))
    bar.classList.add('atc')

    const modal = document.getElementById('rx-config-modal')
    const modalOpen = modal && !modal.hidden
    stickyBtn.innerHTML = mainBtn.innerHTML
    stickyBtn.classList.toggle('disabled', mainBtn.classList.contains('disabled'))
    const pastScrollThreshold = window.scrollY > 515
    if (modalOpen || window.innerWidth > 798 || !pastScrollThreshold) {
      bar.hidden = true
      return
    }
    bar.hidden = false
  }

  function initPdpMobileStickyAtc() {
    const bar = document.getElementById('pdp-sticky-atc')
    if (!bar || bar.dataset.inited === '1') return
    bar.dataset.inited = '1'
    bar.classList.add('atc')

    const refresh = () => {
      syncPdpMobileBottomMenuOffset()
      syncPdpMobileStickyAtc()
    }

    refresh()
    window.addEventListener('resize', refresh)
    window.addEventListener('scroll', refresh, { passive: true })
    window.syncPdpMobileStickyAtc = syncPdpMobileStickyAtc
    window.reobservePdpMobileStickyAtc = refresh

    const menu = document.querySelector('nav.nvn-mobile-bottom-menu')
    if (menu && typeof ResizeObserver !== 'undefined') {
      new ResizeObserver(() => syncPdpMobileBottomMenuOffset()).observe(menu)
    }
    syncPdpMobileBottomMenuOffset()
  }

  function updateATCText(_value) {
    let value
    if (_value) value = _value
    else value = window.pdp.selectedVariant

    // Always sync availability from currentProduct.variants array (which is updated by getProductVariantWithAvailability)
    if (value && value.id && window.pdp.currentProduct && window.pdp.currentProduct.variants) {
      let currentVariant = window.pdp.currentProduct.variants.find(v => v.id === value.id)
      if (!currentVariant && window.pdp.ophMainProduct) {
        currentVariant = window.pdp.ophMainProduct.variants?.find(v => v.id === value.id)
      }
      if (!currentVariant && window.pdp.ophSplitArchitecture) {
        if (window.pdp.ophSplitBlProduct) {
          currentVariant = window.pdp.ophSplitBlProduct.variants?.find(v => v.id === value.id)
        }
        if (!currentVariant && window.pdp.ophSplitPlProduct) {
          currentVariant = window.pdp.ophSplitPlProduct.variants?.find(v => v.id === value.id)
        }
      }
      if (currentVariant && currentVariant.hasOwnProperty('available')) {
        value.available = currentVariant.available
      }
    }

    let productId
    if (value && value.product_id) {
      productId = value.product_id
    } else if (window.pdp.currentProduct && window.pdp.currentProduct.id) {
      productId = window.pdp.currentProduct.id
    } else {
      productId = null
    }

    syncOphSplitAtcBlockVisibility(productId)
    if (usesRxConfigModal()) syncRxConfigModalProductId()

    const mainAtcButton = getMainAtcButton()
    const stickyAtcButton = getRxConfigStickyAtcButton()
    const bisBlock = document.querySelector('.product__information_block.bis')

    const badgesBlock = document.querySelector('.product__information_block.badges')
    
    const url = new URL(window.location)
    let variantId
    if (value && value.id) {
      variantId = value.id
    } else {
      variantId = url.searchParams.get('variant')
    }

    if (!window.pdp.currentProduct) {
      return
    }

    let showAddToCart = true

    if (window.isOphOrRxPdpProduct(window.pdp.currentProduct)) {
      if (!variantId) {
        showAddToCart = false
      }
    }

    const selectedLensColor = normalizeRxOptionHandle(window.pdp.rx?.['lens-color'] || '')
    const shouldUseFirstVariantAvailability =
      window.pdp.currentProduct.product_type === 'Prescription' &&
      RX_LENS_TAG_GATED_LENS_COLORS.includes(selectedLensColor)
    const firstVariantUnavailable =
      shouldUseFirstVariantAvailability &&
      window.pdp.currentProduct?.variants?.[0] &&
      window.pdp.currentProduct.variants[0].available === false
    const ophType = window.pdp.rx?.['oph-type']
    const ophMainProduct =
      window.pdp.ophMainProduct ||
      (window.pdp.ophSplitArchitecture ? window.pdp.currentProduct : null)
    const ophMainFirstVariantUnavailable =
      window.isOphthalmicPdpProduct(window.pdp.currentProduct) &&
      window.pdp.ophSplitArchitecture &&
      ophMainProduct?.variants?.[0] &&
      ophMainProduct.variants[0].available === false
    const ophSplitFullySoldOut = isOphSplitFullySoldOut()
    const ophLandingPathOos = isOphLandingPathOos()
    const ophSplitPartialAvailable =
      window.isOphthalmicPdpProduct(window.pdp.currentProduct) &&
      window.pdp.ophSplitArchitecture &&
      !ophSplitFullySoldOut
    const ophSplitUsesMainFirstForNotify =
      window.isOphthalmicPdpProduct(window.pdp.currentProduct) &&
      window.pdp.ophSplitArchitecture &&
      (ophType === 'prescription' || ophType === 'readers' || ophType === 'plain')
    const showNotifyPreSelection =
      firstVariantUnavailable || ophSplitFullySoldOut || ophLandingPathOos
    const effectiveAvailable = shouldUseFirstVariantAvailability
      ? !firstVariantUnavailable
      : (value ? value.available : undefined)

    const applySoldOutUi = (soldOut, preSelection = false) => {
      if (bisBlock) {
        // Landed path OOS (or fully sold out) → show PDP notify form for that product
        if (ophSplitFullySoldOut || ophLandingPathOos) {
          bisBlock.classList.remove('hidden')
        } else if (ophSplitPartialAvailable) {
          bisBlock.classList.add('hidden')
        } else if (ophSplitUsesMainFirstForNotify) {
          bisBlock.classList.toggle('hidden', !ophMainFirstVariantUnavailable)
        } else if (preSelection) {
          bisBlock.classList.toggle('hidden', !showNotifyPreSelection)
        } else {
          bisBlock.classList.toggle('hidden', !soldOut)
        }
      }
      if (badgesBlock) {
        // Badge only when nothing left to buy — partial OOS keeps shoppable CTA
        const showSoldOut = ophSplitPartialAvailable
          ? false
          : !!(soldOut || ophSplitFullySoldOut || (preSelection && showNotifyPreSelection))
        badgesBlock.innerHTML = showSoldOut ? '<div class="badge_item">SOLD OUT</div>' : ''
      }
      const info = document.querySelector('.product__information')
      if (info) {
        info.classList.toggle(
          'sold_out',
          ophSplitPartialAvailable
            ? false
            : !!(soldOut || ophSplitFullySoldOut || (preSelection && showNotifyPreSelection))
        )
      }
    }

    // Main PDP ATC: for Rx/Oph opens configurator — no price on button
    // Landing path OOS + other path in stock → CHOOSE OTHER LENSES + notify form
    // Both paths OOS → SOLD OUT
    if (usesRxConfigModal() && mainAtcButton) {
      if (ophSplitFullySoldOut) {
        mainAtcButton.innerHTML = 'SOLD OUT'
        mainAtcButton.classList.add('disabled')
        applySoldOutUi(true)
      } else if (ophSplitPartialAvailable) {
        mainAtcButton.innerHTML = getAddToCartButtonText(null, { hidePrice: true })
        mainAtcButton.classList.remove('disabled')
        applySoldOutUi(false)
      } else if (firstVariantUnavailable || (value && value.id && effectiveAvailable === false)) {
        mainAtcButton.innerHTML = 'SOLD OUT'
        mainAtcButton.classList.add('disabled')
        applySoldOutUi(true)
      } else {
        const priceVariant = (value && value.id) ? value : window.pdp.currentProduct?.variants?.[0]
        const hidePrice = !isOphSimpleAtcType()
        mainAtcButton.innerHTML = getAddToCartButtonText(priceVariant, { hidePrice })
        mainAtcButton.classList.remove('disabled')
        applySoldOutUi(false)
      }
    }

    const configAtcButton = stickyAtcButton
    if (usesRxConfigModal() && configAtcButton) {
      if (value && value.id && showAddToCart) {
        if (effectiveAvailable || effectiveAvailable === undefined) {
          configAtcButton.innerHTML = getAddToCartButtonText(value, { applyRxDiscount: true })
          configAtcButton.classList.remove('disabled')
        } else {
          configAtcButton.innerHTML = 'SOLD OUT'
          configAtcButton.classList.add('disabled')
        }
      } else {
        let buttonText = 'SELECT OPTIONS'
        configAtcButton.innerHTML = buttonText
        configAtcButton.classList.add('disabled')

        if (window.pdp.currentProduct.product_type === 'Prescription') {
          if (!window.pdp.rx['lens-type'] || !document.querySelector('#lens-type-panel .dropdown-option.selected')) {
            buttonText = 'CHOOSE YOUR LENS TYPE'
            configAtcButton.innerHTML = buttonText
          }
          if (!window.pdp.rx['lens-color'] || !document.querySelector('#lens-color-panel .dropdown-option.selected')) {
            buttonText = 'CHOOSE YOUR LENS COLOR'
            configAtcButton.innerHTML = buttonText
          }
        } else if (window.isOphthalmicPdpProduct(window.pdp.currentProduct)) {
          if (!window.pdp.rx['lens-type'] || !document.querySelector('#lens-type-panel .dropdown-option.selected')) {
            buttonText = 'CHOOSE YOUR LENS TYPE'
            configAtcButton.innerHTML = buttonText
          }
          if (!window.pdp.rx['oph-type'] || !document.querySelector('#oph-type-panel .dropdown-option.selected')) {
            buttonText = 'CHOOSE YOUR TYPE'
            configAtcButton.innerHTML = buttonText
          }
        }
      }
      syncRxConfigModalGallery()
    }

    if (usesRxConfigModal()) {
      if (typeof window.syncPdpMobileStickyAtc === 'function') window.syncPdpMobileStickyAtc()
      else syncPdpMobileStickyAtc()
      return
    }

    if (value && value.id && showAddToCart) {
      if (effectiveAvailable || effectiveAvailable === undefined) {
        if (mainAtcButton) {
          mainAtcButton.innerHTML = getAddToCartButtonText(value)
          mainAtcButton.classList.remove('disabled')
        }
        applySoldOutUi(false)
      } else {
        if (mainAtcButton) {
          mainAtcButton.innerHTML = 'SOLD OUT'
          mainAtcButton.classList.add('disabled')
        }
        applySoldOutUi(true)
      }
    } else {
      if (mainAtcButton) {
        let buttonText = 'SELECT OPTIONS'
        mainAtcButton.innerHTML = buttonText
        mainAtcButton.classList.add('disabled')

        if (window.pdp.currentProduct.product_type === 'Prescription') {
          if (!window.pdp.rx['lens-type'] || !document.querySelector('#lens-type-panel .dropdown-option.selected')) {
            buttonText = 'CHOOSE YOUR LENS TYPE'
            mainAtcButton.innerHTML = buttonText
          }
          if (!window.pdp.rx['lens-color'] || !document.querySelector('#lens-color-panel .dropdown-option.selected')) {
            buttonText = 'CHOOSE YOUR LENS COLOR'
            mainAtcButton.innerHTML = buttonText
          }
        } else if (window.isOphthalmicPdpProduct(window.pdp.currentProduct)) {
          if (!window.pdp.rx['lens-type'] || !document.querySelector('#lens-type-panel .dropdown-option.selected')) {
            buttonText = 'CHOOSE YOUR LENS TYPE'
            mainAtcButton.innerHTML = buttonText
          }
          if (!window.pdp.rx['oph-type'] || !document.querySelector('#oph-type-panel .dropdown-option.selected')) {
            buttonText = 'CHOOSE YOUR TYPE'
            mainAtcButton.innerHTML = buttonText
          }
        }
      }
      applySoldOutUi(false, true)
    }
    if (typeof window.syncPdpMobileStickyAtc === 'function') window.syncPdpMobileStickyAtc()
    else syncPdpMobileStickyAtc()
  }

  function addBisListeners() {
    const urlParams = new URLSearchParams(window.location.search);
    const lv_vid = urlParams.get('variant')
    const first_vid = window.pdp.currentProduct.variants[0].id;  

    function createNotify() {
      if (typeof BIS != 'undefined') {
        if ($('[name=method]:checked').length) {
          var method = $('[name=method]:checked').data('tab')
          var landingTarget =
            typeof isOphLandingPathOos === 'function' && isOphLandingPathOos()
              ? getOphLandingNotifyTarget()
              : null
          var variantId =
            (landingTarget && landingTarget.variantId) ||
            window.pdp.selectedVariant?.id ||
            lv_vid ||
            first_vid
          var payload = {
            email: null,
            pId:
              (landingTarget && landingTarget.productId) ||
              window.pdp.selectedVariant?.product_id ||
              window.pdp.currentProduct.id,
            vId: variantId,
            optIn: false,
            phone: null
          };
          switch (method) {
            case 'phone-number':
              var phone = window.toUSE164($('#phone-number input').first().val());

              if (!phone){
                handleBISError({errors: { 0: 'Invalid phone number.' }});
                return false;
              }
              payload.phone = phone;
              BIS.create(null, payload.vId, payload.pId, { phone_number: payload.phone }).then(function(resp) {
                if (resp.status == 'OK') {
                  handleBISSuccess(resp);
                } else {
                  handleBISError(resp);
                }
              });
              break;
            case 'email-address':
              payload.email = $('#email-address input').first().val();
              payload.optIn = $('#customer_accepts_marketing').is(':checked')
              BIS.create(payload.email, payload.vId, payload.pId, { accepts_marketing: payload.optIn }).then(function(resp) {
                if (resp.status == 'OK'){
                  handleBISSuccess(resp)
                }else{
                  handleBISError(resp);
                }
              });
            break;
          }
        }
      } else {
        console.error("BIS object undefined!");
      }
      return
    }

    var clearBISResponse = function() {
      $('#BIS_form .BIS_response').text('');
    };

    var handleBISSuccess = function(resp) {
      var msgWrapOpen = '<p style="background-color: #aaffaa">';
      var msgWrapClose = '</p>';
      var message = resp.message;

      $('.BIS_response').html(msgWrapOpen+message+msgWrapClose);
    };

    var handleBISError = function(resp) {
      var msgWrapOpen = '<p style="background-color: #ffaaaa">';
      var msgWrapClose = '</p>';
      var message = '';
      for (var x in resp.errors)
      {
        message += msgWrapOpen + resp.errors[x] + msgWrapClose;
      }

      $('.BIS_response').html(message);
    }

    $(function() {
      $('#BIS_form input').on('focus change', clearBISResponse);
      $('[name=method]').on('change', (e)=>{
        $('[name=method]').parent().removeClass('active')
        $('[name=method]:checked').parent().addClass('active')
        if ($('[name=method]:checked').data('tab') == 'email-address'){
          $('#phone-number').hide()
          $('#email-address').show()
        } else {
          $('#email-address').hide()
          $('#phone-number').show()
        }
      });

      // hide the Notify me form if the variant options combination does not exist
      var _origSelectCallback = window.selectCallback;
      window.selectCallback = function(variant, selector) {
        _origSelectCallback.apply(window, arguments);
        if (variant == null) {
          $('#notify-form').stop().hide();
        }
      }

      $('.submit-notifyme').click(function(e) {
        e.preventDefault()
        // clearBISResponse();
        createNotify()
      });
    });

    window.toUSE164 = function(num) {
      if (num) {
        let e164 = num.trim().replace(/-/g, '').replace(/ /g, '');
        console.log('toE164: ', e164);
        e164 = e164.match(/[2-9][0-9]{9}/g);
        if (e164 === null) {
          return '';
        }
        e164 = e164.join('');
        e164 = '+1' + e164;
        e164 = e164.substring(0, 12);
        return e164;
      }
    };
  }

  document.addEventListener('state:change:currentProductHandle', (event) => {
    const handle = event.detail.value
    const sliderHandle =
      typeof window.getOphSplitSliderHandle === 'function'
        ? window.getOphSplitSliderHandle(handle)
        : handle

    fetchProductJsonMerged(`/products/${sliderHandle}.json`)
      .then((data) => {
        if (window.pdp.ophSplitArchitecture && typeof window.loadOphthalmicSplitProducts === 'function') {
          return window.loadOphthalmicSplitProducts(data.product).then(() => data)
        }
        return data
      })
      .then((data) => {
        const canonical =
          window.pdp.ophSplitArchitecture &&
          window.pdp.ophSplitReady?.main &&
          window.pdp.ophMainProduct
            ? window.pdp.ophMainProduct
            : data.product
        setState['currentProduct'](canonical)

        if (window.pdp.ophSplitArchitecture) {
          const prefetch = [sliderHandle]
          if (window.pdp.ophSplitBlHandle) prefetch.push(window.pdp.ophSplitBlHandle)
          if (window.pdp.ophSplitPlHandle) prefetch.push(window.pdp.ophSplitPlHandle)
          fetchProductsByHandles([...new Set(prefetch.filter(Boolean))])
        }
      })

    if (sepStorefrontEnabled()) {
      populateVariantPricesFromStorefront(sliderHandle)
    } else {
      fetchSectionHtml(`/products/${sliderHandle}?section_id=sep-pdp-varprices`)
        .then(data => {
          const div = new DOMParser().parseFromString(data, 'text/html')
          const variantPrice = div.querySelector('#shopify-section-sep-pdp-varprices')
          if (variantPrice) {
            variantPrice.querySelectorAll('.variant-price').forEach(variantPriceElement => {
              const variantId = variantPriceElement.getAttribute('data-variant-id')
              if (variantId) {
                window.pdp.variantPriceHtmls[variantId] = variantPriceElement.innerHTML
              }
            })
          }
        })
    }

    // Use the handle from this event (not getSepDesignActiveSliderHandle):
    // currentProduct is still the previous product until JSON resolves.
    switchMainSliderForHandle(sliderHandle, (activeHandle) => {
      syncSepDesignMainAndThumbSliders(activeHandle)
      syncOphthalmicGlassonAppBlock()
    })
  })

  document.addEventListener('state:change:currentProductType', (event) => {
    const value = event.detail.value
    const bisBlock = document.querySelector('.product__information_block.bis')
    const currentHandle = window.pdp.currentProduct.handle
    let productHandle = ''
    let mainCollection = ''
    if (value === 'sunglasses') {
      if (currentHandle && currentHandle.endsWith('-rx')) {
        productHandle = currentHandle.replace(/-rx$/, '')
      } else if (window.pdp.linkedProductHandle) {
        productHandle = window.pdp.linkedProductHandle
      }
      mainCollection = window.pdp.mainCollection ? window.pdp.mainCollection.replace(/^prescription-/, '') : ''
      const beforeVsAfter = document.querySelector('.before_vs_after')
      if (beforeVsAfter) {
        beforeVsAfter.classList.remove('hidden')
      }
    } else {
      if (currentHandle && !currentHandle.includes('-rx') && window.pdp.counterPartCollectionProducts.find(product => product.handle === `${currentHandle}-rx`)) {
        productHandle = `${currentHandle}-rx`
      } else if (window.pdp.linkedProductHandle) {
        productHandle = window.pdp.linkedProductHandle
      }
      mainCollection = window.pdp.mainCollection ? `prescription-${window.pdp.mainCollection.replace(/^prescription-/, '')}` : ''
      const beforeVsAfter = document.querySelector('.before_vs_after')
      if (beforeVsAfter) {
        beforeVsAfter.classList.add('hidden')
      }
    }
    if (productHandle && productHandle !== currentHandle) {
      window.pdp.linkedProductHandle = currentHandle
      setState['currentProductHandle'](productHandle)
      if (mainCollection) {
        setState['mainCollection'](mainCollection)
      }
    } else {
      updateRxToggleUI(value === 'prescription')
      placeRxToggleForProductType(value === 'prescription' ? 'Prescription' : 'Sunglasses')
      endPdpProductSwitch('rx', value, true)
    }
  })

  document.addEventListener('state:change:currentProduct', (event) => {
    const value = event.detail.value
    resolvePdpProductSwitchFromProduct(value)

    if (value?.product_type === 'Prescription' && window.pdp._scrollTopAfterRxLoad) {
      window.pdp._scrollTopAfterRxLoad = false
      window.scrollTo({ top: 0, left: 0, behavior: 'auto' })
    }

    if (value?.product_type === 'Prescription') {
      syncPrescriptionRxLensTagVisibilityFromProduct(value)
      initLensStyleForPrescription()
    }

    // get variant with availability
    getProductVariantWithAvailability().then(() => {
      applyRxLensColorFromUrlIfApplicable()
      // change selected variant
      findSelectedVariant()
      applyOphSplitLandingPriceFallback()
      syncOphTypeAvailabilityUi()
      // Update ATC text after availability is fetched and variant is selected
      updateATCText()
      syncOphSplitAtcBlockVisibility(value.id)
      if (!window.pdp.selectedVariant || Object.keys(window.pdp.selectedVariant).length === 0) {
        const url = new URL(window.location)
        let ophType = url.searchParams.get('oph-type')
        if (ophType) {
          if (ophType === 'bluelight') ophType = 'blue-light'
          if (isOphTypePathAvailable(ophType)) {
            setState['oph-type'](ophType)
            document.querySelector('.dropdown-option[data-value="' + ophType + '"]')?.click()
          }
        }
      }
      syncGlassonTryOnLenColorIdFromRxState()
    })

    // Change title
    const titleElement = document.querySelector('.product__information > .pdp-lead .product__information_block.title h1')
      || document.querySelector('.product__information .product__information_block.title h1')
    if (titleElement) {
      titleElement.innerHTML = value.title
    }

    // Change price (oph split uses selected variant + applyPriceBlockForVariant, not canonical main)
    if (!window.pdp.ophSplitArchitecture) {
      if (window.pdp.variantPriceHtmls[value.variants[0].id]) {
        const priceElement = document.querySelector('.product__information > .pdp-lead .product__information_block.price-block')
          || document.querySelector('.product__information .product__information_block.price-block')
        if (priceElement) {
          priceElement.innerHTML = window.pdp.variantPriceHtmls[value.variants[0].id]
        }
      } else if (window.pdp.productPriceHtmls[value.handle]) {
        const priceBlock = document.querySelector('.product__information > .pdp-lead .product__information_block.price-block')
          || document.querySelector('.product__information .product__information_block.price-block')
        if (priceBlock) {
          priceBlock.innerHTML = window.pdp.productPriceHtmls[value.handle]
        }
      }
    }

    // Change atc button
    syncOphSplitAtcBlockVisibility(value.id)

    // hide rx information on main column (options live in config modal)
    const rxInformation = document.querySelector('.product__information_block.rx-information')
    if (rxInformation) {
      mountRxConfigModal()
      syncRxConfigModalProductId()
    }

    // change rx toggle + restore template block order for this product type
    const rxToggle = document.querySelector('.product__information_block.rx-toggle')
    if (rxToggle) {
      if (value.product_type === 'Sunglasses') {
        if (value.tags.includes('_sunglasses:has_rx')) rxToggle.classList.remove('hidden')
        else rxToggle.classList.add('hidden')
      } else if (value.product_type === 'Prescription') {
        rxToggle.classList.remove('hidden')
      }
      updateRxToggleUI(value.product_type === 'Prescription', value)
    }
    placeRxToggleForProductType(value.product_type)

    if (window.pdp._openRxConfigAfterProductLoad && usesRxConfigModal()) {
      window.pdp._openRxConfigAfterProductLoad = false
      openRxConfigModal()
    } else if (!usesRxConfigModal()) {
      closeRxConfigModal()
    }

    // change url path first so secondary UI updates can't block navigation
    const url = new URL(window.location)
    const urlHandle = resolveOphSplitHandleForNavigation(value.handle)
    const newPath = url.pathname.replace(/\/products\/[^\/]+/, `/products/${urlHandle}`)
    url.pathname = newPath
    if (!window.pdp.lock.variantParam) {
      url.searchParams.delete('variant')
    }
    window.history.replaceState({}, '', url)

    // sunglasses feats/ship3 vs default freeshipping
    try {
      updateSepPerkFeatures(value)
    } catch (e) {
      console.error('updateSepPerkFeatures', e)
    }

    requestAnimationFrame(updatePdpSizeSelector)

    // Change judgeme badge (retry via dedicated fetch if not cached yet)
    if (!applyJudgemeBadgeForHandle(value.handle)) {
      ensureJudgemeHtmlForHandle(value.handle).then(() => {
        if (window.pdp.currentProduct?.handle === value.handle) {
          applyJudgemeBadgeForHandle(value.handle)
        }
      })
    }

    // change slider images
    changeSliderImages()
    requestAnimationFrame(() => {
      const sliderHandle = getSepDesignActiveSliderHandle()
      if (sliderHandle) syncSepDesignMainAndThumbSliders(sliderHandle)
    })

    // render glasson, recommendation, FAQ, etc.
    renderAdditionalSections()

    // Change subtitle
    if (typeof window.pdp.subtitleHtmls[value.handle] === 'string') {
      const subtitleElement = document.querySelector('.product__information_block.subtitle')
      if (subtitleElement) {
        subtitleElement.innerHTML = window.pdp.subtitleHtmls[value.handle]
        subtitleElement.classList.remove('hidden')
      }
    } else if (sepStorefrontEnabled()) {
      applySubtitleFromStorefront(value.handle)
    } else {
      fetchSectionHtml(`/products/${value.handle}?section_id=sep-pdp-subtitle`)
        .then(data => {
          const div = new DOMParser().parseFromString(data, 'text/html')
          const subtitle = div.querySelector('#shopify-section-sep-pdp-subtitle').innerHTML
          window.pdp.subtitleHtmls[value.handle] = subtitle
          const subtitleElement = document.querySelector('.product__information_block.subtitle')
          if (subtitleElement) {
            if (subtitle) {
              subtitleElement.innerHTML = window.pdp.subtitleHtmls[value.handle]
              subtitleElement.classList.remove('hidden')
            } else {
              subtitleElement.innerHTML = ''
              subtitleElement.classList.add('hidden')
            }
          }
        })
    }

    const body = document.querySelector('body')
    if (body) {
      if (window.isOphthalmicPdpProduct(value)) {
        body.setAttribute('data-selected-product-type', 'ophthalmic')
      } else if (value.product_type === 'Prescription') {
        body.setAttribute('data-selected-product-type', 'rx')
      } else {
        body.removeAttribute('data-selected-product-type')
      }
    }

    // lens upgrade options visibility
    if (window.isOphOrRxPdpProduct(value)) {
      console.log('state:change:currentProduct: window.pdp.selectedVariant', window.pdp.selectedVariant)
      if (usesRxConfigModal()) {
        keepRxConfigOptionPanelsOpen()
      } else {
        const sv = window.pdp.selectedVariant
        const variantBelongsToPdp =
          sv &&
          Object.keys(sv).length > 0 &&
          (sv.product_id === value.id ||
            (window.pdp.ophMainProduct && sv.product_id === window.pdp.ophMainProduct.id) ||
            (window.pdp.ophSplitArchitecture &&
              window.pdp.ophSplitBlProduct &&
              sv.product_id === window.pdp.ophSplitBlProduct.id) ||
            (window.pdp.ophSplitArchitecture &&
              window.pdp.ophSplitPlProduct &&
              sv.product_id === window.pdp.ophSplitPlProduct.id))
        if (!sv || Object.keys(sv).length === 0 || !variantBelongsToPdp) {
          const lensTypeDropdown = document.querySelector(`.dropdown.lens-type`)
          if (lensTypeDropdown) {
            lensTypeDropdown.querySelector('.dropdown-panel').classList.add('disabled')
          }
          const lensUpgradeDropdown = document.querySelector(`.dropdown.lens-upgrade`)
          if (lensUpgradeDropdown) {
            lensUpgradeDropdown.querySelector('.dropdown-panel').classList.add('disabled')
          }
        }
      }
    }

    // b1g2f message change
    if (value.product_type === 'Sunglasses' || value.product_type === 'Blue Light') {
      setSepDesignB1g2fContent('Sunglasses', value.variants?.[0]?.price)
    } else if (value.product_type === 'Prescription' || window.isOphOrRxPdpProduct(value)) {
      // OPH defaults to Rx 30% until plain/blue-light type is chosen
      syncOphOfferBannerFromType(window.pdp.rx?.['oph-type'], value.variants?.[0]?.price)
    }

    // add attribute to other products selector
    const otherProductsWrapper = document.querySelector('.product__information_block.other-products')
    if (otherProductsWrapper) {
      otherProductsWrapper.setAttribute('data-selected-product-type', value.product_type.toLowerCase())
    }

    setTimeout(() => {
      changeSliderImages()
    }, 1000)

    if (!window.pdp.mainSliderPosition.isEventListenerAdded) {
      window.addEventListener('resize', handleMainSliderPosition)
      window.addEventListener('resize', adjustSliderWidth)
      window.addEventListener('resize', updatePriceBlockStickyTop)
      window.addEventListener('load', handleMainSliderPosition)
      window.addEventListener('load', adjustSliderWidth)
      window.addEventListener('load', updatePriceBlockStickyTop)
      window.addEventListener('scroll', updateStickyBorder, { passive: true })
      handleMainSliderPosition()
      adjustSliderWidth()
      updatePriceBlockStickyTop()
      window.pdp.mainSliderPosition.isEventListenerAdded = true
    } else {
      handleMainSliderPosition(value.handle)
      adjustSliderWidth()
      updatePriceBlockStickyTop()
    }

    updateATCText()
  })

  document.addEventListener('state:change:initialized', (event) => {
    const value = event.detail.value
    console.log('initialized', value)
    // pdpBackgroundTask()
    onUserInteraction(pdpBackgroundTask)
    
    if (window.SEP_DESIGN_OPH.enableRxInit) {
      checkEditMode()
      readFromVariantParam()
      if (window.pdp.ophSplitArchitecture) {
        const splitSiblingRole =
          window.pdp.ophSplitRole === 'bl' || window.pdp.ophSplitRole === 'pl'
        selectOphTypeFromSplitRole({ force: splitSiblingRole })
        applyOphTypeFromUrl({ force: !window.pdp.rx?.['oph-type'] })
      } else {
        applyOphTypeFromUrl({ force: true })
      }
      updateLensUpgradeAvailability()
      updateLensUpgradePricing()
      if (window.isOphOrRxPdpProduct(window.pdp.currentProduct)) {
        changeSliderImages()
        if (window.pdp.ophSplitArchitecture) {
          requestAnimationFrame(() => syncOphthalmicGlassonAppBlock())
        }
      }
      mountRxConfigModal()
      if (window.pdp.editMode && usesRxConfigModal()) {
        const tryOpenEditModal = () => {
          if (document.getElementById('rx-config-modal')) {
            openRxConfigModal()
          } else {
            requestAnimationFrame(tryOpenEditModal)
          }
        }
        tryOpenEditModal()
      }
    
    }
    initLensStyleForPrescription()
    updatePhotochromicLensColorLabels()
    syncGlassonTryOnLenColorIdFromRxState()
    requestAnimationFrame(updatePdpSizeSelector)

    const addUnprocessedUpsellProduct = (node) => {
      const nextUpsellItem = node.querySelector('.cart_drawer_upsell.no-display')
      if (nextUpsellItem) {
        const recommendedProducts = document.querySelector('.product__information_block.recommended-products')
        if (recommendedProducts) {
          recommendedProducts.classList.remove('hidden')
          recommendedProducts.innerHTML = nextUpsellItem.outerHTML
          const _nextUpsellItem = recommendedProducts.querySelector('.cart_drawer_upsell')
          if (_nextUpsellItem) {
            _nextUpsellItem.classList.remove('no-display')
            const addButton = _nextUpsellItem.querySelector('.cart_drawer_upsell_add')
            if (addButton) {
              addButton.innerHTML = 'ADD TO CART'
            }
            const img = _nextUpsellItem.querySelector('img')
            if (img) {
              const src = img.src
              img.src = src.replace('100x', '200x')
            }
          }
        }
      }
    }

    // attach observer for drawer cart, to change recommended products
    const drawerCart = document.querySelector('#shopify-section-cart-drawer')
    if (drawerCart) {
      const observer = new MutationObserver((mutations) => {
        mutations.forEach((mutation) => {
          console.log('mutation', mutation)
          const addedNodes = Array.from(mutation.addedNodes)
          if (addedNodes.length > 0) {
            addedNodes.forEach((node) => {
              if (node?.classList?.contains('cart_drawer_main_container')) {
                addUnprocessedUpsellProduct(node)
              }
            })
          }
        })
      })
      // observer.observe(drawerCart, { childList: true, subtree: true })

      // addUnprocessedUpsellProduct(drawerCart)
    }

    addBisListeners()
    updateATCText()
  })

  document.addEventListener('state:change:mainCollection', (event) => {
    const value = event.detail.value
    if (window.pdp.swipers[value]) {
      $(document).find('.product__information_block.other-products .other-products-container').addClass('hidden')
      $(window.pdp.swipers[value].swiper.el).closest('.other-products-container').removeClass('hidden')
      requestAnimationFrame(updatePdpSizeSelector)
    } else {
      refreshOtherProductsForHandle(window.pdp.currentProductHandle)
    }

    fetchCollectionProductsStorefrontFirst(value).then(products => {
      window.pdp.mainCollectionProducts = products
      fetchProductsByHandles(products.map(product => product.handle))
    })
  })

  const RX_LENS_TAG_GATED_LENS_COLORS = ['yellow', 'green-vibrant', 'purple-pastel', 'photochromic-gray', 'photochromic-brown']
  const RX_LENS_COLOR_TRY_ORDER = ['clear', 'black', 'brown', 'yellow', 'coastal-blue', 'purple-pastel', 'green-vibrant', 'rose-pink', 'silver', 'photochromic-gray', 'photochromic-brown']

  function getRxLensColorHandleFromLensQueryParam() {
    try {
      const raw = new URL(window.location.href).searchParams.get('lens')
      if (!raw || typeof raw !== 'string') return ''
      const stripped = raw.replace(/^rx-lens-color-/i, '').trim()
      return normalizeRxOptionHandle(stripped)
    } catch (e) {
      return ''
    }
  }

  function resolveInitialLensStyleForPrescription() {
    const url = new URL(window.location)
    const variantId = url.searchParams.get('variant')
    const urlLensColor = getRxLensColorHandleFromLensQueryParam()
    if (variantId) {
      return normalizeLensStyleToAvailable(deriveLensStyleFromColor(window.pdp.rx['lens-color']))
    }
    if (urlLensColor) {
      return normalizeLensStyleToAvailable(deriveLensStyleFromColor(urlLensColor))
    }
    return normalizeLensStyleToAvailable('basic')
  }

  function applyRxLensColorFromUrlIfApplicable() {
    if (window.pdp.currentProduct?.product_type !== 'Prescription') return
    const lensColor = getRxLensColorHandleFromLensQueryParam()
    if (!lensColor) return

    const style = normalizeLensStyleToAvailable(deriveLensStyleFromColor(lensColor))
    window.pdp._applyingLensFromUrl = true
    if (window.pdp.rx['lens-style'] !== style) {
      setState['lens-style'](style)
      syncLensStyleSelectionUi(style)
      updateLensStyleInfoMessage(style)
      applyLensStyleColorVisibility(style)
    }

    const lcOpt = document.querySelector('#lens-color-panel .dropdown-option[data-value="' + lensColor + '"]')
    if (lcOpt && !lcOpt.classList.contains('hidden') && !lcOpt.classList.contains('lens-style-hidden')) {
      if (normalizeRxOptionHandle(window.pdp.rx['lens-color'] || '') !== lensColor) {
        setState['lens-color'](lensColor)
        lcOpt.click()
      }
    }
    window.pdp._applyingLensFromUrl = false
  }

  function normalizeProductTagsToArray(tags) {
    if (tags == null) return []
    if (Array.isArray(tags)) return tags.map(function (t) { return String(t).trim() }).filter(Boolean)
    if (typeof tags === 'string') {
      return tags.split(',').map(function (t) { return t.trim() }).filter(Boolean)
    }
    return []
  }

  // Catalog tags use short photochromic names (e.g. `_rx_lens_color:photo_black`);
  // map them to the Lens Color option handles the dropdown renders.
  const RX_LENS_COLOR_TAG_ALIASES = {
    'photo-black': 'photochromic-gray',
    'photo-gray': 'photochromic-gray',
    'photo-grey': 'photochromic-gray',
    'photochromic-black': 'photochromic-gray',
    'photochromic-grey': 'photochromic-gray',
    'photo-brown': 'photochromic-brown'
  }

  function parseRxLensColorTagHandlesFromProduct(product) {
    const set = new Set()
    const tags = normalizeProductTagsToArray(product?.tags)
    for (let i = 0; i < tags.length; i++) {
      const tag = tags[i]
      if (typeof tag !== 'string' || tag.indexOf('_rx_lens_color:') === -1) continue
      const raw = tag.split('_rx_lens_color:').pop()
      const h = normalizeRxOptionHandle(raw)
      if (h) set.add(RX_LENS_COLOR_TAG_ALIASES[h] || h)
    }
    return set
  }

  function syncPrescriptionRxLensTagVisibilityFromProduct(product) {
    if (!product || product.product_type !== 'Prescription') return
    const handles = parseRxLensColorTagHandlesFromProduct(product)
    const colorPanel = document.getElementById('lens-color-panel')
    if (colorPanel) {
      RX_LENS_TAG_GATED_LENS_COLORS.forEach(function (handle) {
        const el = colorPanel.querySelector('.dropdown-option[data-value="' + handle + '"]')
        if (!el) return
        if (handles.has(handle)) el.classList.remove('hidden')
        else el.classList.add('hidden')
      })
    }
    const showPhotoStyle = handles.has('photochromic-gray') || handles.has('photochromic-brown')
    const photoStyleEl = document.querySelector('#lens-style-panel .dropdown-option[data-value="photochromic"]')
    if (photoStyleEl) {
      if (showPhotoStyle) photoStyleEl.classList.remove('hidden')
      else photoStyleEl.classList.add('hidden')
    }
    if (!showPhotoStyle && window.pdp.rx['lens-style'] === 'photochromic') {
      setState['lens-style']('basic')
    }
    const urlLens = getRxLensColorHandleFromLensQueryParam()
    const cur = normalizeRxOptionHandle(urlLens || window.pdp.rx['lens-color'] || '')
    const curOpt = document.querySelector('#lens-color-panel .dropdown-option[data-value="' + cur + '"]')
    const curBad = !curOpt || curOpt.classList.contains('hidden')
    if (curBad) {
      for (let i = 0; i < RX_LENS_COLOR_TRY_ORDER.length; i++) {
        const h = RX_LENS_COLOR_TRY_ORDER[i]
        const opt = document.querySelector('#lens-color-panel .dropdown-option[data-value="' + h + '"]')
        if (opt && !opt.classList.contains('hidden')) {
          opt.click()
          break
        }
      }
    }
    applyRxLensColorFromUrlIfApplicable()
  }

  const RX_LENS_STYLE_COLOR_GROUPS = {
    basic: ['clear', 'black', 'brown', 'yellow'],
    mirrored: ['coastal-blue', 'purple-pastel', 'green-vibrant', 'rose-pink', 'silver'],
    photochromic: ['photochromic-gray', 'photochromic-brown']
  }

  function deriveLensStyleFromColor(color) {
    const normalizedColor = normalizeRxOptionHandle(color || '')
    if (RX_LENS_STYLE_COLOR_GROUPS.basic.includes(normalizedColor)) return 'basic'
    if (RX_LENS_STYLE_COLOR_GROUPS.mirrored.includes(normalizedColor)) return 'mirrored'
    if (RX_LENS_STYLE_COLOR_GROUPS.photochromic.includes(normalizedColor)) return 'photochromic'
    return 'basic'
  }

  function getAvailableLensStylesFromDom() {
    return Array.from(document.querySelectorAll('#lens-style-panel .dropdown-option[data-value]'))
      .filter(el => !el.classList.contains('hidden'))
      .map(el => el.getAttribute('data-value'))
      .filter(Boolean)
  }

  function normalizeLensStyleToAvailable(style) {
    const available = getAvailableLensStylesFromDom()
    if (!available.length) return style || 'basic'
    const s = style || 'basic'
    if (available.includes(s)) return s
    if (available.includes('basic')) return 'basic'
    return available[0]
  }

  function syncLensStyleSelectionUi(style) {
    const options = document.querySelectorAll('#lens-style-panel .dropdown-option[data-value]')
    let selectedOption = null
    options.forEach(option => {
      const isSelected = option.getAttribute('data-value') === style
      option.classList.toggle('selected', isSelected)
      if (isSelected) selectedOption = option
    })

    const lensStyleDropdown = document.querySelector('.dropdown.lens-style')
    const lensStyleBadge = lensStyleDropdown ? lensStyleDropdown.querySelector('.dropdown-badge') : null
    if (lensStyleBadge && selectedOption) {
      lensStyleBadge.textContent = selectedOption.getAttribute('data-badge') || ''
    }
  }

  function applyLensStyleColorVisibility(style) {
    // Config modal shows every available color in one flat image grid
    if (usesRxConfigModal()) {
      document.querySelectorAll('#lens-color-panel .dropdown-option[data-value]').forEach(option => {
        option.classList.remove('lens-style-hidden')
      })
      if (typeof window.syncRxLensColorProductImages === 'function') {
        window.syncRxLensColorProductImages()
      }
      return [].concat(
        RX_LENS_STYLE_COLOR_GROUPS.basic,
        RX_LENS_STYLE_COLOR_GROUPS.mirrored,
        RX_LENS_STYLE_COLOR_GROUPS.photochromic
      )
    }
    const allowed = RX_LENS_STYLE_COLOR_GROUPS[style] || RX_LENS_STYLE_COLOR_GROUPS.basic
    const options = document.querySelectorAll('#lens-color-panel .dropdown-option[data-value]')
    options.forEach(option => {
      option.classList.toggle('lens-style-hidden', !allowed.includes(option.getAttribute('data-value')))
    })
    return allowed
  }

  function enforceValidLensColorForStyle(style) {
    const allowed = applyLensStyleColorVisibility(style)
    const selectedColor = normalizeRxOptionHandle(window.pdp.rx['lens-color'] || '')
    const selectedOpt = selectedColor
      ? document.querySelector('#lens-color-panel .dropdown-option[data-value="' + selectedColor + '"]')
      : null
    const ok = allowed.includes(selectedColor) && selectedOpt && !selectedOpt.classList.contains('hidden')
    if (ok) return
    for (let i = 0; i < allowed.length; i++) {
      const h = allowed[i]
      const opt = document.querySelector('#lens-color-panel .dropdown-option[data-value="' + h + '"]')
      if (opt && !opt.classList.contains('hidden')) {
        opt.click()
        return
      }
    }
  }

  function updateLensStyleInfoMessage(style) {
    const color = window.pdp?.rx?.['lens-color']
    const lensStyle = style || (color ? deriveLensStyleFromColor(color) : 'basic')
    let copy = 'Evenly tinted lenses for a classic, solid color look.'
    if (lensStyle === 'mirrored') {
      copy = 'Reflective coating layered over a brown base.'
    } else if (lensStyle === 'photochromic') {
      copy = 'Clear indoors, darkens in sunlight to adapt to changing light conditions.'
    }
    const styleMessage = document.getElementById('lens-style-info-message')
    if (styleMessage) styleMessage.textContent = copy

    const modalEl = document.getElementById('rx-config-modal')
    const noteEl = document.getElementById('rx-config-preview-color-note')
    if (noteEl) {
      const onColorStep = modalEl && modalEl.getAttribute('data-step') === 'lens-color'
      if (onColorStep && color) {
        noteEl.textContent = copy
        noteEl.hidden = false
      } else {
        noteEl.hidden = true
      }
    }
  }
  window.updateLensStyleInfoMessage = updateLensStyleInfoMessage

  function initLensStyleForPrescription() {
    if (window.pdp.currentProduct?.product_type !== 'Prescription') return
    const urlLensColor = getRxLensColorHandleFromLensQueryParam()
    const style = resolveInitialLensStyleForPrescription()
    window.pdp.rx['lens-style'] = style
    syncLensStyleSelectionUi(style)
    updateLensStyleInfoMessage(style)
    applyLensStyleColorVisibility(style)
    if (urlLensColor) {
      applyRxLensColorFromUrlIfApplicable()
    } else {
      enforceValidLensColorForStyle(style)
    }
  }

  document.addEventListener('state:change:lens-color', (event) => {
    syncGlassonTryOnLenColorIdFromRxState()
    updateLensUpgradeAvailability()
    updateLensUpgradePricing()
    updatePhotochromicLensColorLabels()
    findSelectedVariant()
    changeSliderImages()
    syncRxConfigModalGallery()
    if (typeof window.syncRxLensColorProductImages === 'function') {
      window.syncRxLensColorProductImages()
    }
    updateATCText()
    if (event.detail.value) {
      if (usesRxConfigModal()) {
        keepRxConfigOptionPanelsOpen()
      } else {
        const lensTypeDropdown = document.querySelector(`.dropdown.lens-type`)
        if (lensTypeDropdown) {
          lensTypeDropdown.querySelector('.dropdown-panel').classList.remove('disabled')
        }
      }
      if (window.pdp.currentProduct?.product_type === 'Prescription') {
        const style = normalizeLensStyleToAvailable(deriveLensStyleFromColor(event.detail.value))
        if (window.pdp.rx['lens-style'] !== style) {
          window.pdp.rx['lens-style'] = style
          syncLensStyleSelectionUi(style)
          applyLensStyleColorVisibility(style)
        }
        updateLensStyleInfoMessage(style)
      }
    } else if (window.pdp.currentProduct?.product_type === 'Prescription') {
      updateLensStyleInfoMessage()
    }
  })

  document.addEventListener('state:change:lens-style', (event) => {
    if (window.pdp.currentProduct?.product_type !== 'Prescription') return
    const style = event.detail.value || 'basic'
    syncLensStyleSelectionUi(style)
    updateLensStyleInfoMessage(style)
    if (!window.pdp._applyingLensFromUrl) {
      enforceValidLensColorForStyle(style)
    }
    if (usesRxConfigModal()) {
      keepRxConfigOptionPanelsOpen()
    } else {
      const lensColorDropdown = document.querySelector(`.dropdown.lens-color`)
      if (lensColorDropdown) {
        lensColorDropdown.querySelector('.dropdown-panel').classList.remove('disabled')
      }
    }
  })

  document.addEventListener('state:change:lens-type', (event) => {
    updateLensUpgradeAvailability()
    updateLensUpgradePricing()
    updatePhotochromicLensColorLabels()
    findSelectedVariant()
    updateATCText()
    if (event.detail.value) {
      if (usesRxConfigModal()) {
        keepRxConfigOptionPanelsOpen()
      } else {
        const lensUpgradeDropdown = document.querySelector(`.dropdown.lens-upgrade`)
        if (lensUpgradeDropdown) {
          lensUpgradeDropdown.querySelector('.dropdown-panel').classList.remove('disabled')
        }
        const lensTypeDropdown = document.querySelector(`.dropdown.lens-type`)
        if (lensTypeDropdown) {
          lensTypeDropdown.querySelector('.dropdown-panel').classList.add('disabled')
        }
        const lensColorDropdown = document.querySelector(`.dropdown.lens-color`)
        if (lensColorDropdown) {
          lensColorDropdown.querySelector('.dropdown-panel').classList.add('disabled')
        }
        const lensStyleDropdown = document.querySelector(`.dropdown.lens-style`)
        if (lensStyleDropdown) {
          lensStyleDropdown.querySelector('.dropdown-panel').classList.add('disabled')
        }
        const ophTypeDropdown = document.querySelector(`.dropdown.oph-type`)
        if (ophTypeDropdown) {
          ophTypeDropdown.querySelector('.dropdown-panel').classList.add('disabled')
        }
      }
      // Keep frame / other-products selector open while configuring lenses in the modal
      const otherProductsContainer = document.querySelector(`.product__information_block.other-products`)
      if (otherProductsContainer) {
        otherProductsContainer.classList.remove('disabled')
        otherProductsContainer.querySelectorAll('.other-products-container').forEach(container => {
          container.classList.remove('disabled')
        })
      }
    }
  })

  document.addEventListener('state:change:oph-type', (event) => {
    changeSliderImages()
    updateLensTypeAvailability()
    updateLensUpgradeAvailability()
    updateLensUpgradePricing()
    findSelectedVariant()
    if (window.pdp.selectedVariant) {
      applyPriceBlockForVariant(window.pdp.selectedVariant)
    }
    updateATCText()

    // hide prescription submit note for readers
    const summaryNote = document.querySelector('.rx-config-modal__summary-board-note')
    if (summaryNote) {
      summaryNote.classList.toggle('hidden', event.detail.value === 'readers')
    }

    // update b1g2f wrapper text — plain/blue-light are B1G2F; Rx types stay 30% off
    syncOphOfferBannerFromType(
      event.detail.value,
      window.pdp.selectedVariant?.price || window.pdp.currentProduct?.variants?.[0]?.price
    )

    // update dropdowns
    if (event.detail.value) {
      if (usesRxConfigModal()) {
        keepRxConfigOptionPanelsOpen()
      } else {
        const lensTypeDropdown = document.querySelector(`.dropdown.lens-type`)
        if (lensTypeDropdown) {
          lensTypeDropdown.querySelector('.dropdown-panel').classList.remove('disabled')
        }
        const ophTypeDropdown = document.querySelector(`.dropdown.oph-type`)
        if (ophTypeDropdown) {
          ophTypeDropdown.querySelector('.dropdown-panel').classList.add('disabled')
        }
      }
    }
  })

  document.addEventListener('state:change:lens-upgrade', (event) => {
    updatePhotochromicLensColorLabels()
    findSelectedVariant()
    updateATCText()
    setTimeout(() => {
      updateATCText()
    }, 1000)
  })

  function getCachedVariantPriceHtml(variantId) {
    const c = window.pdp.variantPriceHtmls
    if (!c || variantId == null) return null
    return c[variantId] != null ? c[variantId] : c[String(variantId)]
  }

  function buildSepDesignRxPriceBlockHtml(variant, productType) {
    if (!variant) return null
    const pt = productType || window.pdp.currentProduct?.product_type
    const price = parseFloat(variant.price)
    if (isNaN(price)) return null
    const cents = Math.round(price * 100)
    const moneyFormat = document.body.getAttribute('data-money-format') || (typeof Shopify !== 'undefined' && Shopify.money_format) || (window.SEP_DESIGN_OPH.moneyFormat || '')
    function fmtCents(c) {
      if (typeof Shopify !== 'undefined' && typeof Shopify.formatMoneyOrigin === 'function') {
        return Shopify.formatMoneyOrigin(String(Math.round(c)), moneyFormat)
      }
      return '$' + (c / 100).toFixed(2)
    }
    if (pt === 'Prescription' || pt === 'Sunglasses' || window.isOphthalmicPdpProduct(window.pdp.currentProduct)) {
      const discCents = Math.round(price * 0.7 * 100)
      return (
        '<div class="price-block price">' + fmtCents(discCents) + '</div>' +
        '<div class="price-block compare-at-price">' + fmtCents(cents) + '</div>' +
        '<div class="price-block discount-badge">SAVE 30%</div>'
      )
    }
    const compareAt = variant.compare_at_price ? parseFloat(variant.compare_at_price) : null
    let html = '<div class="price-block price">' + fmtCents(cents) + '</div>'
    if (compareAt && !isNaN(compareAt) && compareAt > price) {
      html += '<div class="price-block compare-at-price">' + fmtCents(Math.round(compareAt * 100)) + '</div>'
    }
    return html
  }

  function applyPriceBlockForVariant(variant) {
    if (!variant) return
    let html = null
    if (window.isOphthalmicPdpProduct(window.pdp.currentProduct)) {
      html = buildSepDesignRxPriceBlockHtml(variant)
    } else {
      html = getCachedVariantPriceHtml(variant.id)
      if (!html) html = buildSepDesignRxPriceBlockHtml(variant)
    }
    if (html) {
      const priceBlock = document.querySelector('.product__information > .pdp-lead .product__information_block.price-block')
        || document.querySelector('.product__information .product__information_block.price-block')
      if (priceBlock) priceBlock.innerHTML = html
    }
  }

  function coerceVariantPriceDollars(raw) {
    if (raw == null || raw === '') return NaN
    if (typeof raw === 'object') {
      if (raw.amount != null) return coerceVariantPriceDollars(raw.amount)
      if (typeof raw.cents === 'number') return raw.cents / 100
    }
    const str = String(raw).trim()
    const n = parseFloat(str)
    if (isNaN(n)) return NaN
    if (str.indexOf('.') === -1 && Number.isInteger(n) && Math.abs(n) >= 1000) return n / 100
    return n
  }

  // Price of the Rx variant for a lens type, color and upgrade set (same matching as findSelectedVariant).
  function rxVariantPriceDollars(lensType, lensColor, upgrades) {
    const variant = (window.pdp.currentProduct?.variants || []).find(v => {
      if (!v?.option1 || v.option2 == null) return false
      let opt3 = v.option3 == null ? '' : String(v.option3)
      const lower = opt3.toLowerCase()
      if (!(lower.includes('standard') || lower.includes('impact resistant') || lower.includes('high index'))) {
        opt3 = opt3 ? (opt3 + ' + Standard') : 'Standard'
      }
      return v.option1.toLowerCase().split(' ').join('-') === lensType &&
        normalizeRxOptionHandle(v.option2) === lensColor &&
        haveSameElements(opt3.split(' + ').map(o => o.toLowerCase().split(' ').join('-')), upgrades)
    })
    if (!variant) return NaN
    const price = coerceVariantPriceDollars(variant.price)
    return price > 0 ? price : NaN
  }

  // Photochromic upcharge over clear for the shopper's lens type and upgrades, from variant prices.
  // Falls back to the Standard lens, then to the list prices if the variants aren't loaded.
  function photochromicUpchargeLabel(handle) {
    const lt = window.pdp.rx['lens-type']
    const upgrades = Object.keys(window.pdp.rx['lens-upgrade'] || {}).filter(k => window.pdp.rx['lens-upgrade'][k])
    const sets = [upgrades, ['standard']]
    for (let i = 0; i < sets.length; i++) {
      const diff = rxVariantPriceDollars(lt, handle, sets[i]) - rxVariantPriceDollars(lt, 'clear', sets[i])
      if (!isNaN(diff)) return diff > 0 ? '+$' + Math.round(diff) : 'FREE'
    }
    return lt === 'progressive' ? '+$80' : '+$60'
  }

  function updatePhotochromicLensColorLabels() {
    if (window.pdp.currentProduct?.product_type !== 'Prescription') return
    ;['photochromic-gray', 'photochromic-brown'].forEach(function (handle) {
      const el = document.querySelector('#lens-color-panel .dropdown-option[data-value="' + handle + '"] .dropdown-text')
      if (el) el.textContent = photochromicUpchargeLabel(handle)
    })
  }

  document.addEventListener('state:change:selectedVariant', (event) => {
    // change variant price
    const value = event.detail.value
    const bisBlock = document.querySelector('.product__information_block.bis')
    if (value) {
      const variantPrice = getCachedVariantPriceHtml(value.id)
      if (!variantPrice) {
        const handle = getProductHandleForVariant(value) || window.pdp.currentProduct?.handle || location.pathname.split('/').pop()
        if (sepStorefrontEnabled()) {
          populateVariantPricesFromStorefront(handle).then(() => {
            applyPriceBlockForVariant(value)
          })
        } else {
          fetchSectionHtml(`/products/${handle}?section_id=sep-pdp-varprices`)
            .then(data => {
              const div = new DOMParser().parseFromString(data, 'text/html')
              const variantPriceSection = div.querySelector('#shopify-section-sep-pdp-varprices')
              if (variantPriceSection) {
                variantPriceSection.querySelectorAll('.variant-price').forEach(variantPriceElement => {
                  const variantId = variantPriceElement.getAttribute('data-variant-id')
                  if (variantId) {
                    window.pdp.variantPriceHtmls[variantId] = variantPriceElement.innerHTML
                  }
                })
              }
              applyPriceBlockForVariant(value)
            })
        }
      }
      applyPriceBlockForVariant(value)
    } else {
    }

    // change atc button text
    updateATCText(value)

    // change url param
    if (window.pdp.lock.variantParam) {
      return
    }
    if (value) {
      const url = new URL(window.location)
      const targetHandle = getProductHandleForVariant(value)
      if (targetHandle) {
        const currentPath = url.pathname
        const newPath = currentPath.replace(/\/products\/[^\/]+/, `/products/${targetHandle}`)
        url.pathname = newPath
      }
      url.searchParams.set('variant', value.id)
      window.history.replaceState({}, '', url)
    } else {
      const url = new URL(window.location)
      url.searchParams.delete('variant')
      window.history.replaceState({}, '', url)
    }
  })

  document.addEventListener('state:change:variant-id', (event) => {
    const value = event.detail.value
    if (value) {
      let variant = window.pdp.currentProduct.variants.find(v => v.id === +value) || null
      if (!variant && window.pdp.ophMainProduct) {
        variant = window.pdp.ophMainProduct.variants?.find(v => v.id === +value) || null
      }
      if (!variant && window.pdp.ophSplitArchitecture && window.pdp.ophSplitBlProduct) {
        variant = window.pdp.ophSplitBlProduct.variants?.find(v => v.id === +value) || null
      }
      if (!variant && window.pdp.ophSplitArchitecture && window.pdp.ophSplitPlProduct) {
        variant = window.pdp.ophSplitPlProduct.variants?.find(v => v.id === +value) || null
      }
      if (variant) {
        setState['selectedVariant'](variant)
      } else {
        setState['selectedVariant'](null)
      }
    }
  })

  function toTitleCase(str) {
    return str.split(' ').map(word => 
      word.charAt(0).toUpperCase() + word.slice(1).toLowerCase()
    ).join(' ');
  }

  function renderWishlistButton() {
    const atcs = document.querySelectorAll('.product__information_block.atc')
    atcs.forEach((atc) => {
      const productId = atc.getAttribute('product_id')
      atc.setAttribute('data-product-id', productId)

      // Monitor to check if WishlistKing is available
      const wishlistCheckInterval = setInterval(() => {
        if (typeof WishlistKing !== 'undefined' && WishlistKing.observe) {
          clearInterval(wishlistCheckInterval);
          
          WishlistKing.observe(
            {
              selector: `.product__information_block.atc[data-product-id]`,
            },
            (target) => {
              target.container.querySelector('.to-be-removed')?.remove()
              target.append(
                WishlistKing.createComponent("wishlist-button-floating-pdp", {
                  id: target.container.getAttribute("data-product-id"),
                })
              );
            }
          );

          window.pdp.wishlistButtonInited = true
        }
      }, 100);

      // Stop checking after 10 seconds
      setTimeout(() => {
        clearInterval(wishlistCheckInterval);
      }, 10000);
    })
  }

  function visibleFitGuideZoomLink() {
    const root = document.getElementById('frame-details-fit-guide')
    if (!root) return null
    return Array.from(root.querySelectorAll('a.fit-guide-zoom')).find((a) => {
      const cs = window.getComputedStyle(a)
      return cs.display !== 'none' && cs.visibility !== 'hidden'
    }) || null
  }

  let nvzModalLastFocus = null
  function openNvzModal(id) {
    const m = document.getElementById(id)
    if (!m) return
    nvzModalLastFocus = document.activeElement
    m.hidden = false
    m.classList.add('is-open')
    document.body.classList.add('nvz-locked')
    const x = m.querySelector('.nvz-modal__x')
    if (x) x.focus()
  }
  function closeNvzModals() {
    document.querySelectorAll('.nvz-modal.is-open').forEach((m) => {
      m.classList.remove('is-open')
      m.hidden = true
    })
    document.body.classList.remove('nvz-locked')
    if (nvzModalLastFocus) nvzModalLastFocus.focus()
  }
  document.addEventListener('keydown', (ev) => {
    if (ev.key !== 'Escape') return
    if (!document.querySelector('.nvz-modal.is-open')) return
    closeNvzModals()
  })

  function retargetPdpSizeFitLinks() {
    document.querySelectorAll('.pdp-size-selector__help a').forEach((a) => {
      a.removeAttribute('data-safety-open')
      a.removeAttribute('data-pdp-open-fit-guide')
      a.setAttribute('data-pdp-open-fit-modal', '')
      a.setAttribute('href', '#pdp-fit-modal')
    })
  }

  function openPdpFitModal(event) {
    if (event) event.preventDefault()
    closeNvzModals()
    if (window.pdp.fitFamilyPainted) paintPdpFitModal()
    openNvzModal('pdp-fit-modal')
    return true
  }

  retargetPdpSizeFitLinks()

  // adding event listeners to additional blocks
  document.body.addEventListener('click', (event) => {
    const target = event.target
    // product additional information block headers
    if (target.closest('.additional-block-header')) {
      const additionalBlock = target.closest('.additional-block')
      if (additionalBlock) {
        additionalBlock.classList.toggle('active')
      }
    }

    const fitLink = target.closest('.pdp-size-selector__help a, [data-pdp-open-fit-modal]')
    if (fitLink) {
      openPdpFitModal(event)
      return
    }
    if (target.closest('[data-pdp-fit-close]')) {
      closeNvzModals()
      return
    }

    // rx toggles
    if (target.closest('.rx-toggle-lab-link')) return
    if (target.closest('.rx-toggle-action')) {
      const rxToggle = target.closest('.rx-toggle')
      if (!rxToggle || rxToggle.classList.contains('is-busy') || isPdpProductSwitchBusy()) return
      if (rxToggle.classList.contains('rx')) {
        if (!beginPdpProductSwitch('rx', 'sunglasses')) return
        updateRxToggleUI(false)
        setState['currentProductType']('sunglasses')
        placeRxToggleForProductType('Sunglasses')
        closeRxConfigModal()
      } else {
        if (!beginPdpProductSwitch('rx', 'prescription')) return
        updateRxToggleUI(true)
        window.pdp._scrollTopAfterRxLoad = true
        setState['currentProductType']('prescription')
        placeRxToggleForProductType('Prescription')
      }
    }

    // atc buttons
    if (target.closest('.atc')) {
      if (target.classList.contains('wk-button') || target.closest('.wk-button')) {
        return
      }

      const atcRoot = target.closest('.atc')
      const isConfigStickyAtc = atcRoot.classList.contains('rx-config-modal__atc')

      // Oph split: if ophthalmic OR BL still in stock → always open configurator
      // (OOS types are grayed inside modal; only fully sold out keeps SOLD OUT on PDP)
      if (
        !isConfigStickyAtc &&
        usesRxConfigModal() &&
        window.isOphthalmicPdpProduct(window.pdp.currentProduct) &&
        window.pdp.ophSplitArchitecture &&
        !isOphSplitFullySoldOut()
      ) {
        const button = atcRoot.querySelector('.atc-button')
        if (!button || button.classList.contains('disabled')) return
        openRxConfigModal()
        return
      }

      // Main PDP ATC: Prescription / Readers / Rx → configurator
      // Known Blue Light / Plain → add sibling variant directly
      if (!isConfigStickyAtc && usesRxConfigModal() && !isOphSimpleAtcType()) {
        const button = atcRoot.querySelector('.atc-button')
        if (!button || button.classList.contains('disabled')) return
        openRxConfigModal()
        return
      }

      if (!isConfigStickyAtc && isOphSimpleAtcType()) {
        if (!window.pdp.rx?.['oph-type']) {
          selectOphTypeFromSplitRole({ force: true })
        }
        ensureOphSimpleSelectedVariant()
      }

      const button = atcRoot.querySelector('.atc-button')
      if (!button) return
      if (button.classList.contains('disabled')) return
      button.innerHTML = '<div class="spinning_circle"></div>'
      button.classList.add('disabled')
      
      let properties = null

      try {
        if (
          window.pdp.currentProduct.product_type === 'Prescription' ||
          (window.isOphthalmicPdpProduct(window.pdp.currentProduct) && (window.pdp.selectedVariant?.title.includes('Prescription') || window.pdp.selectedVariant?.title.includes('Readers')))
        ) {
          const frameTag = normalizeProductTags(window.pdp.currentProduct.tags).find(tag => tag.includes('_frame_name:'))
          const frameColorTag = frameTag ? frameTag.split(':').slice(1).join(':').trim() : ''
          
          if (window.pdp.currentProduct.product_type === 'Prescription') {
            properties = {
              _frame_color: toTitleCase(frameColorTag),
              _prescription_type: window.pdp.selectedVariant?.option1,
              _lens_color: window.pdp.selectedVariant?.option2,
              _lens_upgrades: window.pdp.selectedVariant?.option3,
              _SKU: window.pdp.selectedVariant?.sku,
              _range: '-5:6',
              _barcode: window.pdp.selectedVariant?.barcode,
              _choice: 'SUBMIT LATER',
              _collection: window.pdp.mainCollection
            }
          } else {
            properties = {
              _frame_color: toTitleCase(frameColorTag),
              _prescription_type: window.pdp.selectedVariant?.option2,
              _lens_color: 'Clear',
              _lens_upgrades: window.pdp.selectedVariant?.option3,
              _SKU: window.pdp.selectedVariant?.sku,
              _range: '-5:6',
              ...(window.pdp.selectedVariant?.title.includes('Prescription') ? { _choice: 'SUBMIT LATER' } : {}),
              _barcode: window.pdp.selectedVariant?.barcode,
              _collection: window.pdp.mainCollection
            }
          }
          if (window.pdp.rxConfigLineProperties && typeof window.pdp.rxConfigLineProperties === 'object') {
            properties = Object.assign({}, properties, window.pdp.rxConfigLineProperties)
          }
        }
      } catch (err) {
        console.error('[rx atc] properties failed', err)
        button.classList.remove('disabled')
        if (isConfigStickyAtc && typeof window.clearRxConfigAtcLoading === 'function') {
          window.clearRxConfigAtcLoading('Add to cart')
        }
        updateATCText()
        return
      }

      const restoreAtcLabel = () => {
        const atcButton = atcRoot.querySelector('.atc-button')
        if (atcButton) {
          atcButton.innerHTML = getAddToCartButtonText(window.pdp.selectedVariant, {
            applyRxDiscount: isConfigStickyAtc,
            hidePrice: !isConfigStickyAtc && usesRxConfigModal() && !isOphSimpleAtcType()
          })
          atcButton.classList.remove('disabled')
        }
        if (isConfigStickyAtc && typeof window.clearRxConfigAtcLoading === 'function') {
          window.clearRxConfigAtcLoading('Add to cart')
        }
        updateATCText()
      }

      const onAddSuccess = (res) => {
        const atcButton = atcRoot.querySelector('.atc-button')
        if (atcButton) {
          atcButton.innerHTML = "ADDED"
          atcButton.classList.add('disabled')
        }
        if (isConfigStickyAtc) {
          const continueBtn = document.getElementById('rx-config-continue')
          if (continueBtn) {
            continueBtn.dataset.loading = '0'
            continueBtn.disabled = true
            continueBtn.textContent = 'ADDED'
          }
        }
        $('#shopify-section-cart-drawer .section_holder').html($(res.sections['cart-drawer']).find('.section_holder').html());
        const bubble = new DOMParser().parseFromString(res.sections['header-classic'], 'text/html').querySelector('.header-cart__count').innerHTML;
        document.querySelectorAll('.header-cart__count').forEach((element) => {
          element.innerHTML = bubble;
          if (+bubble > 0) {
            $(element).show();
          } else {
            $(element).hide();
          }
        });
        closeRxConfigModal()
        open_slider_cart();
        window.pdp.rxConfigLineProperties = null
        setTimeout(restoreAtcLabel, 2000)
      }

      if (window.pdp.editMode) {
        fetch('/cart/update.js', {
          body: JSON.stringify({
            updates: {
              [window.pdp.editVariant.id]: 0
            }
          }),
          headers: {
            'Content-Type': 'application/json',
          },
          method: 'POST'
        })
        .then(res => res.json())
        .then(res => {
          fetch('/cart/add.js', {
            body: JSON.stringify({
              items: [{
                'id': window.pdp.selectedVariant?.id,
                'quantity': window.pdp.editVariant.qty,
                ...(properties ? { properties } : {})
              }],
              'sections': ['cart-drawer', 'header-classic']
            }),
            credentials: 'same-origin',
            headers: {
              'Content-Type': 'application/json',
              'X-Requested-With':'xmlhttprequest'
            },
            method: 'POST'
          })
          .then(res => res.json())
          .then(onAddSuccess)
          .catch(restoreAtcLabel)
        })
        .catch(restoreAtcLabel)
      } else {
        fetch('/cart/add.js', {
          body: JSON.stringify({
            items: [{
              'id': window.pdp.selectedVariant?.id,
              'quantity': 1,
              ...(properties ? { properties } : {})
            }],
            'sections': ['cart-drawer', 'header-classic']
          }),
          credentials: 'same-origin',
          headers: {
            'Content-Type': 'application/json',
            'X-Requested-With':'xmlhttprequest'
          },
          method: 'POST'
        })
        .then(res => res.json())
        .then(onAddSuccess)
        .catch(restoreAtcLabel)
      }
    }

    // happy faces grid video item
    if (target.closest('.happy-faces-grid .video-item')) {
      if (target.closest('.happy-faces-grid .video-item').querySelector('.ugc-video').classList.contains('playing')) return
      const allWrappers = document.querySelectorAll('.happy-faces-grid .video-item')
      allWrappers.forEach(wrapper => {
        const video = wrapper.querySelector('.ugc-video')
        const playButton = wrapper.querySelector('.play-button')
        const thumbnail = wrapper.querySelector('.video-thumbnail')
        
        if (video) {
          video.classList.remove('playing')
          video.pause()
        }
        if (playButton) {
          playButton.style.display = 'flex'
        }
        if (thumbnail) {
          thumbnail.style.display = 'block'
        }
      })
      
      const wrap = target.closest('.happy-faces-grid .video-item')
      const video = wrap.querySelector('.ugc-video');
      const thumbnail = wrap.querySelector('.video-thumbnail');
      const playButton = wrap.querySelector('.play-button');
      
      if (video && !video.classList.contains('playing')) {
        video.classList.add('playing');
        video.play();
        if (playButton) playButton.style.display = 'none';
        if (thumbnail) thumbnail.style.display = 'none';
      } else if (video && video.classList.contains('playing')) {
        video.pause();
        video.classList.remove('playing');
        if (playButton) playButton.style.display = 'flex';
        if (thumbnail) thumbnail.style.display = 'block';
      }
    }

    // dropdown label click
    if (target.closest('.dropdown-label')) {
      const wrapper = target.closest('.dropdown-wrapper')
      if (wrapper) {
        const panel = wrapper.querySelector('.dropdown-panel')
        const option = wrapper.querySelector('.dropdown-trigger').getAttribute('data-dropdown')
        console.log('option', option)
        // In Rx config modal, panels stay open — no collapse toggle
        if (usesRxConfigModal()) {
          keepRxConfigOptionPanelsOpen()
          return
        }
        if (window.pdp.currentProduct.product_type === 'Prescription') {
          if (option === 'lens-type' && !window.pdp.rx['lens-color']) return
        }
        if (window.isOphthalmicPdpProduct(window.pdp.currentProduct)) {
          if (option === 'lens-type' && !window.pdp.rx['oph-type']) return
        }
        if (option === 'lens-upgrade' && !window.pdp.rx['lens-color']) return
        if (option === 'lens-upgrade' && !window.pdp.rx['lens-type']) return
        if (panel) {
          panel.classList.toggle('disabled')
        }
      }
    }

    // size selector Standard / XL / XXL (in-place swap, same as rx toggle / color swatches)
    const sizeBtn = target.closest('[data-size-selector] .pdp-size-selector__btn')
    if (sizeBtn) {
      const sizeSelector = sizeBtn.closest('[data-size-selector]')
      if (!sizeSelector || sizeSelector.classList.contains('is-busy') || isPdpProductSwitchBusy()) return
      const size = sizeBtn.dataset.size
      const targetHandle =
        size === 'xxl'
          ? sizeSelector.dataset.xxlHandle
          : size === 'xl'
            ? sizeSelector.dataset.xlHandle
            : sizeSelector.dataset.stdHandle
      if (!targetHandle || targetHandle === window.pdp.currentProduct?.handle) return
      switchPdpSizeProduct(targetHandle)
    }
  })

  function handleMainSliderPosition(explicitHandle) {
    const handle =
      explicitHandle ||
      window.pdp._activeMainSliderHandle ||
      window.pdp.currentProductHandle ||
      (typeof getSepDesignActiveSliderHandle === 'function' ? getSepDesignActiveSliderHandle() : null) ||
      window.pdp.currentProduct?.handle
    if (!handle) return

    const currentScreenWidth = window.innerWidth
    const wasMobile = window.pdp.mainSliderPosition.previousScreenWidth < 798
    const isMobile = currentScreenWidth < 798
    const force = explicitHandle != null || window.pdp.mainSliderPosition.isFirstLoad

    if (!force && wasMobile === isMobile) {
      window.pdp.mainSliderPosition.previousScreenWidth = currentScreenWidth
      return
    }

    if (
      window.pdp._activeMainSliderHandle &&
      window.pdp._activeMainSliderHandle !== handle &&
      explicitHandle == null
    ) {
      window.pdp.mainSliderPosition.previousScreenWidth = currentScreenWidth
      return
    }

    if (
      !window.pdp.swipers ||
      !window.pdp.swipers[handle] ||
      !window.pdp.swipers[handle].swiper ||
      !window.pdp.swipers[handle].thumbSwiper
    ) {
      window.pdp.mainSliderPosition.previousScreenWidth = currentScreenWidth
      return
    }

    const mainSliderWrapper = window.pdp.swipers[handle].swiper.el.closest('.mainslider-wrapper')
    const productMain = document.querySelector('.product__main')
    const mainslider =
      getMainSliderRootForHandle(handle) ||
      window.pdp.swipers[handle].thumbSwiper.el.closest('.product__sep-design__mainSlider')

    if (!mainSliderWrapper || !productMain || !mainslider) {
      window.pdp.mainSliderPosition.previousScreenWidth = currentScreenWidth
      return
    }

    if (mainslider.classList.contains('hidden')) {
      restoreMainSliderWrapperIntoRoot(handle, mainslider)
      window.pdp.mainSliderPosition.previousScreenWidth = currentScreenWidth
      return
    }

    if (isMobile) {
      // Hoist gallery above info for mobile layout, but do not pin sticky on scroll
      if (mainSliderWrapper.parentNode !== productMain) {
        productMain.insertBefore(mainSliderWrapper, productMain.firstChild)
      }
      mainSliderWrapper.classList.remove('sticky', 'floating')
      removeOrphanedMainSliderWrappers(mainSliderWrapper)
      if (typeof updatePriceBlockStickyTop === 'function') updatePriceBlockStickyTop()
    } else {
      restoreMainSliderWrapperIntoRoot(handle, mainslider)
      removeOrphanedMainSliderWrappers(null)
    }

    window.pdp.mainSliderPosition.isFirstLoad = false
    window.pdp.mainSliderPosition.previousScreenWidth = currentScreenWidth
  }

  let priceBlockStickyRo = null
  let priceBlockStickyObservedEl = null

  function teardownPriceBlockStickyObserver() {
    if (priceBlockStickyRo) {
      priceBlockStickyRo.disconnect()
      priceBlockStickyRo = null
      priceBlockStickyObservedEl = null
    }
  }

  function ensurePriceBlockStickyObserver(el) {
    if (typeof ResizeObserver === 'undefined') return
    if (el === priceBlockStickyObservedEl && priceBlockStickyRo) return
    teardownPriceBlockStickyObserver()
    if (!el) return
    priceBlockStickyRo = new ResizeObserver(() => updatePriceBlockStickyTop())
    priceBlockStickyObservedEl = el
    priceBlockStickyRo.observe(el)
  }

  // Mobile: border only while position:sticky is actively pinned (matches resolved `top`)
  function updatePriceBlockStuckState() {
    const el = document.querySelector('.product__information > .pdp-lead .product__information_block.price-block')
      || document.querySelector('.product__information .product__information_block.price-block')
    if (!el) return
    if (window.innerWidth >= 798) {
      el.classList.remove('is-stuck')
      return
    }
    if (getComputedStyle(el).position !== 'sticky') {
      el.classList.remove('is-stuck')
      return
    }
    const stickyTop = parseFloat(getComputedStyle(el).top)
    if (!Number.isFinite(stickyTop)) {
      el.classList.remove('is-stuck')
      return
    }
    const rect = el.getBoundingClientRect()
    const tol = 3
    const isStuck = rect.top <= stickyTop + tol && rect.top >= stickyTop - tol
    el.classList.toggle('is-stuck', isStuck)
  }

  // Mobile: sticky price row sits below header (93px) + visible sticky mainslider height (.floating changes box size)
  function updatePriceBlockStickyTop() {
    const productMain = document.querySelector('.product__main')
    if (!productMain) {
      updatePriceBlockStuckState()
      return
    }
    if (window.innerWidth >= 798) {
      productMain.style.removeProperty('--pdp-sticky-slider-height')
      teardownPriceBlockStickyObserver()
      updatePriceBlockStuckState()
      return
    }
    const slider = document.querySelector('.product__main .mainslider-wrapper.sticky')
    if (!slider) {
      productMain.style.removeProperty('--pdp-sticky-slider-height')
      teardownPriceBlockStickyObserver()
      updatePriceBlockStuckState()
      return
    }
    productMain.style.setProperty('--pdp-sticky-slider-height', `${slider.offsetHeight}px`)
    ensurePriceBlockStickyObserver(slider)
    updatePriceBlockStuckState()
  }

  function adjustSliderWidth() {
    if (!window.pdp.swipers) return
    Object.keys(window.pdp.swipers).forEach(handle => {
      const entry = window.pdp.swipers[handle]
      if (isOtherProductsSwiperEntry(entry)) return
      const swiper = entry?.swiper
      const thumbSwiper = entry?.thumbSwiper
      const root = getMainSliderRootForHandle(handle)
      // Skip hidden product galleries — measuring display:none zeros Swiper and breaks reveal
      if (root && root.classList.contains('hidden')) return
      let swiperToChange
      if (swiper && !thumbSwiper) {
        swiperToChange = swiper
      } else {
        swiperToChange = thumbSwiper
      }
      if (!swiperToChange?.el || !swiperToChange.slides) return
      const totalSlides = swiperToChange.slides.length
      const slidesPerView = swiperToChange.params.slidesPerView
      if (totalSlides <= slidesPerView) {
        swiperToChange.el.style.width = '100%'
      } else {
        swiperToChange.el.removeAttribute('style')
      }
    })
  }

  // Toggle floating class from scroll position (border styled in CSS)
  function updateStickyBorder() {
    const sliderHandle =
      window.pdp._activeMainSliderHandle ||
      window.pdp.currentProductHandle ||
      getSepDesignActiveSliderHandle()
    const mainSliderWrapper = sliderHandle && swiperClosest(window.pdp.swipers[sliderHandle]?.swiper, '.mainslider-wrapper')
    if (!mainSliderWrapper) {
      updatePriceBlockStickyTop()
      return
    }
    
    const isSticky = mainSliderWrapper.classList.contains('sticky')
    if (!isSticky) {
      mainSliderWrapper.classList.remove('floating')
      updatePriceBlockStickyTop()
      return
    }
    
    if (window.pageYOffset > 0) {
      mainSliderWrapper.classList.add('floating')
    } else {
      mainSliderWrapper.classList.remove('floating')
    }
    updatePriceBlockStickyTop()
  }

  // Track previous values to avoid unnecessary updates
  let previousSelectedVariantId = null
  let previousCurrentProductHandle = null
  
  setInterval(() => {
    const currentVariantId = window.pdp.selectedVariant?.id
    const currentProductHandle = window.pdp.currentProduct?.handle
    
    // Early return if nothing changed
    if (currentVariantId === previousSelectedVariantId && 
        currentProductHandle === previousCurrentProductHandle) {
      return
    }
    
    // Update tracked values
    previousSelectedVariantId = currentVariantId
    previousCurrentProductHandle = currentProductHandle
    
    updateATCText()
  }, 100)

  placeRxToggleForProductType(window.SEP_DESIGN_OPH.productType);

  (() => {
    const productInformation = document.querySelector(window.SEP_DESIGN_OPH.sectionRoot + ' .product__information')
    const title = productInformation?.querySelector(':scope > .product__information_block.title')
    const reviews = productInformation?.querySelector(':scope > .product__information_block.judgeme-badge')
    const price = productInformation?.querySelector(':scope > .product__information_block.price-block')
    if (!productInformation || !title || !reviews || !price) return

    // Seed landing badge so RX/XL round-trips keep correct counts
    const landingHandle = window.SEP_DESIGN_OPH?.productHandle
    if (landingHandle && !hasJudgemeHtmlCache(landingHandle)) {
      if (!window.pdp.judgemeHtmls) window.pdp.judgemeHtmls = {}
      window.pdp.judgemeHtmls[landingHandle] = reviews.innerHTML
    }

    const lead = document.createElement('div')
    lead.className = 'pdp-lead'
    productInformation.insertBefore(lead, title)
    lead.append(title, reviews, price)

    const syncGalleryPdpLead = () => {
      const infoLead = document.querySelector(window.SEP_DESIGN_OPH.sectionRoot + ' .product__information > .pdp-lead')
      if (!infoLead) return
      document.querySelectorAll(window.SEP_DESIGN_OPH.sectionRoot + ' .mainslider-wrapper').forEach((wrapper) => {
        let galleryLead = wrapper.querySelector(':scope > .pdp-lead')
        if (!galleryLead) {
          galleryLead = infoLead.cloneNode(true)
          galleryLead.classList.add('pdp-lead--gallery')
          galleryLead.setAttribute('aria-hidden', 'true')
          wrapper.insertBefore(galleryLead, wrapper.firstChild)
        } else {
          galleryLead.innerHTML = infoLead.innerHTML
        }
      })
    }

    window.syncGalleryPdpLead = syncGalleryPdpLead
    syncGalleryPdpLead()

    const mo = new MutationObserver(() => syncGalleryPdpLead())
    mo.observe(lead, { childList: true, subtree: true, characterData: true })
  })()

  if (typeof window.mountRxConfigModal === 'function') {
    window.mountRxConfigModal()
  }

  // Check if WishlistKing is defined before running
  const wishlistCheckInterval = setInterval(() => {
    if (typeof WishlistKing !== 'undefined') {
      console.log('WishlistKing is now defined!', WishlistKing);
      clearInterval(wishlistCheckInterval);
      
      // Run the function once WishlistKing is available
      renderWishlistButton();
    }
  }, 100); // Check every 100ms
  
  // Stop checking after 10 seconds
  setTimeout(() => {
    clearInterval(wishlistCheckInterval);
    console.log('Stopped checking for WishlistKing');
  }, 10000);

initPdpMobileStickyAtc();

